var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 345,
    viewBox: "0 0 603 345",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 173.787H297.068L295.569 171.191L297.068 168.6H300.065L301.564 171.191L300.065 173.787Z",
    fill: "#DADADA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 177.033H291.442L289.943 174.437L291.442 171.841H294.444L295.943 174.437L294.444 177.033Z",
    fill: "#DADADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 180.274H297.068L295.569 177.679L297.068 175.087H300.065L301.564 177.679L300.065 180.274Z",
    fill: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 177.033H302.688L301.189 174.437L302.688 171.841H305.686L307.184 174.437L305.686 177.033Z",
    fill: "#DADADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 170.546H302.688L301.189 167.95L302.688 165.354H305.686L307.184 167.95L305.686 170.546Z",
    fill: "#DADADA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 167.3H297.068L295.569 164.705L297.068 162.113H300.065L301.564 164.705L300.065 167.3Z",
    fill: "#DADADA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 170.546H291.442L289.943 167.95L291.442 165.354H294.444L295.943 167.95L294.444 170.546Z",
    fill: "#DADADA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 180.274H285.821L284.322 177.679L285.821 175.087H288.818L290.317 177.679L288.818 180.274Z",
    fill: "#DADADA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 183.518H291.442L289.943 180.923L291.442 178.327H294.444L295.943 180.923L294.444 183.518Z",
    fill: "#DADADA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 186.761H297.068L295.569 184.17L297.068 181.574H300.065L301.564 184.17L300.065 186.761Z",
    fill: "#DADADA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 183.518H302.688L301.189 180.923L302.688 178.327H305.686L307.184 180.923L305.686 183.518Z",
    fill: "#DADADA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 180.274H308.309L306.811 177.679L308.309 175.087H311.307L312.806 177.679L311.307 180.274Z",
    fill: "#DADADA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 173.787H308.309L306.811 171.191L308.309 168.6H311.307L312.806 171.191L311.307 173.787Z",
    fill: "#DADADA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 167.3H308.309L306.811 164.705L308.309 162.113H311.307L312.806 164.705L311.307 167.3Z",
    fill: "#DADADA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 164.059H302.688L301.189 161.464L302.688 158.868H305.686L307.184 161.464L305.686 164.059Z",
    fill: "#DADADA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 160.813H297.068L295.569 158.218L297.068 155.622H300.065L301.564 158.218L300.065 160.813Z",
    fill: "#DADADA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 164.059H291.442L289.943 161.464L291.442 158.868H294.444L295.943 161.464L294.444 164.059Z",
    fill: "#DADADA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 173.787H285.821L284.322 171.191L285.821 168.6H288.818L290.317 171.191L288.818 173.787Z",
    fill: "#DADADA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 183.518H280.201L278.702 180.923L280.201 178.327H283.198L284.697 180.923L283.198 183.518Z",
    fill: "#DADADA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 186.761H285.821L284.322 184.17L285.821 181.574H288.818L290.317 184.17L288.818 186.761Z",
    fill: "#DADADA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 190.007H302.688L301.189 187.411L302.688 184.815H305.686L307.184 187.411L305.686 190.007Z",
    fill: "#DADADA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 186.761H308.309L306.811 184.17L308.309 181.574H311.307L312.806 184.17L311.307 186.761Z",
    fill: "#DADADA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 183.518H313.929L312.431 180.923L313.929 178.327H316.927L318.426 180.923L316.927 183.518Z",
    fill: "#DADADA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 177.033H313.929L312.431 174.437L313.929 171.841H316.927L318.426 174.437L316.927 177.033Z",
    fill: "#DADADA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 170.546H313.929L312.431 167.95L313.929 165.354H316.927L318.426 167.95L316.927 170.546Z",
    fill: "#DADADA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 164.059H313.929L312.431 161.464L313.929 158.868H316.927L318.426 161.464L316.927 164.059Z",
    fill: "#DADADA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 160.813H308.309L306.811 158.218L308.309 155.622H311.307L312.806 158.218L311.307 160.813Z",
    fill: "#DADADA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 157.572H302.688L301.189 154.976L302.688 152.38H305.686L307.184 154.976L305.686 157.572Z",
    fill: "#DADADA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 154.326H297.068L295.569 151.73L297.068 149.135H300.065L301.564 151.73L300.065 154.326Z",
    fill: "#DADADA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 157.572H291.442L289.943 154.976L291.442 152.38H294.444L295.943 154.976L294.444 157.572Z",
    fill: "#DADADA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 160.813H285.821L284.322 158.218L285.821 155.622H288.818L290.317 158.218L288.818 160.813Z",
    fill: "#DADADA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 164.059H280.201L278.702 161.464L280.201 158.868H283.198L284.697 161.464L283.198 164.059Z",
    fill: "#DADADA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 170.546H280.201L278.702 167.95L280.201 165.354H283.198L284.697 167.95L283.198 170.546Z",
    fill: "#DADADA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 177.033H280.201L278.702 174.437L280.201 171.841H283.198L284.697 174.437L283.198 177.033Z",
    fill: "#DADADA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 186.761H274.58L273.082 184.17L274.58 181.574H277.578L279.076 184.17L277.578 186.761Z",
    fill: "#DADADA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 190.007H280.201L278.702 187.411L280.201 184.815H283.198L284.697 187.411L283.198 190.007Z",
    fill: "#DADADA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 199.74H297.068L295.569 197.144L297.068 194.548H300.065L301.564 197.144L300.065 199.74Z",
    fill: "#DADADA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 196.494H302.688L301.189 193.898L302.688 191.303H305.686L307.184 193.898L305.686 196.494Z",
    fill: "#DADADA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 193.248H308.309L306.811 190.656L308.309 188.061H311.307L312.806 190.656L311.307 193.248Z",
    fill: "#DADADA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 190.007H313.929L312.431 187.411L313.929 184.815H316.927L318.426 187.411L316.927 190.007Z",
    fill: "#DADADA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 186.761H319.55L318.052 184.17L319.55 181.574H322.552L324.051 184.17L322.552 186.761Z",
    fill: "#DADADA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 180.274H319.55L318.052 177.679L319.55 175.087H322.552L324.051 177.679L322.552 180.274Z",
    fill: "#DADADA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 173.787H319.55L318.052 171.191L319.55 168.6H322.552L324.051 171.191L322.552 173.787Z",
    fill: "#DADADA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 167.3H319.55L318.052 164.705L319.55 162.113H322.552L324.051 164.705L322.552 167.3Z",
    fill: "#DADADA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 160.813H319.55L318.052 158.218L319.55 155.622H322.552L324.051 158.218L322.552 160.813Z",
    fill: "#DADADA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 157.572H313.929L312.431 154.976L313.929 152.38H316.927L318.426 154.976L316.927 157.572Z",
    fill: "#DADADA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M311.303 154.317H308.314L306.824 151.73L308.314 149.147H311.303L312.797 151.73L311.303 154.317Z",
    fill: "#DADADA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M305.656 151.034H302.719L301.246 148.49L302.719 145.946H305.656L307.125 148.49L305.656 151.034Z",
    fill: "#DADADA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 147.839H297.068L295.569 145.244L297.068 142.648H300.065L301.564 145.244L300.065 147.839Z",
    fill: "#DADADA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 151.085H291.442L289.943 148.489L291.442 145.894H294.444L295.943 148.489L294.444 151.085Z",
    fill: "#DADADA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 154.326H285.821L284.322 151.73L285.821 149.135H288.818L290.317 151.73L288.818 154.326Z",
    fill: "#DADADA"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 157.572H280.201L278.702 154.976L280.201 152.38H283.198L284.697 154.976L283.198 157.572Z",
    fill: "#DADADA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 160.813H274.58L273.082 158.218L274.58 155.622H277.578L279.076 158.218L277.578 160.813Z",
    fill: "#DADADA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 167.3H274.58L273.082 164.705L274.58 162.113H277.578L279.076 164.705L277.578 167.3Z",
    fill: "#DADADA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 173.787H274.58L273.082 171.191L274.58 168.6H277.578L279.076 171.191L277.578 173.787Z",
    fill: "#DADADA"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 180.274H274.58L273.082 177.679L274.58 175.087H277.578L279.076 177.679L277.578 180.274Z",
    fill: "#DADADA"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 190.007H268.96L267.461 187.411L268.96 184.815H271.957L273.456 187.411L271.957 190.007Z",
    fill: "#DADADA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 193.248H274.58L273.082 190.656L274.58 188.061H277.578L279.076 190.656L277.578 193.248Z",
    fill: "#DADADA"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 199.74H285.821L284.322 197.144L285.821 194.548H288.818L290.317 197.144L288.818 199.74Z",
    fill: "#DADADA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 206.226H297.068L295.569 203.63L297.068 201.035H300.065L301.564 203.63L300.065 206.226Z",
    fill: "#DADADA"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 202.98H302.688L301.189 200.385L302.688 197.793H305.686L307.184 200.385L305.686 202.98Z",
    fill: "#DADADA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 199.74H308.309L306.811 197.144L308.309 194.548H311.307L312.806 197.144L311.307 199.74Z",
    fill: "#DADADA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 196.494H313.929L312.431 193.898L313.929 191.303H316.927L318.426 193.898L316.927 196.494Z",
    fill: "#DADADA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 193.248H319.55L318.052 190.656L319.55 188.061H322.552L324.051 190.656L322.552 193.248Z",
    fill: "#DADADA"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 190.007H325.176L323.678 187.411L325.176 184.815H328.174L329.673 187.411L328.174 190.007Z",
    fill: "#DADADA"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 183.518H325.176L323.678 180.923L325.176 178.327H328.174L329.673 180.923L328.174 183.518Z",
    fill: "#DADADA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 177.033H325.176L323.678 174.437L325.176 171.841H328.174L329.673 174.437L328.174 177.033Z",
    fill: "#DADADA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 170.546H325.176L323.678 167.95L325.176 165.354H328.174L329.673 167.95L328.174 170.546Z",
    fill: "#DADADA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 164.059H325.176L323.678 161.464L325.176 158.868H328.174L329.673 161.464L328.174 164.059Z",
    fill: "#DADADA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 157.572H325.176L323.678 154.976L325.176 152.38H328.174L329.673 154.976L328.174 157.572Z",
    fill: "#DADADA"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M322.411 154.08H319.694L318.337 151.73L319.694 149.38H322.411L323.768 151.73L322.411 154.08Z",
    fill: "#DADADA"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M304.609 142.734H303.765L303.339 142.002L303.765 141.266H304.609L305.036 142.002L304.609 142.734Z",
    fill: "#DADADA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M299.488 140.354H297.641L296.719 138.757L297.641 137.16H299.488L300.41 138.757L299.488 140.354Z",
    fill: "#DADADA"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M294.384 144.495H291.503L290.064 142.003L291.503 139.506H294.384L295.823 142.003L294.384 144.495Z",
    fill: "#DADADA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 147.839H285.821L284.322 145.244L285.821 142.648H288.818L290.317 145.244L288.818 147.839Z",
    fill: "#DADADA"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 151.085H280.201L278.702 148.489L280.201 145.894H283.198L284.697 148.489L283.198 151.085Z",
    fill: "#DADADA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 154.326H274.58L273.082 151.73L274.58 149.135H277.578L279.076 151.73L277.578 154.326Z",
    fill: "#DADADA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 157.572H268.96L267.461 154.976L268.96 152.38H271.957L273.456 154.976L271.957 157.572Z",
    fill: "#DADADA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 164.059H268.96L267.461 161.464L268.96 158.868H271.957L273.456 161.464L271.957 164.059Z",
    fill: "#DADADA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 170.546H268.96L267.461 167.95L268.96 165.354H271.957L273.456 167.95L271.957 170.546Z",
    fill: "#DADADA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 177.033H268.96L267.461 174.437L268.96 171.841H271.957L273.456 174.437L271.957 177.033Z",
    fill: "#DADADA"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 183.518H268.96L267.461 180.923L268.96 178.327H271.957L273.456 180.923L271.957 183.518Z",
    fill: "#DADADA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 193.248H263.338L261.839 190.656L263.338 188.061H266.336L267.834 190.656L266.336 193.248Z",
    fill: "#DADADA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 196.494H268.96L267.461 193.898L268.96 191.303H271.957L273.456 193.898L271.957 196.494Z",
    fill: "#DADADA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 199.74H274.58L273.082 197.144L274.58 194.548H277.578L279.076 197.144L277.578 199.74Z",
    fill: "#DADADA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M299.26 211.318H297.874L297.18 210.117L297.874 208.916H299.26L299.954 210.117L299.26 211.318Z",
    fill: "#DADADA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 209.468H302.688L301.189 206.872L302.688 204.281H305.686L307.184 206.872L305.686 209.468Z",
    fill: "#DADADA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 206.226H308.309L306.811 203.63L308.309 201.035H311.307L312.806 203.63L311.307 206.226Z",
    fill: "#DADADA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 202.98H313.929L312.431 200.385L313.929 197.793H316.927L318.426 200.385L316.927 202.98Z",
    fill: "#DADADA"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 199.74H319.55L318.052 197.144L319.55 194.548H322.552L324.051 197.144L322.552 199.74Z",
    fill: "#DADADA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 196.494H325.176L323.678 193.898L325.176 191.303H328.174L329.673 193.898L328.174 196.494Z",
    fill: "#DADADA"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 193.248H330.797L329.298 190.656L330.797 188.061H333.795L335.293 190.656L333.795 193.248Z",
    fill: "#DADADA"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 186.761H330.797L329.298 184.17L330.797 181.574H333.795L335.293 184.17L333.795 186.761Z",
    fill: "#DADADA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 180.274H330.797L329.298 177.679L330.797 175.087H333.795L335.293 177.679L333.795 180.274Z",
    fill: "#DADADA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 173.787H330.797L329.298 171.191L330.797 168.6H333.795L335.293 171.191L333.795 173.787Z",
    fill: "#DADADA"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 167.3H330.797L329.298 164.705L330.797 162.113H333.795L335.293 164.705L333.795 167.3Z",
    fill: "#DADADA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 160.813H330.797L329.298 158.218L330.797 155.622H333.795L335.293 158.218L333.795 160.813Z",
    fill: "#DADADA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M333.721 154.205H330.866L329.436 151.73L330.866 149.259H333.721L335.151 151.73L333.721 154.205Z",
    fill: "#DADADA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M327.355 149.669H325.99L325.31 148.489L325.99 147.306H327.355L328.036 148.489L327.355 149.669Z",
    fill: "#DADADA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M310.209 139.45H309.408L309.007 138.757L309.408 138.063H310.209L310.609 138.757L310.209 139.45Z",
    fill: "#DADADA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M299.386 133.682H297.749L296.931 132.27L297.749 130.854H299.386L300.199 132.27L299.386 133.682Z",
    fill: "#DADADA"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M282.922 144.116H280.476L279.253 142.002L280.476 139.884H282.922L284.145 142.002L282.922 144.116Z",
    fill: "#DADADA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M277.56 147.809H274.597L273.115 145.243L274.597 142.678H277.56L279.041 145.243L277.56 147.809Z",
    fill: "#DADADA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 151.085H268.96L267.461 148.489L268.96 145.894H271.957L273.456 148.489L271.957 151.085Z",
    fill: "#DADADA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M265.729 153.276H263.941L263.05 151.73L263.941 150.185H265.729L266.624 151.73L265.729 153.276Z",
    fill: "#DADADA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M266.292 160.745H263.377L261.921 158.218L263.377 155.695H266.292L267.752 158.218L266.292 160.745Z",
    fill: "#DADADA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 167.3H263.338L261.839 164.705L263.338 162.113H266.336L267.834 164.705L266.336 167.3Z",
    fill: "#DADADA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 173.787H263.338L261.839 171.191L263.338 168.6H266.336L267.834 171.191L266.336 173.787Z",
    fill: "#DADADA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 180.274H263.338L261.839 177.679L263.338 175.087H266.336L267.834 177.679L266.336 180.274Z",
    fill: "#DADADA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 186.761H263.338L261.839 184.17L263.338 181.574H266.336L267.834 184.17L266.336 186.761Z",
    fill: "#DADADA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M260.714 196.494H257.717L256.218 193.898L257.717 191.303H260.714L262.213 193.898L260.714 196.494Z",
    fill: "#DADADA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 199.74H263.338L261.839 197.144L263.338 194.548H266.336L267.834 197.144L266.336 199.74Z",
    fill: "#DADADA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 202.98H268.96L267.461 200.385L268.96 197.793H271.957L273.456 200.385L271.957 202.98Z",
    fill: "#DADADA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 206.226H274.58L273.082 203.63L274.58 201.035H277.578L279.076 203.63L277.578 206.226Z",
    fill: "#DADADA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M287.751 210.863H286.894L286.463 210.118L286.894 209.374H287.751L288.181 210.118L287.751 210.863Z",
    fill: "#DADADA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M299.118 217.559H298.011L297.459 216.604L298.011 215.648H299.118L299.669 216.604L299.118 217.559Z",
    fill: "#DADADA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 215.954H302.688L301.189 213.358L302.688 210.767H305.686L307.184 213.358L305.686 215.954Z",
    fill: "#DADADA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 212.713H308.309L306.811 210.118L308.309 207.522H311.307L312.806 210.118L311.307 212.713Z",
    fill: "#DADADA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 209.468H313.929L312.431 206.872L313.929 204.281H316.927L318.426 206.872L316.927 209.468Z",
    fill: "#DADADA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 206.226H319.55L318.052 203.63L319.55 201.035H322.552L324.051 203.63L322.552 206.226Z",
    fill: "#DADADA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 202.98H325.176L323.678 200.385L325.176 197.793H328.174L329.673 200.385L328.174 202.98Z",
    fill: "#DADADA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 199.74H330.797L329.298 197.144L330.797 194.548H333.795L335.293 197.144L333.795 199.74Z",
    fill: "#DADADA"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 196.494H336.417L334.918 193.898L336.417 191.303H339.415L340.913 193.898L339.415 196.494Z",
    fill: "#DADADA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 190.007H336.417L334.918 187.411L336.417 184.815H339.415L340.913 187.411L339.415 190.007Z",
    fill: "#DADADA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 183.518H336.417L334.918 180.923L336.417 178.327H339.415L340.913 180.923L339.415 183.518Z",
    fill: "#DADADA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 177.033H336.417L334.918 174.437L336.417 171.841H339.415L340.913 174.437L339.415 177.033Z",
    fill: "#DADADA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 170.546H336.417L334.918 167.95L336.417 165.354H339.415L340.913 167.95L339.415 170.546Z",
    fill: "#DADADA"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 164.059H336.417L334.918 161.464L336.417 158.868H339.415L340.913 161.464L339.415 164.059Z",
    fill: "#DADADA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 157.572H336.417L334.918 154.976L336.417 152.38H339.415L340.913 154.976L339.415 157.572Z",
    fill: "#DADADA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M327.614 143.629H325.732L324.793 142.002L325.732 140.37H327.614L328.553 142.002L327.614 143.629Z",
    fill: "#DADADA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M321.976 140.354H320.128L319.207 138.757L320.128 137.16H321.976L322.897 138.757L321.976 140.354Z",
    fill: "#DADADA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M310.269 133.061H309.351L308.891 132.269L309.351 131.477H310.269L310.725 132.269L310.269 133.061Z",
    fill: "#DADADA"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M304.622 129.777H303.752L303.317 129.024L303.752 128.271H304.622L305.057 129.024L304.622 129.777Z",
    fill: "#DADADA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M299.635 127.634H297.494L296.426 125.783L297.494 123.932H299.635L300.707 125.783L299.635 127.634Z",
    fill: "#DADADA"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M283.103 137.943H280.295L278.891 135.511L280.295 133.083H283.103L284.511 135.511L283.103 137.943Z",
    fill: "#DADADA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M277.221 140.733H274.938L273.797 138.757L274.938 136.781H277.221L278.362 138.757L277.221 140.733Z",
    fill: "#DADADA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M270.75 142.511H270.164L269.867 142.003L270.164 141.49H270.75L271.043 142.003L270.75 142.511Z",
    fill: "#DADADA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M260.056 162.919H258.373L257.533 161.464L258.373 160.009H260.056L260.896 161.464L260.056 162.919Z",
    fill: "#DADADA"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M260.714 170.546H257.717L256.218 167.95L257.717 165.354H260.714L262.213 167.95L260.714 170.546Z",
    fill: "#DADADA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M260.714 177.033H257.717L256.218 174.437L257.717 171.841H260.714L262.213 174.437L260.714 177.033Z",
    fill: "#DADADA"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M260.714 183.518H257.717L256.218 180.923L257.717 178.327H260.714L262.213 180.923L260.714 183.518Z",
    fill: "#DADADA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M260.714 190.007H257.717L256.218 187.411L257.717 184.815H260.714L262.213 187.411L260.714 190.007Z",
    fill: "#DADADA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M253.889 197.652H253.299L253.006 197.144L253.299 196.636H253.889L254.182 197.144L253.889 197.652Z",
    fill: "#DADADA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M260.69 202.942H257.739L256.262 200.385L257.739 197.833H260.69L262.167 200.385L260.69 202.942Z",
    fill: "#DADADA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M266.336 206.226H263.338L261.839 203.63L263.338 201.035H266.336L267.834 203.63L266.336 206.226Z",
    fill: "#DADADA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 209.468H268.96L267.461 206.872L268.96 204.281H271.957L273.456 206.872L271.957 209.468Z",
    fill: "#DADADA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M277.121 211.916H275.041L273.999 210.117L275.041 208.318H277.121L278.159 210.117L277.121 211.916Z",
    fill: "#DADADA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M299.811 225.248H297.317L296.072 223.091L297.317 220.935H299.811L301.059 223.091L299.811 225.248Z",
    fill: "#DADADA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 222.441H302.688L301.189 219.85L302.688 217.254H305.686L307.184 219.85L305.686 222.441Z",
    fill: "#DADADA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 219.2H308.309L306.811 216.604L308.309 214.009H311.307L312.806 216.604L311.307 219.2Z",
    fill: "#DADADA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 215.954H313.929L312.431 213.358L313.929 210.767H316.927L318.426 213.358L316.927 215.954Z",
    fill: "#DADADA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 212.713H319.55L318.052 210.118L319.55 207.522H322.552L324.051 210.118L322.552 212.713Z",
    fill: "#DADADA"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 209.468H325.176L323.678 206.872L325.176 204.281H328.174L329.673 206.872L328.174 209.468Z",
    fill: "#DADADA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 206.226H330.797L329.298 203.63L330.797 201.035H333.795L335.293 203.63L333.795 206.226Z",
    fill: "#DADADA"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 202.98H336.417L334.918 200.385L336.417 197.793H339.415L340.913 200.385L339.415 202.98Z",
    fill: "#DADADA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 199.74H342.038L340.54 197.144L342.038 194.548H345.036L346.535 197.144L345.036 199.74Z",
    fill: "#DADADA"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 193.248H342.038L340.54 190.656L342.038 188.061H345.036L346.535 190.656L345.036 193.248Z",
    fill: "#DADADA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 186.761H342.038L340.54 184.17L342.038 181.574H345.036L346.535 184.17L345.036 186.761Z",
    fill: "#DADADA"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 180.274H342.038L340.54 177.679L342.038 175.087H345.036L346.535 177.679L345.036 180.274Z",
    fill: "#DADADA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 173.787H342.038L340.54 171.191L342.038 168.6H345.036L346.535 171.191L345.036 173.787Z",
    fill: "#DADADA"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 167.3H342.038L340.54 164.705L342.038 162.113H345.036L346.535 164.705L345.036 167.3Z",
    fill: "#DADADA"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 160.813H342.038L340.54 158.218L342.038 155.622H345.036L346.535 158.218L345.036 160.813Z",
    fill: "#DADADA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M344.588 153.551H342.486L341.436 151.73L342.486 149.91H344.588L345.643 151.73L344.588 153.551Z",
    fill: "#DADADA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M343.783 145.67H343.292L343.046 145.244L343.292 144.817H343.783L344.033 145.244L343.783 145.67Z",
    fill: "#DADADA"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M338.701 143.354H337.133L336.354 142.002L337.133 140.646H338.701L339.48 142.002L338.701 143.354Z",
    fill: "#DADADA"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M333.716 141.219H330.874L329.448 138.757L330.874 136.294H333.716L335.137 138.757L333.716 141.219Z",
    fill: "#DADADA"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M327.213 136.45H326.132L325.589 135.511L326.132 134.577H327.213L327.755 135.511L327.213 136.45Z",
    fill: "#DADADA"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M322.505 134.784H319.598L318.146 132.27L319.598 129.756H322.505L323.956 132.27L322.505 134.784Z",
    fill: "#DADADA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M316.312 130.552H314.546L313.667 129.024L314.546 127.5H316.312L317.195 129.024L316.312 130.552Z",
    fill: "#DADADA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M310.532 127.035H309.085L308.361 125.782L309.085 124.53H310.532L311.255 125.782L310.532 127.035Z",
    fill: "#DADADA"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 125.133H302.688L301.189 122.537L302.688 119.941H305.686L307.184 122.537L305.686 125.133Z",
    fill: "#DADADA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 121.891H297.068L295.569 119.296L297.068 116.7H300.065L301.564 119.296L300.065 121.891Z",
    fill: "#DADADA"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M294.16 124.646H291.726L290.512 122.537L291.726 120.432H294.16L295.378 122.537L294.16 124.646Z",
    fill: "#DADADA"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M288.432 127.707H286.209L285.098 125.783L286.209 123.858H288.432L289.543 125.783L288.432 127.707Z",
    fill: "#DADADA"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 131.621H280.201L278.702 129.025L280.201 126.434H283.198L284.697 129.025L283.198 131.621Z",
    fill: "#DADADA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 134.865H274.58L273.082 132.269L274.58 129.674H277.578L279.076 132.269L277.578 134.865Z",
    fill: "#DADADA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 138.106H268.96L267.461 135.511L268.96 132.919H271.957L273.456 135.511L271.957 138.106Z",
    fill: "#DADADA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M254.216 172.271H252.972L252.347 171.191L252.972 170.115H254.216L254.841 171.191L254.216 172.271Z",
    fill: "#DADADA"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M254.957 180.041H252.23L250.865 177.678L252.23 175.319H254.957L256.322 177.678L254.957 180.041Z",
    fill: "#DADADA"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M254.957 186.529H252.23L250.865 184.17L252.23 181.807H254.957L256.322 184.17L254.957 186.529Z",
    fill: "#DADADA"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M254.957 193.016H252.23L250.865 190.657L252.23 188.294H254.957L256.322 190.657L254.957 193.016Z",
    fill: "#18A7B9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M259.461 207.303H258.966L258.721 206.873L258.966 206.446H259.461L259.707 206.873L259.461 207.303Z",
    fill: "#DADADA"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M265.354 211.013H264.321L263.804 210.118L264.321 209.222H265.354L265.871 210.118L265.354 211.013Z",
    fill: "#DADADA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 228.929H302.688L301.189 226.337L302.688 223.742H305.686L307.184 226.337L305.686 228.929Z",
    fill: "#DADADA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 225.687H308.309L306.811 223.091L308.309 220.496H311.307L312.806 223.091L311.307 225.687Z",
    fill: "#DADADA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 222.441H313.929L312.431 219.85L313.929 217.254H316.927L318.426 219.85L316.927 222.441Z",
    fill: "#DADADA"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 219.2H319.55L318.052 216.604L319.55 214.009H322.552L324.051 216.604L322.552 219.2Z",
    fill: "#DADADA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 215.954H325.176L323.678 213.358L325.176 210.767H328.174L329.673 213.358L328.174 215.954Z",
    fill: "#DADADA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 212.713H330.797L329.298 210.118L330.797 207.522H333.795L335.293 210.118L333.795 212.713Z",
    fill: "#DADADA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 209.468H336.417L334.918 206.872L336.417 204.281H339.415L340.913 206.872L339.415 209.468Z",
    fill: "#DADADA"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 206.226H342.038L340.54 203.63L342.038 201.035H345.036L346.535 203.63L345.036 206.226Z",
    fill: "#DADADA"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 202.98H347.658L346.159 200.385L347.658 197.793H350.655L352.154 200.385L350.655 202.98Z",
    fill: "#DADADA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 196.494H347.658L346.159 193.898L347.658 191.303H350.655L352.154 193.898L350.655 196.494Z",
    fill: "#DADADA"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 190.007H347.658L346.159 187.411L347.658 184.815H350.655L352.154 187.411L350.655 190.007Z",
    fill: "#DADADA"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 183.518H347.658L346.159 180.923L347.658 178.327H350.655L352.154 180.923L350.655 183.518Z",
    fill: "#DADADA"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M350.631 176.981H347.69L346.221 174.437L347.69 171.893H350.631L352.1 174.437L350.631 176.981Z",
    fill: "#DADADA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M349.639 168.785H348.675L348.192 167.95L348.675 167.115H349.639L350.122 167.95L349.639 168.785Z",
    fill: "#DADADA"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M350.651 164.046H347.667L346.172 161.463L347.667 158.876H350.651L352.146 161.463L350.651 164.046Z",
    fill: "#DADADA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 157.572H347.658L346.159 154.976L347.658 152.38H350.655L352.154 154.976L350.655 157.572Z",
    fill: "#DADADA"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 151.085H347.658L346.159 148.489L347.658 145.894H350.655L352.154 148.489L350.655 151.085Z",
    fill: "#DADADA"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 144.593H347.658L346.159 142.002L347.658 139.406H350.655L352.154 142.002L350.655 144.593Z",
    fill: "#DADADA"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M345.006 141.3H342.069L340.6 138.756L342.069 136.212H345.006L346.479 138.756L345.006 141.3Z",
    fill: "#DADADA"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 138.106H336.417L334.918 135.511L336.417 132.919H339.415L340.913 135.511L339.415 138.106Z",
    fill: "#DADADA"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 134.865H330.797L329.298 132.269L330.797 129.674H333.795L335.293 132.269L333.795 134.865Z",
    fill: "#DADADA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M328.13 131.551H325.214L323.758 129.024L325.214 126.502H328.13L329.59 129.024L328.13 131.551Z",
    fill: "#DADADA"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 128.378H319.55L318.052 125.783L319.55 123.187H322.552L324.051 125.783L322.552 128.378Z",
    fill: "#DADADA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 125.133H313.929L312.431 122.537L313.929 119.941H316.927L318.426 122.537L316.927 125.133Z",
    fill: "#DADADA"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M311.246 121.788H308.37L306.927 119.296L308.37 116.804H311.246L312.689 119.296L311.246 121.788Z",
    fill: "#DADADA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 118.646H302.688L301.189 116.05L302.688 113.455H305.686L307.184 116.05L305.686 118.646Z",
    fill: "#DADADA"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 115.405H297.068L295.569 112.81L297.068 110.214H300.065L301.564 112.81L300.065 115.405Z",
    fill: "#DADADA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 118.646H291.442L289.943 116.05L291.442 113.455H294.444L295.943 116.05L294.444 118.646Z",
    fill: "#DADADA"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 121.891H285.821L284.322 119.296L285.821 116.7H288.818L290.317 119.296L288.818 121.891Z",
    fill: "#DADADA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M283.082 124.93H280.321L278.939 122.537L280.321 120.148H283.082L284.465 122.537L283.082 124.93Z",
    fill: "#DADADA"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 128.378H274.58L273.082 125.783L274.58 123.187H277.578L279.076 125.783L277.578 128.378Z",
    fill: "#DADADA"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M271.957 131.621H268.96L267.461 129.025L268.96 126.434H271.957L273.456 129.025L271.957 131.621Z",
    fill: "#DADADA"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M305.555 235.191H302.816L301.447 232.824L302.816 230.452H305.555L306.925 232.824L305.555 235.191Z",
    fill: "#DADADA"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 232.175H308.309L306.811 229.579L308.309 226.983H311.307L312.806 229.579L311.307 232.175Z",
    fill: "#DADADA"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 228.929H313.929L312.431 226.337L313.929 223.742H316.927L318.426 226.337L316.927 228.929Z",
    fill: "#DADADA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 225.687H319.55L318.052 223.091L319.55 220.496H322.552L324.051 223.091L322.552 225.687Z",
    fill: "#DADADA"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 222.441H325.176L323.678 219.85L325.176 217.254H328.174L329.673 219.85L328.174 222.441Z",
    fill: "#DADADA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 219.2H330.797L329.298 216.604L330.797 214.009H333.795L335.293 216.604L333.795 219.2Z",
    fill: "#DADADA"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 215.954H336.417L334.918 213.358L336.417 210.767H339.415L340.913 213.358L339.415 215.954Z",
    fill: "#DADADA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 212.713H342.038L340.54 210.118L342.038 207.522H345.036L346.535 210.118L345.036 212.713Z",
    fill: "#DADADA"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 209.468H347.658L346.159 206.872L347.658 204.281H350.655L352.154 206.872L350.655 209.468Z",
    fill: "#DADADA"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 206.226H353.28L351.781 203.63L353.28 201.035H356.277L357.781 203.63L356.277 206.226Z",
    fill: "#DADADA"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 199.74H353.28L351.781 197.144L353.28 194.548H356.277L357.781 197.144L356.277 199.74Z",
    fill: "#DADADA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 193.248H353.28L351.781 190.656L353.28 188.061H356.277L357.781 190.656L356.277 193.248Z",
    fill: "#DADADA"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M355.808 185.948H353.753L352.724 184.17L353.753 182.388H355.808L356.837 184.17L355.808 185.948Z",
    fill: "#DADADA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M355.063 178.17H354.499L354.214 177.679L354.499 177.192H355.063L355.343 177.679L355.063 178.17Z",
    fill: "#DADADA"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M356.272 173.778H353.288L351.793 171.191L353.288 168.608H356.272L357.767 171.191L356.272 173.778Z",
    fill: "#DADADA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 167.3H353.28L351.781 164.705L353.28 162.113H356.277L357.781 164.705L356.277 167.3Z",
    fill: "#DADADA"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 160.813H353.28L351.781 158.218L353.28 155.622H356.277L357.781 158.218L356.277 160.813Z",
    fill: "#DADADA"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 154.326H353.28L351.781 151.73L353.28 149.135H356.277L357.781 151.73L356.277 154.326Z",
    fill: "#DADADA"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 147.839H353.28L351.781 145.244L353.28 142.648H356.277L357.781 145.244L356.277 147.839Z",
    fill: "#DADADA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 141.352H353.28L351.781 138.756L353.28 136.161H356.277L357.781 138.756L356.277 141.352Z",
    fill: "#DADADA"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 138.106H347.658L346.159 135.511L347.658 132.919H350.655L352.154 135.511L350.655 138.106Z",
    fill: "#DADADA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 134.865H342.038L340.54 132.269L342.038 129.674H345.036L346.535 132.269L345.036 134.865Z",
    fill: "#DADADA"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 131.621H336.417L334.918 129.025L336.417 126.434H339.415L340.913 129.025L339.415 131.621Z",
    fill: "#DADADA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 128.378H330.797L329.298 125.783L330.797 123.187H333.795L335.293 125.783L333.795 128.378Z",
    fill: "#DADADA"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 125.133H325.176L323.678 122.537L325.176 119.941H328.174L329.673 122.537L328.174 125.133Z",
    fill: "#DADADA"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 121.891H319.55L318.052 119.296L319.55 116.7H322.552L324.051 119.296L322.552 121.891Z",
    fill: "#DADADA"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 118.646H313.929L312.431 116.05L313.929 113.455H316.927L318.426 116.05L316.927 118.646Z",
    fill: "#DADADA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 115.405H308.309L306.811 112.81L308.309 110.214H311.307L312.806 112.81L311.307 115.405Z",
    fill: "#DADADA"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 112.159H302.688L301.189 109.563L302.688 106.967H305.686L307.184 109.563L305.686 112.159Z",
    fill: "#DADADA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 108.913H297.068L295.569 106.322L297.068 103.726H300.065L301.564 106.322L300.065 108.913Z",
    fill: "#DADADA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 112.159H291.442L289.943 109.563L291.442 106.967H294.444L295.943 109.563L294.444 112.159Z",
    fill: "#DADADA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 115.405H285.821L284.322 112.81L285.821 110.214H288.818L290.317 112.81L288.818 115.405Z",
    fill: "#DADADA"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M283.146 118.555H280.252L278.81 116.05L280.252 113.549H283.146L284.593 116.05L283.146 118.555Z",
    fill: "#DADADA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M270.862 123.24H270.053L269.644 122.538L270.053 121.836H270.862L271.267 122.538L270.862 123.24Z",
    fill: "#DADADA"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M242.608 184.618H242.091L241.833 184.17L242.091 183.722H242.608L242.866 184.17L242.608 184.618Z",
    fill: "#DADADA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M305.161 240.998H303.21L302.236 239.311L303.21 237.619H305.161L306.138 239.311L305.161 240.998Z",
    fill: "#DADADA"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 238.661H308.309L306.811 236.065L308.309 233.469H311.307L312.806 236.065L311.307 238.661Z",
    fill: "#DADADA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 235.415H313.929L312.431 232.824L313.929 230.228H316.927L318.426 232.824L316.927 235.415Z",
    fill: "#DADADA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 232.175H319.55L318.052 229.579L319.55 226.983H322.552L324.051 229.579L322.552 232.175Z",
    fill: "#DADADA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 228.929H325.176L323.678 226.337L325.176 223.742H328.174L329.673 226.337L328.174 228.929Z",
    fill: "#DADADA"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 225.687H330.797L329.298 223.091L330.797 220.496H333.795L335.293 223.091L333.795 225.687Z",
    fill: "#18A7B9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 222.441H336.417L334.918 219.85L336.417 217.254H339.415L340.913 219.85L339.415 222.441Z",
    fill: "#DADADA"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 219.2H342.038L340.54 216.604L342.038 214.009H345.036L346.535 216.604L345.036 219.2Z",
    fill: "#DADADA"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 215.954H347.658L346.159 213.358L347.658 210.767H350.655L352.154 213.358L350.655 215.954Z",
    fill: "#DADADA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 212.713H353.28L351.781 210.118L353.28 207.522H356.277L357.781 210.118L356.277 212.713Z",
    fill: "#DADADA"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 209.468H358.905L357.402 206.872L358.905 204.281H361.903L363.402 206.872L361.903 209.468Z",
    fill: "#DADADA"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 202.98H358.905L357.402 200.385L358.905 197.793H361.903L363.402 200.385L361.903 202.98Z",
    fill: "#DADADA"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M361.872 196.442H358.931L357.462 193.898L358.931 191.354H361.872L363.341 193.898L361.872 196.442Z",
    fill: "#DADADA"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M360.908 188.285H359.896L359.392 187.411L359.896 186.537H360.908L361.411 187.411L360.908 188.285Z",
    fill: "#DADADA"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M361.74 183.235H359.069L357.734 180.924L359.069 178.612H361.74L363.07 180.924L361.74 183.235Z",
    fill: "#DADADA"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 177.033H358.905L357.402 174.437L358.905 171.841H361.903L363.402 174.437L361.903 177.033Z",
    fill: "#DADADA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 170.546H358.905L357.402 167.95L358.905 165.354H361.903L363.402 167.95L361.903 170.546Z",
    fill: "#DADADA"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 164.059H358.905L357.402 161.464L358.905 158.868H361.903L363.402 161.464L361.903 164.059Z",
    fill: "#DADADA"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 157.572H358.905L357.402 154.976L358.905 152.38H361.903L363.402 154.976L361.903 157.572Z",
    fill: "#DADADA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 151.085H358.905L357.402 148.489L358.905 145.894H361.903L363.402 148.489L361.903 151.085Z",
    fill: "#DADADA"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 144.593H358.905L357.402 142.002L358.905 139.406H361.903L363.402 142.002L361.903 144.593Z",
    fill: "#DADADA"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 138.106H358.905L357.402 135.511L358.905 132.919H361.903L363.402 135.511L361.903 138.106Z",
    fill: "#DADADA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 134.865H353.28L351.781 132.269L353.28 129.674H356.277L357.781 132.269L356.277 134.865Z",
    fill: "#DADADA"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 131.621H347.658L346.159 129.025L347.658 126.434H350.655L352.154 129.025L350.655 131.621Z",
    fill: "#DADADA"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 128.378H342.038L340.54 125.783L342.038 123.187H345.036L346.535 125.783L345.036 128.378Z",
    fill: "#DADADA"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 125.133H336.417L334.918 122.537L336.417 119.941H339.415L340.913 122.537L339.415 125.133Z",
    fill: "#DADADA"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 121.891H330.797L329.298 119.296L330.797 116.7H333.795L335.293 119.296L333.795 121.891Z",
    fill: "#DADADA"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 118.646H325.176L323.678 116.05L325.176 113.455H328.174L329.673 116.05L328.174 118.646Z",
    fill: "#DADADA"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 115.405H319.55L318.052 112.81L319.55 110.214H322.552L324.051 112.81L322.552 115.405Z",
    fill: "#DADADA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 112.159H313.929L312.431 109.563L313.929 106.967H316.927L318.426 109.563L316.927 112.159Z",
    fill: "#DADADA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 108.913H308.309L306.811 106.322L308.309 103.726H311.307L312.806 106.322L311.307 108.913Z",
    fill: "#DADADA"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 105.672H302.688L301.189 103.076L302.688 100.48H305.686L307.184 103.076L305.686 105.672Z",
    fill: "#DADADA"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 102.427H297.068L295.569 99.8354L297.068 97.2397H300.065L301.564 99.8354L300.065 102.427Z",
    fill: "#DADADA"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M294.444 105.672H291.442L289.943 103.076L291.442 100.48H294.444L295.943 103.076L294.444 105.672Z",
    fill: "#DADADA"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M288.818 108.913H285.821L284.322 106.322L285.821 103.726H288.818L290.317 106.322L288.818 108.913Z",
    fill: "#DADADA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M283.189 112.138H280.213L278.728 109.563L280.213 106.989H283.189L284.675 109.563L283.189 112.138Z",
    fill: "#DADADA"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M277.371 115.048H274.787L273.495 112.809L274.787 110.571H277.371L278.667 112.809L277.371 115.048Z",
    fill: "#DADADA"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 245.148H308.309L306.811 242.553L308.309 239.961H311.307L312.806 242.553L311.307 245.148Z",
    fill: "#DADADA"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 241.906H313.929L312.431 239.31L313.929 236.715H316.927L318.426 239.31L316.927 241.906Z",
    fill: "#DADADA"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 238.661H319.55L318.052 236.065L319.55 233.469H322.552L324.051 236.065L322.552 238.661Z",
    fill: "#DADADA"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 235.415H325.176L323.678 232.824L325.176 230.228H328.174L329.673 232.824L328.174 235.415Z",
    fill: "#DADADA"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 232.175H330.797L329.298 229.579L330.797 226.983H333.795L335.293 229.579L333.795 232.175Z",
    fill: "#DADADA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 228.929H336.417L334.918 226.337L336.417 223.742H339.415L340.913 226.337L339.415 228.929Z",
    fill: "#DADADA"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 225.687H342.038L340.54 223.091L342.038 220.496H345.036L346.535 223.091L345.036 225.687Z",
    fill: "#DADADA"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 222.441H347.658L346.159 219.85L347.658 217.254H350.655L352.154 219.85L350.655 222.441Z",
    fill: "#DADADA"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 219.2H353.28L351.781 216.604L353.28 214.009H356.277L357.781 216.604L356.277 219.2Z",
    fill: "#DADADA"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 215.954H358.905L357.402 213.358L358.905 210.767H361.903L363.402 213.358L361.903 215.954Z",
    fill: "#DADADA"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 212.713H364.526L363.027 210.118L364.526 207.522H367.524L369.022 210.118L367.524 212.713Z",
    fill: "#DADADA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 206.226H364.526L363.027 203.63L364.526 201.035H367.524L369.022 203.63L367.524 206.226Z",
    fill: "#DADADA"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M367.515 199.726H364.53L363.04 197.144L364.53 194.557H367.515L369.009 197.144L367.515 199.726Z",
    fill: "#DADADA"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M367.415 193.067H364.628L363.237 190.657L364.628 188.242H367.415L368.81 190.657L367.415 193.067Z",
    fill: "#DADADA"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 186.761H364.526L363.027 184.17L364.526 181.574H367.524L369.022 184.17L367.524 186.761Z",
    fill: "#DADADA"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 180.274H364.526L363.027 177.679L364.526 175.087H367.524L369.022 177.679L367.524 180.274Z",
    fill: "#DADADA"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 173.787H364.526L363.027 171.191L364.526 168.6H367.524L369.022 171.191L367.524 173.787Z",
    fill: "#DADADA"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 167.3H364.526L363.027 164.705L364.526 162.113H367.524L369.022 164.705L367.524 167.3Z",
    fill: "#DADADA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 160.813H364.526L363.027 158.218L364.526 155.622H367.524L369.022 158.218L367.524 160.813Z",
    fill: "#DADADA"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 154.326H364.526L363.027 151.73L364.526 149.135H367.524L369.022 151.73L367.524 154.326Z",
    fill: "#DADADA"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 147.839H364.526L363.027 145.244L364.526 142.648H367.524L369.022 145.244L367.524 147.839Z",
    fill: "#DADADA"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 141.352H364.526L363.027 138.756L364.526 136.161H367.524L369.022 138.756L367.524 141.352Z",
    fill: "#DADADA"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 134.865H364.526L363.027 132.269L364.526 129.674H367.524L369.022 132.269L367.524 134.865Z",
    fill: "#DADADA"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 131.621H358.905L357.402 129.025L358.905 126.434H361.903L363.402 129.025L361.903 131.621Z",
    fill: "#DADADA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 128.378H353.28L351.781 125.783L353.28 123.187H356.277L357.781 125.783L356.277 128.378Z",
    fill: "#DADADA"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 125.133H347.658L346.159 122.537L347.658 119.941H350.655L352.154 122.537L350.655 125.133Z",
    fill: "#DADADA"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 121.891H342.038L340.54 119.296L342.038 116.7H345.036L346.535 119.296L345.036 121.891Z",
    fill: "#DADADA"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 118.646H336.417L334.918 116.05L336.417 113.455H339.415L340.913 116.05L339.415 118.646Z",
    fill: "#DADADA"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 115.405H330.797L329.298 112.81L330.797 110.214H333.795L335.293 112.81L333.795 115.405Z",
    fill: "#DADADA"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 112.159H325.176L323.678 109.563L325.176 106.967H328.174L329.673 109.563L328.174 112.159Z",
    fill: "#DADADA"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 108.913H319.55L318.052 106.322L319.55 103.726H322.552L324.051 106.322L322.552 108.913Z",
    fill: "#18A7B9"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 102.427H308.309L306.811 99.8354L308.309 97.2397H311.307L312.806 99.8354L311.307 102.427Z",
    fill: "#DADADA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M305.681 99.1717H302.692L301.202 96.589L302.692 94.002H305.681L307.171 96.589L305.681 99.1717Z",
    fill: "#DADADA"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M299.953 95.7458H297.179L295.792 93.3438L297.179 90.9419H299.953L301.34 93.3438L299.953 95.7458Z",
    fill: "#DADADA"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M293.756 97.9936H292.132L291.322 96.5903L292.132 95.187H293.756L294.565 96.5903L293.756 97.9936Z",
    fill: "#DADADA"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M287.562 100.249H287.08L286.843 99.8352L287.08 99.4175H287.562L287.803 99.8352L287.562 100.249Z",
    fill: "#DADADA"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M283.189 105.65H280.213L278.728 103.076L280.213 100.502H283.189L284.675 103.076L283.189 105.65Z",
    fill: "#DADADA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M276.389 106.861H275.769L275.455 106.322L275.769 105.78H276.389L276.704 106.322L276.389 106.861Z",
    fill: "#DADADA"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M305.074 253.821H303.299L302.412 252.285L303.299 250.748H305.074L305.961 252.285L305.074 253.821Z",
    fill: "#DADADA"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 251.634H308.309L306.811 249.039L308.309 246.447H311.307L312.806 249.039L311.307 251.634Z",
    fill: "#DADADA"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 248.394H313.929L312.431 245.798L313.929 243.203H316.927L318.426 245.798L316.927 248.394Z",
    fill: "#DADADA"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 245.148H319.55L318.052 242.553L319.55 239.961H322.552L324.051 242.553L322.552 245.148Z",
    fill: "#DADADA"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 241.906H325.176L323.678 239.31L325.176 236.715H328.174L329.673 239.31L328.174 241.906Z",
    fill: "#DADADA"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 238.661H330.797L329.298 236.065L330.797 233.469H333.795L335.293 236.065L333.795 238.661Z",
    fill: "#DADADA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 235.415H336.417L334.918 232.824L336.417 230.228H339.415L340.913 232.824L339.415 235.415Z",
    fill: "#DADADA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 232.175H342.038L340.54 229.579L342.038 226.983H345.036L346.535 229.579L345.036 232.175Z",
    fill: "#DADADA"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 228.929H347.658L346.159 226.337L347.658 223.742H350.655L352.154 226.337L350.655 228.929Z",
    fill: "#DADADA"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 225.687H353.28L351.781 223.091L353.28 220.496H356.277L357.781 223.091L356.277 225.687Z",
    fill: "#DADADA"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M361.799 222.269H359.004L357.604 219.85L359.004 217.426H361.799L363.198 219.85L361.799 222.269Z",
    fill: "#DADADA"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M366.86 218.05H365.189L364.354 216.604L365.189 215.158H366.86L367.691 216.604L366.86 218.05Z",
    fill: "#DADADA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M372.937 209.11H370.353L369.057 206.872L370.353 204.634H372.937L374.234 206.872L372.937 209.11Z",
    fill: "#DADADA"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 202.98H370.146L368.647 200.385L370.146 197.793H373.144L374.642 200.385L373.144 202.98Z",
    fill: "#DADADA"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M372.305 195.039H370.987L370.328 193.898L370.987 192.757H372.305L372.964 193.898L372.305 195.039Z",
    fill: "#DADADA"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M373.132 189.985H370.16L368.67 187.411L370.16 184.836H373.132L374.622 187.411L373.132 189.985Z",
    fill: "#DADADA"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 183.518H370.146L368.647 180.923L370.146 178.327H373.144L374.642 180.923L373.144 183.518Z",
    fill: "#DADADA"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 177.033H370.146L368.647 174.437L370.146 171.841H373.144L374.642 174.437L373.144 177.033Z",
    fill: "#DADADA"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 170.546H370.146L368.647 167.95L370.146 165.354H373.144L374.642 167.95L373.144 170.546Z",
    fill: "#DADADA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 164.059H370.146L368.647 161.464L370.146 158.868H373.144L374.642 161.464L373.144 164.059Z",
    fill: "#DADADA"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 157.572H370.146L368.647 154.976L370.146 152.38H373.144L374.642 154.976L373.144 157.572Z",
    fill: "#DADADA"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 151.085H370.146L368.647 148.489L370.146 145.894H373.144L374.642 148.489L373.144 151.085Z",
    fill: "#DADADA"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 144.593H370.146L368.647 142.002L370.146 139.406H373.144L374.642 142.002L373.144 144.593Z",
    fill: "#DADADA"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 138.106H370.146L368.647 135.511L370.146 132.919H373.144L374.642 135.511L373.144 138.106Z",
    fill: "#DADADA"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 131.621H370.146L368.647 129.025L370.146 126.434H373.144L374.642 129.025L373.144 131.621Z",
    fill: "#DADADA"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 128.378H364.526L363.027 125.783L364.526 123.187H367.524L369.022 125.783L367.524 128.378Z",
    fill: "#DADADA"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 125.133H358.905L357.402 122.537L358.905 119.941H361.903L363.402 122.537L361.903 125.133Z",
    fill: "#DADADA"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 121.891H353.28L351.781 119.296L353.28 116.7H356.277L357.781 119.296L356.277 121.891Z",
    fill: "#DADADA"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 118.646H347.658L346.159 116.05L347.658 113.455H350.655L352.154 116.05L350.655 118.646Z",
    fill: "#DADADA"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 115.405H342.038L340.54 112.81L342.038 110.214H345.036L346.535 112.81L345.036 115.405Z",
    fill: "#DADADA"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 112.159H336.417L334.918 109.563L336.417 106.967H339.415L340.913 109.563L339.415 112.159Z",
    fill: "#DADADA"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 108.913H330.797L329.298 106.322L330.797 103.726H333.795L335.293 106.322L333.795 108.913Z",
    fill: "#DADADA"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 105.672H325.176L323.678 103.076L325.176 100.48H328.174L329.673 103.076L328.174 105.672Z",
    fill: "#DADADA"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 102.427H319.55L318.052 99.8354L319.55 97.2397H322.552L324.051 99.8354L322.552 102.427Z",
    fill: "#DADADA"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 99.1849H313.929L312.431 96.5893L313.929 93.9937H316.927L318.426 96.5893L316.927 99.1849Z",
    fill: "#DADADA"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M310.816 95.0874H308.805L307.797 93.344L308.805 91.605H310.816L311.82 93.344L310.816 95.0874Z",
    fill: "#DADADA"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M304.962 91.4448H303.412L302.637 90.1018L303.412 88.7588H304.962L305.738 90.1018L304.962 91.4448Z",
    fill: "#DADADA"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M299.501 88.4754H297.632L296.697 86.8569L297.632 85.2427H299.501L300.436 86.8569L299.501 88.4754Z",
    fill: "#DADADA"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M283.198 99.1849H280.201L278.702 96.5893L280.201 93.9937H283.198L284.697 96.5893L283.198 99.1849Z",
    fill: "#DADADA"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M277.578 102.427H274.58L273.082 99.8354L274.58 97.2397H277.578L279.076 99.8354L277.578 102.427Z",
    fill: "#DADADA"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M305.526 261.091H302.848L301.504 258.771L302.848 256.451H305.526L306.866 258.771L305.526 261.091Z",
    fill: "#DADADA"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 258.122H308.309L306.811 255.53L308.309 252.935H311.307L312.806 255.53L311.307 258.122Z",
    fill: "#DADADA"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 254.881H313.929L312.431 252.285L313.929 249.689H316.927L318.426 252.285L316.927 254.881Z",
    fill: "#DADADA"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 251.634H319.55L318.052 249.039L319.55 246.447H322.552L324.051 249.039L322.552 251.634Z",
    fill: "#DADADA"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 248.394H325.176L323.678 245.798L325.176 243.203H328.174L329.673 245.798L328.174 248.394Z",
    fill: "#DADADA"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 241.906H336.417L334.918 239.31L336.417 236.715H339.415L340.913 239.31L339.415 241.906Z",
    fill: "#DADADA"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 238.661H342.038L340.54 236.065L342.038 233.469H345.036L346.535 236.065L345.036 238.661Z",
    fill: "#DADADA"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 235.415H347.658L346.159 232.824L347.658 230.228H350.655L352.154 232.824L350.655 235.415Z",
    fill: "#DADADA"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M356.255 232.131H353.305L351.828 229.578L353.305 227.026H356.255L357.732 229.578L356.255 232.131Z",
    fill: "#DADADA"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M377.989 198.392H376.542L375.819 197.144L376.542 195.891H377.989L378.713 197.144L377.989 198.392Z",
    fill: "#DADADA"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 186.761H375.768L374.269 184.17L375.768 181.574H378.765L380.264 184.17L378.765 186.761Z",
    fill: "#DADADA"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 180.274H375.768L374.269 177.679L375.768 175.087H378.765L380.264 177.679L378.765 180.274Z",
    fill: "#DADADA"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 173.787H375.768L374.269 171.191L375.768 168.6H378.765L380.264 171.191L378.765 173.787Z",
    fill: "#DADADA"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M378.761 167.292H375.777L374.282 164.705L375.777 162.122H378.761L380.256 164.705L378.761 167.292Z",
    fill: "#DADADA"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M377.68 158.933H376.857L376.444 158.218L376.857 157.507H377.68L378.089 158.218L377.68 158.933Z",
    fill: "#DADADA"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 154.326H375.768L374.269 151.73L375.768 149.135H378.765L380.264 151.73L378.765 154.326Z",
    fill: "#DADADA"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 147.839H375.768L374.269 145.244L375.768 142.648H378.765L380.264 145.244L378.765 147.839Z",
    fill: "#DADADA"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 141.352H375.768L374.269 138.756L375.768 136.161H378.765L380.264 138.756L378.765 141.352Z",
    fill: "#DADADA"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 134.865H375.768L374.269 132.269L375.768 129.674H378.765L380.264 132.269L378.765 134.865Z",
    fill: "#DADADA"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 128.378H375.768L374.269 125.783L375.768 123.187H378.765L380.264 125.783L378.765 128.378Z",
    fill: "#DADADA"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 125.133H370.146L368.647 122.537L370.146 119.941H373.144L374.642 122.537L373.144 125.133Z",
    fill: "#DADADA"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 121.891H364.526L363.027 119.296L364.526 116.7H367.524L369.022 119.296L367.524 121.891Z",
    fill: "#DADADA"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 118.646H358.905L357.402 116.05L358.905 113.455H361.903L363.402 116.05L361.903 118.646Z",
    fill: "#DADADA"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 115.405H353.28L351.781 112.81L353.28 110.214H356.277L357.781 112.81L356.277 115.405Z",
    fill: "#DADADA"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 112.159H347.658L346.159 109.563L347.658 106.967H350.655L352.154 109.563L350.655 112.159Z",
    fill: "#DADADA"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 108.913H342.038L340.54 106.322L342.038 103.726H345.036L346.535 106.322L345.036 108.913Z",
    fill: "#DADADA"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 105.672H336.417L334.918 103.076L336.417 100.48H339.415L340.913 103.076L339.415 105.672Z",
    fill: "#DADADA"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 102.427H330.797L329.298 99.8354L330.797 97.2397H333.795L335.293 99.8354L333.795 102.427Z",
    fill: "#DADADA"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 99.1849H325.176L323.678 96.5893L325.176 93.9937H328.174L329.673 96.5893L328.174 99.1849Z",
    fill: "#DADADA"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 95.9394H319.55L318.052 93.3438L319.55 90.7524H322.552L324.051 93.3438L322.552 95.9394Z",
    fill: "#DADADA"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M311.303 89.4442H308.314L306.824 86.8571L308.314 84.2744H311.303L312.797 86.8571L311.303 89.4442Z",
    fill: "#DADADA"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M305.661 86.1686H302.711L301.238 83.616L302.711 81.0591H305.661L307.138 83.616L305.661 86.1686Z",
    fill: "#DADADA"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 82.9657H297.068L295.569 80.3701L297.068 77.7744H300.065L301.564 80.3701L300.065 82.9657Z",
    fill: "#DADADA"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M293.471 84.5325H292.415L291.886 83.6156L292.415 82.6987H293.471L294 83.6156L293.471 84.5325Z",
    fill: "#DADADA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M282.603 91.6689H280.795L279.89 90.102L280.795 88.5352H282.603L283.512 90.102L282.603 91.6689Z",
    fill: "#DADADA"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M276.906 94.7818H275.252L274.421 93.3441L275.252 91.9106H276.906L277.737 93.3441L276.906 94.7818Z",
    fill: "#DADADA"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M271.72 98.7758H269.192L267.93 96.5891L269.192 94.4023H271.72L272.986 96.5891L271.72 98.7758Z",
    fill: "#DADADA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M265.44 100.88H264.229L263.626 99.8345L264.229 98.7842H265.44L266.047 99.8345L265.44 100.88Z",
    fill: "#DADADA"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 264.608H308.309L306.811 262.017L308.309 259.421H311.307L312.806 262.017L311.307 264.608Z",
    fill: "#DADADA"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 261.368H313.929L312.431 258.772L313.929 256.176H316.927L318.426 258.772L316.927 261.368Z",
    fill: "#DADADA"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 258.122H319.55L318.052 255.53L319.55 252.935H322.552L324.051 255.53L322.552 258.122Z",
    fill: "#DADADA"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 254.881H325.176L323.678 252.285L325.176 249.689H328.174L329.673 252.285L328.174 254.881Z",
    fill: "#DADADA"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 251.634H330.797L329.298 249.039L330.797 246.447H333.795L335.293 249.039L333.795 251.634Z",
    fill: "#DADADA"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 248.394H336.417L334.918 245.798L336.417 243.203H339.415L340.913 245.798L339.415 248.394Z",
    fill: "#DADADA"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 245.148H342.038L340.54 242.553L342.038 239.961H345.036L346.535 242.553L345.036 245.148Z",
    fill: "#DADADA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 241.906H347.658L346.159 239.31L347.658 236.715H350.655L352.154 239.31L350.655 241.906Z",
    fill: "#DADADA"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M356.26 238.631H353.297L351.82 236.065L353.297 233.504H356.26L357.742 236.065L356.26 238.631Z",
    fill: "#DADADA"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M384.347 183.446H381.432L379.972 180.924L381.432 178.401H384.347L385.803 180.924L384.347 183.446Z",
    fill: "#DADADA"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 177.033H381.388L379.889 174.437L381.388 171.841H384.385L385.884 174.437L384.385 177.033Z",
    fill: "#DADADA"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M384.347 170.472H381.432L379.972 167.95L381.432 165.427H384.347L385.803 167.95L384.347 170.472Z",
    fill: "#DADADA"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M384.106 163.568H381.672L380.454 161.463L381.672 159.354H384.106L385.32 161.463L384.106 163.568Z",
    fill: "#DADADA"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 157.572H381.388L379.889 154.976L381.388 152.38H384.385L385.884 154.976L384.385 157.572Z",
    fill: "#DADADA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 151.085H381.388L379.889 148.489L381.388 145.894H384.385L385.884 148.489L384.385 151.085Z",
    fill: "#DADADA"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 144.593H381.388L379.889 142.002L381.388 139.406H384.385L385.884 142.002L384.385 144.593Z",
    fill: "#DADADA"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 138.106H381.388L379.889 135.511L381.388 132.919H384.385L385.884 135.511L384.385 138.106Z",
    fill: "#DADADA"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 131.621H381.388L379.889 129.025L381.388 126.434H384.385L385.884 129.025L384.385 131.621Z",
    fill: "#DADADA"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 125.133H381.388L379.889 122.537L381.388 119.941H384.385L385.884 122.537L384.385 125.133Z",
    fill: "#DADADA"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 121.891H375.768L374.269 119.296L375.768 116.7H378.765L380.264 119.296L378.765 121.891Z",
    fill: "#DADADA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 118.646H370.146L368.647 116.05L370.146 113.455H373.144L374.642 116.05L373.144 118.646Z",
    fill: "#DADADA"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 115.405H364.526L363.027 112.81L364.526 110.214H367.524L369.022 112.81L367.524 115.405Z",
    fill: "#DADADA"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 112.159H358.905L357.402 109.563L358.905 106.967H361.903L363.402 109.563L361.903 112.159Z",
    fill: "#DADADA"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 108.913H353.28L351.781 106.322L353.28 103.726H356.277L357.781 106.322L356.277 108.913Z",
    fill: "#DADADA"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 105.672H347.658L346.159 103.076L347.658 100.48H350.655L352.154 103.076L350.655 105.672Z",
    fill: "#DADADA"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 102.427H342.038L340.54 99.8354L342.038 97.2397H345.036L346.535 99.8354L345.036 102.427Z",
    fill: "#DADADA"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 99.1849H336.417L334.918 96.5893L336.417 93.9937H339.415L340.913 96.5893L339.415 99.1849Z",
    fill: "#DADADA"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 95.9394H330.797L329.298 93.3438L330.797 90.7524H333.795L335.293 93.3438L333.795 95.9394Z",
    fill: "#DADADA"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 92.6981H325.176L323.678 90.1025L325.176 87.5068H328.174L329.673 90.1025L328.174 92.6981Z",
    fill: "#DADADA"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M322.466 89.3101H319.636L318.219 86.8565L319.636 84.4072H322.466L323.883 86.8565L322.466 89.3101Z",
    fill: "#DADADA"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M315.722 84.1238H315.137L314.844 83.6156L315.137 83.1074H315.722L316.02 83.6156L315.722 84.1238Z",
    fill: "#DADADA"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 82.9657H308.309L306.811 80.3701L308.309 77.7744H311.307L312.806 80.3701L311.307 82.9657Z",
    fill: "#DADADA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 79.7245H302.688L301.189 77.1288L302.688 74.5332H305.686L307.184 77.1288L305.686 79.7245Z",
    fill: "#DADADA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 76.4784H297.068L295.569 73.8827L297.068 71.2871H300.065L301.564 73.8827L300.065 76.4784Z",
    fill: "#DADADA"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M294.212 79.3236H291.676L290.405 77.1283L291.676 74.9287H294.212L295.483 77.1283L294.212 79.3236Z",
    fill: "#DADADA"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M277.56 89.4226H274.597L273.115 86.8571L274.597 84.2959H277.56L279.041 86.8571L277.56 89.4226Z",
    fill: "#DADADA"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M214.787 227.279H213.693L213.146 226.337L213.693 225.39H214.787L215.334 226.337L214.787 227.279Z",
    fill: "#DADADA"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M311.273 271.036H308.344L306.88 268.505L308.344 265.969H311.273L312.737 268.505L311.273 271.036Z",
    fill: "#DADADA"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 267.854H313.929L312.431 265.259L313.929 262.663H316.927L318.426 265.259L316.927 267.854Z",
    fill: "#DADADA"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 264.608H319.55L318.052 262.017L319.55 259.421H322.552L324.051 262.017L322.552 264.608Z",
    fill: "#DADADA"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 261.368H325.176L323.678 258.772L325.176 256.176H328.174L329.673 258.772L328.174 261.368Z",
    fill: "#18A7B9"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 258.122H330.797L329.298 255.53L330.797 252.935H333.795L335.293 255.53L333.795 258.122Z",
    fill: "#DADADA"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 254.881H336.417L334.918 252.285L336.417 249.689H339.415L340.913 252.285L339.415 254.881Z",
    fill: "#DADADA"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 251.634H342.038L340.54 249.039L342.038 246.447H345.036L346.535 249.039L345.036 251.634Z",
    fill: "#DADADA"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 248.394H347.658L346.159 245.798L347.658 243.203H350.655L352.154 245.798L350.655 248.394Z",
    fill: "#DADADA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 245.148H353.28L351.781 242.553L353.28 239.961H356.277L357.781 242.553L356.277 245.148Z",
    fill: "#DADADA"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M389.86 180.02H387.159L385.807 177.678L387.159 175.341H389.86L391.212 177.678L389.86 180.02Z",
    fill: "#DADADA"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M389.851 173.512H387.168L385.829 171.192L387.168 168.872H389.851L391.19 171.192L389.851 173.512Z",
    fill: "#DADADA"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M389.722 166.801H387.298L386.087 164.705L387.298 162.608H389.722L390.932 164.705L389.722 166.801Z",
    fill: "#DADADA"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 160.813H387.009L385.51 158.218L387.009 155.622H390.011L391.51 158.218L390.011 160.813Z",
    fill: "#DADADA"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 154.326H387.009L385.51 151.73L387.009 149.135H390.011L391.51 151.73L390.011 154.326Z",
    fill: "#DADADA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 147.839H387.009L385.51 145.244L387.009 142.648H390.011L391.51 145.244L390.011 147.839Z",
    fill: "#DADADA"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 141.352H387.009L385.51 138.756L387.009 136.161H390.011L391.51 138.756L390.011 141.352Z",
    fill: "#DADADA"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 134.865H387.009L385.51 132.269L387.009 129.674H390.011L391.51 132.269L390.011 134.865Z",
    fill: "#DADADA"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 128.378H387.009L385.51 125.783L387.009 123.187H390.011L391.51 125.783L390.011 128.378Z",
    fill: "#DADADA"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 121.891H387.009L385.51 119.296L387.009 116.7H390.011L391.51 119.296L390.011 121.891Z",
    fill: "#DADADA"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 118.646H381.388L379.889 116.05L381.388 113.455H384.385L385.884 116.05L384.385 118.646Z",
    fill: "#DADADA"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 115.405H375.768L374.269 112.81L375.768 110.214H378.765L380.264 112.81L378.765 115.405Z",
    fill: "#DADADA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 112.159H370.146L368.647 109.563L370.146 106.967H373.144L374.642 109.563L373.144 112.159Z",
    fill: "#DADADA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 108.913H364.526L363.027 106.322L364.526 103.726H367.524L369.022 106.322L367.524 108.913Z",
    fill: "#DADADA"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 102.427H353.28L351.781 99.8354L353.28 97.2397H356.277L357.781 99.8354L356.277 102.427Z",
    fill: "#DADADA"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 99.1849H347.658L346.159 96.5893L347.658 93.9937H350.655L352.154 96.5893L350.655 99.1849Z",
    fill: "#DADADA"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 95.9394H342.038L340.54 93.3438L342.038 90.7524H345.036L346.535 93.3438L345.036 95.9394Z",
    fill: "#DADADA"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 92.6981H336.417L334.918 90.1025L336.417 87.5068H339.415L340.913 90.1025L339.415 92.6981Z",
    fill: "#DADADA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 89.4525H330.797L329.298 86.8569L330.797 84.2612H333.795L335.293 86.8569L333.795 89.4525Z",
    fill: "#DADADA"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 86.2108H325.176L323.678 83.6152L325.176 81.0195H328.174L329.673 83.6152L328.174 86.2108Z",
    fill: "#DADADA"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 76.4784H308.309L306.811 73.8827L308.309 71.2871H311.307L312.806 73.8827L311.307 76.4784Z",
    fill: "#DADADA"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 73.2334H302.688L301.189 70.642L302.688 68.0464H305.686L307.184 70.642L305.686 73.2334Z",
    fill: "#DADADA"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M299.661 69.29H297.473L296.379 67.396L297.473 65.502H299.661L300.75 67.396L299.661 69.29Z",
    fill: "#DADADA"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M293.23 71.1365H292.657L292.369 70.6412L292.657 70.1416H293.23L293.519 70.6412L293.23 71.1365Z",
    fill: "#DADADA"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M276.373 80.883H275.787L275.494 80.3705L275.787 79.8623H276.373L276.67 80.3705L276.373 80.883Z",
    fill: "#DADADA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 228.929H201.501L200.002 226.337L201.501 223.742H204.498L205.997 226.337L204.498 228.929Z",
    fill: "#DADADA"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 232.175H207.121L205.622 229.579L207.121 226.983H210.118L211.617 229.579L210.118 232.175Z",
    fill: "#DADADA"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 235.415H212.742L211.244 232.824L212.742 230.228H215.74L217.239 232.824L215.74 235.415Z",
    fill: "#DADADA"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M310.996 277.044H308.619L307.435 274.991L308.619 272.934H310.996L312.181 274.991L310.996 277.044Z",
    fill: "#DADADA"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 274.341H313.929L312.431 271.746L313.929 269.15H316.927L318.426 271.746L316.927 274.341Z",
    fill: "#DADADA"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 271.096H319.55L318.052 268.504L319.55 265.909H322.552L324.051 268.504L322.552 271.096Z",
    fill: "#DADADA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 267.854H325.176L323.678 265.259L325.176 262.663H328.174L329.673 265.259L328.174 267.854Z",
    fill: "#DADADA"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 264.608H330.797L329.298 262.017L330.797 259.421H333.795L335.293 262.017L333.795 264.608Z",
    fill: "#DADADA"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 261.368H336.417L334.918 258.772L336.417 256.176H339.415L340.913 258.772L339.415 261.368Z",
    fill: "#DADADA"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 258.122H342.038L340.54 255.53L342.038 252.935H345.036L346.535 255.53L345.036 258.122Z",
    fill: "#DADADA"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 254.881H347.658L346.159 252.285L347.658 249.689H350.655L352.154 252.285L350.655 254.881Z",
    fill: "#DADADA"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M356.268 251.614H353.292L351.807 249.039L353.292 246.465H356.268L357.754 249.039L356.268 251.614Z",
    fill: "#DADADA"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M394.569 168.703H393.699L393.264 167.95L393.699 167.197H394.569L395.004 167.95L394.569 168.703Z",
    fill: "#DADADA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 164.059H392.634L391.135 161.464L392.634 158.868H395.631L397.13 161.464L395.631 164.059Z",
    fill: "#DADADA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 157.572H392.634L391.135 154.976L392.634 152.38H395.631L397.13 154.976L395.631 157.572Z",
    fill: "#DADADA"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 151.085H392.634L391.135 148.489L392.634 145.894H395.631L397.13 148.489L395.631 151.085Z",
    fill: "#DADADA"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 144.593H392.634L391.135 142.002L392.634 139.406H395.631L397.13 142.002L395.631 144.593Z",
    fill: "#DADADA"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 138.106H392.634L391.135 135.511L392.634 132.919H395.631L397.13 135.511L395.631 138.106Z",
    fill: "#DADADA"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 131.621H392.634L391.135 129.025L392.634 126.434H395.631L397.13 129.025L395.631 131.621Z",
    fill: "#DADADA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 125.133H392.634L391.135 122.537L392.634 119.941H395.631L397.13 122.537L395.631 125.133Z",
    fill: "#DADADA"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 118.646H392.634L391.135 116.05L392.634 113.455H395.631L397.13 116.05L395.631 118.646Z",
    fill: "#DADADA"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 115.405H387.009L385.51 112.81L387.009 110.214H390.011L391.51 112.81L390.011 115.405Z",
    fill: "#DADADA"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 112.159H381.388L379.889 109.563L381.388 106.967H384.385L385.884 109.563L384.385 112.159Z",
    fill: "#DADADA"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 108.913H375.768L374.269 106.322L375.768 103.726H378.765L380.264 106.322L378.765 108.913Z",
    fill: "#DADADA"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 95.9394H353.28L351.781 93.3438L353.28 90.7524H356.277L357.781 93.3438L356.277 95.9394Z",
    fill: "#DADADA"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 89.4525H342.038L340.54 86.8569L342.038 84.2612H345.036L346.535 86.8569L345.036 89.4525Z",
    fill: "#DADADA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 86.2108H336.417L334.918 83.6152L336.417 81.0195H339.415L340.913 83.6152L339.415 86.2108Z",
    fill: "#DADADA"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M333.769 82.9264H330.819L329.346 80.3695L330.819 77.8169H333.769L335.246 80.3695L333.769 82.9264Z",
    fill: "#DADADA"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M328.148 79.6813H325.197L323.72 77.1287L325.197 74.5718H328.148L329.625 77.1287L328.148 79.6813Z",
    fill: "#DADADA"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 76.4784H319.55L318.052 73.8827L319.55 71.2871H322.552L324.051 73.8827L322.552 76.4784Z",
    fill: "#DADADA"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M316.281 72.1146H314.576L313.723 70.6425L314.576 69.166H316.281L317.134 70.6425L316.281 72.1146Z",
    fill: "#DADADA"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 69.9911H308.309L306.811 67.3955L308.309 64.7998H311.307L312.806 67.3955L311.307 69.9911Z",
    fill: "#DADADA"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M305.608 66.6167H302.766L301.34 64.1545L302.766 61.688H305.608L307.034 64.1545L305.608 66.6167Z",
    fill: "#DADADA"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 232.175H195.88L194.381 229.579L195.88 226.983H198.877L200.376 229.579L198.877 232.175Z",
    fill: "#DADADA"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 235.415H201.501L200.002 232.824L201.501 230.228H204.498L205.997 232.824L204.498 235.415Z",
    fill: "#DADADA"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 238.661H207.121L205.622 236.065L207.121 233.469H210.118L211.617 236.065L210.118 238.661Z",
    fill: "#DADADA"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M215.637 241.721H212.85L211.455 239.311L212.85 236.9H215.637L217.028 239.311L215.637 241.721Z",
    fill: "#DADADA"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M310.342 282.404H309.274L308.74 281.478L309.274 280.553H310.342L310.876 281.478L310.342 282.404Z",
    fill: "#DADADA"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 280.827H313.929L312.431 278.231L313.929 275.636H316.927L318.426 278.231L316.927 280.827Z",
    fill: "#DADADA"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 277.587H319.55L318.052 274.992L319.55 272.396H322.552L324.051 274.992L322.552 277.587Z",
    fill: "#DADADA"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 274.341H325.176L323.678 271.746L325.176 269.15H328.174L329.673 271.746L328.174 274.341Z",
    fill: "#DADADA"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 271.096H330.797L329.298 268.504L330.797 265.909H333.795L335.293 268.504L333.795 271.096Z",
    fill: "#DADADA"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 267.854H336.417L334.918 265.259L336.417 262.663H339.415L340.913 265.259L339.415 267.854Z",
    fill: "#DADADA"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 264.608H342.038L340.54 262.017L342.038 259.421H345.036L346.535 262.017L345.036 264.608Z",
    fill: "#DADADA"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M350.364 260.86H347.956L346.75 258.772L347.956 256.685H350.364L351.57 258.772L350.364 260.86Z",
    fill: "#DADADA"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M355.205 256.262H354.357L353.935 255.531L354.357 254.794H355.205L355.627 255.531L355.205 256.262Z",
    fill: "#DADADA"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M372.92 248.006H370.371L369.096 245.798L370.371 243.589H372.92L374.195 245.798L372.92 248.006Z",
    fill: "#DADADA"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M401.247 167.292H398.259L396.764 164.705L398.259 162.122H401.247L402.738 164.705L401.247 167.292Z",
    fill: "#DADADA"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 160.813H398.255L396.756 158.218L398.255 155.622H401.252L402.751 158.218L401.252 160.813Z",
    fill: "#DADADA"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 154.326H398.255L396.756 151.73L398.255 149.135H401.252L402.751 151.73L401.252 154.326Z",
    fill: "#DADADA"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 147.839H398.255L396.756 145.244L398.255 142.648H401.252L402.751 145.244L401.252 147.839Z",
    fill: "#DADADA"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 141.352H398.255L396.756 138.756L398.255 136.161H401.252L402.751 138.756L401.252 141.352Z",
    fill: "#DADADA"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 134.865H398.255L396.756 132.269L398.255 129.674H401.252L402.751 132.269L401.252 134.865Z",
    fill: "#DADADA"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 121.891H398.255L396.756 119.296L398.255 116.7H401.252L402.751 119.296L401.252 121.891Z",
    fill: "#DADADA"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 115.405H398.255L396.756 112.81L398.255 110.214H401.252L402.751 112.81L401.252 115.405Z",
    fill: "#DADADA"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 112.159H392.634L391.135 109.563L392.634 106.967H395.631L397.13 109.563L395.631 112.159Z",
    fill: "#DADADA"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 108.913H387.009L385.51 106.322L387.009 103.726H390.011L391.51 106.322L390.011 108.913Z",
    fill: "#DADADA"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 82.9657H342.038L340.54 80.3701L342.038 77.7744H345.036L346.535 80.3701L345.036 82.9657Z",
    fill: "#DADADA"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 79.7245H336.417L334.918 77.1288L336.417 74.5332H339.415L340.913 77.1288L339.415 79.7245Z",
    fill: "#DADADA"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 76.4784H330.797L329.298 73.8827L330.797 71.2871H333.795L335.293 73.8827L333.795 76.4784Z",
    fill: "#DADADA"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 73.2334H325.176L323.678 70.642L325.176 68.0464H328.174L329.673 70.642L328.174 73.2334Z",
    fill: "#DADADA"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M321.803 68.7008H320.3L319.546 67.3966L320.3 66.0923H321.803L322.556 67.3966L321.803 68.7008Z",
    fill: "#DADADA"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 66.7461H313.929L312.431 64.1547L313.929 61.5591H316.927L318.426 64.1547L316.927 66.7461Z",
    fill: "#DADADA"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 63.5048H308.309L306.811 60.9091L308.309 58.3135H311.307L312.806 60.9091L311.307 63.5048Z",
    fill: "#DADADA"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M198.601 225.209H196.155L194.932 223.091L196.155 220.974H198.601L199.82 223.091L198.601 225.209Z",
    fill: "#DADADA"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 235.415H190.255L188.756 232.824L190.255 230.228H193.256L194.755 232.824L193.256 235.415Z",
    fill: "#DADADA"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 238.661H195.88L194.381 236.065L195.88 233.469H198.877L200.376 236.065L198.877 238.661Z",
    fill: "#DADADA"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 241.906H201.501L200.002 239.31L201.501 236.715H204.498L205.997 239.31L204.498 241.906Z",
    fill: "#DADADA"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 245.148H207.121L205.622 242.553L207.121 239.961H210.118L211.617 242.553L210.118 245.148Z",
    fill: "#DADADA"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 287.315H313.929L312.431 284.719L313.929 282.124H316.927L318.426 284.719L316.927 287.315Z",
    fill: "#DADADA"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 284.074H319.55L318.052 281.478L319.55 278.882H322.552L324.051 281.478L322.552 284.074Z",
    fill: "#DADADA"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 280.827H325.176L323.678 278.231L325.176 275.636H328.174L329.673 278.231L328.174 280.827Z",
    fill: "#DADADA"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 277.587H330.797L329.298 274.992L330.797 272.396H333.795L335.293 274.992L333.795 277.587Z",
    fill: "#DADADA"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 274.341H336.417L334.918 271.746L336.417 269.15H339.415L340.913 271.746L339.415 274.341Z",
    fill: "#DADADA"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 271.096H342.038L340.54 268.504L342.038 265.909H345.036L346.535 268.504L345.036 271.096Z",
    fill: "#DADADA"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M349.395 265.668H348.926L348.689 265.259L348.926 264.85H349.395L349.632 265.259L349.395 265.668Z",
    fill: "#DADADA"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 258.122H364.526L363.027 255.53L364.526 252.935H367.524L369.022 255.53L367.524 258.122Z",
    fill: "#DADADA"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 254.881H370.146L368.647 252.285L370.146 249.689H373.144L374.642 252.285L373.144 254.881Z",
    fill: "#DADADA"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M406.356 169.651H404.393L403.411 167.95L404.393 166.25H406.356L407.338 167.95L406.356 169.651Z",
    fill: "#DADADA"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 164.059H403.875L402.376 161.464L403.875 158.868H406.873L408.371 161.464L406.873 164.059Z",
    fill: "#DADADA"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 157.572H403.875L402.376 154.976L403.875 152.38H406.873L408.371 154.976L406.873 157.572Z",
    fill: "#18A7B9"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 151.085H403.875L402.376 148.489L403.875 145.894H406.873L408.371 148.489L406.873 151.085Z",
    fill: "#DADADA"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 144.593H403.875L402.376 142.002L403.875 139.406H406.873L408.371 142.002L406.873 144.593Z",
    fill: "#DADADA"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 138.106H403.875L402.376 135.511L403.875 132.919H406.873L408.371 135.511L406.873 138.106Z",
    fill: "#DADADA"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 131.621H403.875L402.376 129.025L403.875 126.434H406.873L408.371 129.025L406.873 131.621Z",
    fill: "#DADADA"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 125.133H403.875L402.376 122.537L403.875 119.941H406.873L408.371 122.537L406.873 125.133Z",
    fill: "#DADADA"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 118.646H403.875L402.376 116.05L403.875 113.455H406.873L408.371 116.05L406.873 118.646Z",
    fill: "#DADADA"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 112.159H403.875L402.376 109.563L403.875 106.967H406.873L408.371 109.563L406.873 112.159Z",
    fill: "#DADADA"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 108.913H398.255L396.756 106.322L398.255 103.726H401.252L402.751 106.322L401.252 108.913Z",
    fill: "#18A7B9"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 105.672H392.634L391.135 103.076L392.634 100.48H395.631L397.13 103.076L395.631 105.672Z",
    fill: "#DADADA"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 102.427H387.009L385.51 99.8354L387.009 97.2397H390.011L391.51 99.8354L390.011 102.427Z",
    fill: "#DADADA"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 79.7245H347.658L346.159 77.1288L347.658 74.5332H350.655L352.154 77.1288L350.655 79.7245Z",
    fill: "#DADADA"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M345.036 76.4784H342.038L340.54 73.8827L342.038 71.2871H345.036L346.535 73.8827L345.036 76.4784Z",
    fill: "#DADADA"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 73.2334H336.417L334.918 70.642L336.417 68.0464H339.415L340.913 70.642L339.415 73.2334Z",
    fill: "#DADADA"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 69.9911H330.797L329.298 67.3955L330.797 64.7998H333.795L335.293 67.3955L333.795 69.9911Z",
    fill: "#DADADA"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 66.7461H325.176L323.678 64.1547L325.176 61.5591H328.174L329.673 64.1547L328.174 66.7461Z",
    fill: "#DADADA"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M322.531 63.4743H319.572L318.086 60.9088L319.572 58.3433H322.531L324.012 60.9088L322.531 63.4743Z",
    fill: "#DADADA"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M316.927 60.2588H313.929L312.431 57.6674L313.929 55.0718H316.927L318.426 57.6674L316.927 60.2588Z",
    fill: "#DADADA"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M310.953 56.4063H308.662L307.517 54.4219L308.662 52.4375H310.953L312.099 54.4219L310.953 56.4063Z",
    fill: "#DADADA"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M192.655 221.404H190.859L189.958 219.85L190.859 218.292H192.655L193.555 219.85L192.655 221.404Z",
    fill: "#DADADA"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 228.929H190.255L188.756 226.337L190.255 223.742H193.256L194.755 226.337L193.256 228.929Z",
    fill: "#DADADA"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 238.661H184.634L183.135 236.065L184.634 233.469H187.631L189.13 236.065L187.631 238.661Z",
    fill: "#DADADA"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 241.906H190.255L188.756 239.31L190.255 236.715H193.256L194.755 239.31L193.256 241.906Z",
    fill: "#DADADA"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 248.394H201.501L200.002 245.798L201.501 243.203H204.498L205.997 245.798L204.498 248.394Z",
    fill: "#DADADA"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M209.857 251.179H207.385L206.153 249.039L207.385 246.904H209.857L211.089 249.039L209.857 251.179Z",
    fill: "#DADADA"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M316.73 293.458H314.133L312.833 291.206L314.133 288.959H316.73L318.031 291.206L316.73 293.458Z",
    fill: "#DADADA"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 290.561H319.55L318.052 287.966L319.55 285.37H322.552L324.051 287.966L322.552 290.561Z",
    fill: "#DADADA"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 287.315H325.176L323.678 284.719L325.176 282.124H328.174L329.673 284.719L328.174 287.315Z",
    fill: "#DADADA"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 284.074H330.797L329.298 281.478L330.797 278.882H333.795L335.293 281.478L333.795 284.074Z",
    fill: "#DADADA"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 280.827H336.417L334.918 278.231L336.417 275.636H339.415L340.913 278.231L339.415 280.827Z",
    fill: "#DADADA"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M343.813 275.469H343.262L342.986 274.991L343.262 274.513H343.813L344.089 274.991L343.813 275.469Z",
    fill: "#DADADA"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M360.967 266.236H359.839L359.274 265.259L359.839 264.282H360.967L361.531 265.259L360.967 266.236Z",
    fill: "#DADADA"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 264.608H364.526L363.027 262.017L364.526 259.421H367.524L369.022 262.017L367.524 264.608Z",
    fill: "#DADADA"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M373.045 261.195H370.245L368.846 258.772L370.245 256.348H373.045L374.444 258.772L373.045 261.195Z",
    fill: "#DADADA"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M412.416 173.658H409.574L408.152 171.192L409.574 168.729H412.416L413.842 171.192L412.416 173.658Z",
    fill: "#DADADA"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 167.3H409.496L407.998 164.705L409.496 162.113H412.494L413.993 164.705L412.494 167.3Z",
    fill: "#DADADA"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 160.813H409.496L407.998 158.218L409.496 155.622H412.494L413.993 158.218L412.494 160.813Z",
    fill: "#DADADA"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 154.326H409.496L407.998 151.73L409.496 149.135H412.494L413.993 151.73L412.494 154.326Z",
    fill: "#DADADA"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 147.839H409.496L407.998 145.244L409.496 142.648H412.494L413.993 145.244L412.494 147.839Z",
    fill: "#DADADA"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 141.352H409.496L407.998 138.756L409.496 136.161H412.494L413.993 138.756L412.494 141.352Z",
    fill: "#DADADA"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 134.865H409.496L407.998 132.269L409.496 129.674H412.494L413.993 132.269L412.494 134.865Z",
    fill: "#DADADA"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 128.378H409.496L407.998 125.783L409.496 123.187H412.494L413.993 125.783L412.494 128.378Z",
    fill: "#DADADA"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 121.891H409.496L407.998 119.296L409.496 116.7H412.494L413.993 119.296L412.494 121.891Z",
    fill: "#DADADA"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 115.405H409.496L407.998 112.81L409.496 110.214H412.494L413.993 112.81L412.494 115.405Z",
    fill: "#DADADA"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 108.913H409.496L407.998 106.322L409.496 103.726H412.494L413.993 106.322L412.494 108.913Z",
    fill: "#DADADA"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 105.672H403.875L402.376 103.076L403.875 100.48H406.873L408.371 103.076L406.873 105.672Z",
    fill: "#DADADA"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 102.427H398.255L396.756 99.8354L398.255 97.2397H401.252L402.751 99.8354L401.252 102.427Z",
    fill: "#DADADA"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 99.1849H392.634L391.135 96.5893L392.634 93.9937H395.631L397.13 96.5893L395.631 99.1849Z",
    fill: "#DADADA"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 79.7245H358.905L357.402 77.1288L358.905 74.5332H361.903L363.402 77.1288L361.903 79.7245Z",
    fill: "#DADADA"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 76.4784H353.28L351.781 73.8827L353.28 71.2871H356.277L357.781 73.8827L356.277 76.4784Z",
    fill: "#DADADA"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M350.655 73.2334H347.658L346.159 70.642L347.658 68.0464H350.655L352.154 70.642L350.655 73.2334Z",
    fill: "#DADADA"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M344.713 69.4325H342.361L341.186 67.3964L342.361 65.3604H344.713L345.888 67.3964L344.713 69.4325Z",
    fill: "#DADADA"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M339.415 66.7461H336.417L334.918 64.1547L336.417 61.5591H339.415L340.913 64.1547L339.415 66.7461Z",
    fill: "#DADADA"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 63.5048H330.797L329.298 60.9091L330.797 58.3135H333.795L335.293 60.9091L333.795 63.5048Z",
    fill: "#DADADA"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 60.2588H325.176L323.678 57.6674L325.176 55.0718H328.174L329.673 57.6674L328.174 60.2588Z",
    fill: "#DADADA"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M322.552 57.0179H319.55L318.052 54.4223L319.55 51.8267H322.552L324.051 54.4223L322.552 57.0179Z",
    fill: "#DADADA"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M316.759 53.4795H314.102L312.771 51.1766L314.102 48.8779H316.759L318.086 51.1766L316.759 53.4795Z",
    fill: "#DADADA"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M260.477 66.3416H257.949L256.688 64.1549L257.949 61.9639H260.477L261.739 64.1549L260.477 66.3416Z",
    fill: "#DADADA"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M254.952 69.7465H252.234L250.877 67.3962L252.234 65.0459H254.952L256.308 67.3962L254.952 69.7465Z",
    fill: "#DADADA"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M187.593 115.331H184.677L183.217 112.809L184.677 110.282H187.593L189.049 112.809L187.593 115.331Z",
    fill: "#DADADA"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M187.102 211.797H185.164L184.195 210.118L185.164 208.439H187.102L188.076 210.118L187.102 211.797Z",
    fill: "#DADADA"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M187.585 219.118H184.682L183.23 216.604L184.682 214.09H187.585L189.04 216.604L187.585 219.118Z",
    fill: "#DADADA"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 225.687H184.634L183.135 223.091L184.634 220.496H187.631L189.13 223.091L187.631 225.687Z",
    fill: "#DADADA"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 232.175H184.634L183.135 229.579L184.634 226.983H187.631L189.13 229.579L187.631 232.175Z",
    fill: "#DADADA"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 241.906H179.013L177.515 239.31L179.013 236.715H182.011L183.51 239.31L182.011 241.906Z",
    fill: "#DADADA"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 245.148H184.634L183.135 242.553L184.634 239.961H187.631L189.13 242.553L187.631 245.148Z",
    fill: "#18A7B9"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 248.394H190.255L188.756 245.798L190.255 243.203H193.256L194.755 245.798L193.256 248.394Z",
    fill: "#DADADA"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 251.634H195.88L194.381 249.039L195.88 246.447H198.877L200.376 249.039L198.877 251.634Z",
    fill: "#DADADA"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 254.881H201.501L200.002 252.285L201.501 249.689H204.498L205.997 252.285L204.498 254.881Z",
    fill: "#DADADA"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M208.961 256.121H208.281L207.94 255.531L208.281 254.937H208.961L209.301 255.531L208.961 256.121Z",
    fill: "#DADADA"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M321.863 295.855H320.24L319.43 294.452L320.24 293.049H321.863L322.673 294.452L321.863 295.855Z",
    fill: "#DADADA"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M327.842 293.233H325.503L324.332 291.206L325.503 289.183H327.842L329.013 291.206L327.842 293.233Z",
    fill: "#DADADA"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M333.752 290.488H330.836L329.38 287.965L330.836 285.443H333.752L335.212 287.965L333.752 290.488Z",
    fill: "#DADADA"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M338.188 285.189H337.646L337.375 284.72L337.646 284.254H338.188L338.456 284.72L338.188 285.189Z",
    fill: "#DADADA"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M360.942 272.684H359.861L359.323 271.746L359.861 270.812H360.942L361.485 271.746L360.942 272.684Z",
    fill: "#DADADA"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 271.096H364.526L363.027 268.504L364.526 265.909H367.524L369.022 268.504L367.524 271.096Z",
    fill: "#DADADA"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M372.576 266.868H370.715L369.789 265.258L370.715 263.653H372.576L373.501 265.258L372.576 266.868Z",
    fill: "#DADADA"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M417.077 188.208H416.16L415.699 187.411L416.16 186.619H417.077L417.533 187.411L417.077 188.208Z",
    fill: "#DADADA"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M418.041 183.386H415.194L413.773 180.924L415.194 178.461H418.041L419.462 180.924L418.041 183.386Z",
    fill: "#DADADA"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 177.033H415.118L413.619 174.437L415.118 171.841H418.115L419.614 174.437L418.115 177.033Z",
    fill: "#DADADA"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 170.546H415.118L413.619 167.95L415.118 165.354H418.115L419.614 167.95L418.115 170.546Z",
    fill: "#DADADA"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 164.059H415.118L413.619 161.464L415.118 158.868H418.115L419.614 161.464L418.115 164.059Z",
    fill: "#DADADA"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 157.572H415.118L413.619 154.976L415.118 152.38H418.115L419.614 154.976L418.115 157.572Z",
    fill: "#DADADA"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 151.085H415.118L413.619 148.489L415.118 145.894H418.115L419.614 148.489L418.115 151.085Z",
    fill: "#DADADA"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 144.593H415.118L413.619 142.002L415.118 139.406H418.115L419.614 142.002L418.115 144.593Z",
    fill: "#DADADA"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 138.106H415.118L413.619 135.511L415.118 132.919H418.115L419.614 135.511L418.115 138.106Z",
    fill: "#DADADA"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 131.621H415.118L413.619 129.025L415.118 126.434H418.115L419.614 129.025L418.115 131.621Z",
    fill: "#DADADA"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 125.133H415.118L413.619 122.537L415.118 119.941H418.115L419.614 122.537L418.115 125.133Z",
    fill: "#DADADA"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 118.646H415.118L413.619 116.05L415.118 113.455H418.115L419.614 116.05L418.115 118.646Z",
    fill: "#DADADA"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 112.159H415.118L413.619 109.563L415.118 106.967H418.115L419.614 109.563L418.115 112.159Z",
    fill: "#DADADA"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 105.672H415.118L413.619 103.076L415.118 100.48H418.115L419.614 103.076L418.115 105.672Z",
    fill: "#DADADA"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 102.427H409.496L407.998 99.8354L409.496 97.2397H412.494L413.993 99.8354L412.494 102.427Z",
    fill: "#DADADA"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 99.1849H403.875L402.376 96.5893L403.875 93.9937H406.873L408.371 96.5893L406.873 99.1849Z",
    fill: "#DADADA"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 95.9394H398.255L396.756 93.3438L398.255 90.7524H401.252L402.751 93.3438L401.252 95.9394Z",
    fill: "#DADADA"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 82.9657H375.768L374.269 80.3701L375.768 77.7744H378.765L380.264 80.3701L378.765 82.9657Z",
    fill: "#DADADA"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 73.2334H358.905L357.402 70.642L358.905 68.0464H361.903L363.402 70.642L361.903 73.2334Z",
    fill: "#DADADA"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 69.9911H353.28L351.781 67.3955L353.28 64.7998H356.277L357.781 67.3955L356.277 69.9911Z",
    fill: "#DADADA"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M350.558 66.5745H347.758L346.363 64.1554L347.758 61.7319H350.558L351.957 64.1554L350.558 66.5745Z",
    fill: "#DADADA"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M339.41 60.2498H336.421L334.931 57.6671L336.421 55.0801H339.41L340.9 57.6671L339.41 60.2498Z",
    fill: "#DADADA"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 57.0179H330.797L329.298 54.4223L330.797 51.8267H333.795L335.293 54.4223L333.795 57.0179Z",
    fill: "#DADADA"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M328.174 53.7724H325.176L323.678 51.1768L325.176 48.5854H328.174L329.673 51.1768L328.174 53.7724Z",
    fill: "#DADADA"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M322.35 50.1823H319.753L318.453 47.9354L319.753 45.6841H322.35L323.651 47.9354L322.35 50.1823Z",
    fill: "#DADADA"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M254.887 63.1476H252.299L251.007 60.9093L252.299 58.6709H254.887L256.179 60.9093L254.887 63.1476Z",
    fill: "#DADADA"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M249.448 66.7067H246.498L245.021 64.1541L246.498 61.5972H249.448L250.921 64.1541L249.448 66.7067Z",
    fill: "#DADADA"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M181.846 105.388H179.176L177.841 103.077L179.176 100.765H181.846L183.181 103.077L181.846 105.388Z",
    fill: "#DADADA"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M181.593 111.436H179.431L178.35 109.564L179.431 107.691H181.593L182.674 109.564L181.593 111.436Z",
    fill: "#DADADA"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M181.313 208.258H179.715L178.914 206.872L179.715 205.49H181.313L182.11 206.872L181.313 208.258Z",
    fill: "#DADADA"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 215.954H179.013L177.515 213.358L179.013 210.767H182.011L183.51 213.358L182.011 215.954Z",
    fill: "#DADADA"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 222.441H179.013L177.515 219.85L179.013 217.254H182.011L183.51 219.85L182.011 222.441Z",
    fill: "#DADADA"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 228.929H179.013L177.515 226.337L179.013 223.742H182.011L183.51 226.337L182.011 228.929Z",
    fill: "#DADADA"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 235.415H179.013L177.515 232.824L179.013 230.228H182.011L183.51 232.824L182.011 235.415Z",
    fill: "#DADADA"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 245.148H173.392L171.893 242.553L173.392 239.961H176.389L177.888 242.553L176.389 245.148Z",
    fill: "#DADADA"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 248.394H179.013L177.515 245.798L179.013 243.203H182.011L183.51 245.798L182.011 248.394Z",
    fill: "#DADADA"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 251.634H184.634L183.135 249.039L184.634 246.447H187.631L189.13 249.039L187.631 251.634Z",
    fill: "#DADADA"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 254.881H190.255L188.756 252.285L190.255 249.689H193.256L194.755 252.285L193.256 254.881Z",
    fill: "#DADADA"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 258.122H195.88L194.381 255.53L195.88 252.935H198.877L200.376 255.53L198.877 258.122Z",
    fill: "#DADADA"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 261.368H201.501L200.002 258.772L201.501 256.176H204.498L205.997 258.772L204.498 261.368Z",
    fill: "#DADADA"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M366.688 276.14H365.362L364.694 274.991L365.362 273.842H366.688L367.352 274.991L366.688 276.14Z",
    fill: "#DADADA"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M422.87 198.232H421.612L420.979 197.143L421.612 196.054H422.87L423.498 197.143L422.87 198.232Z",
    fill: "#DADADA"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M423.732 193.239H420.747L419.253 190.656L420.747 188.069H423.732L425.226 190.656L423.732 193.239Z",
    fill: "#DADADA"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 186.761H420.742L419.239 184.17L420.742 181.574H423.74L425.239 184.17L423.74 186.761Z",
    fill: "#DADADA"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 180.274H420.742L419.239 177.679L420.742 175.087H423.74L425.239 177.679L423.74 180.274Z",
    fill: "#DADADA"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 173.787H420.742L419.239 171.191L420.742 168.6H423.74L425.239 171.191L423.74 173.787Z",
    fill: "#DADADA"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 167.3H420.742L419.239 164.705L420.742 162.113H423.74L425.239 164.705L423.74 167.3Z",
    fill: "#DADADA"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 160.813H420.742L419.239 158.218L420.742 155.622H423.74L425.239 158.218L423.74 160.813Z",
    fill: "#DADADA"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 154.326H420.742L419.239 151.73L420.742 149.135H423.74L425.239 151.73L423.74 154.326Z",
    fill: "#DADADA"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 147.839H420.742L419.239 145.244L420.742 142.648H423.74L425.239 145.244L423.74 147.839Z",
    fill: "#DADADA"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 141.352H420.742L419.239 138.756L420.742 136.161H423.74L425.239 138.756L423.74 141.352Z",
    fill: "#DADADA"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 134.865H420.742L419.239 132.269L420.742 129.674H423.74L425.239 132.269L423.74 134.865Z",
    fill: "#DADADA"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 128.378H420.742L419.239 125.783L420.742 123.187H423.74L425.239 125.783L423.74 128.378Z",
    fill: "#DADADA"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 121.891H420.742L419.239 119.296L420.742 116.7H423.74L425.239 119.296L423.74 121.891Z",
    fill: "#DADADA"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 115.405H420.742L419.239 112.81L420.742 110.214H423.74L425.239 112.81L423.74 115.405Z",
    fill: "#DADADA"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 108.913H420.742L419.239 106.322L420.742 103.726H423.74L425.239 106.322L423.74 108.913Z",
    fill: "#DADADA"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 102.427H420.742L419.239 99.8354L420.742 97.2397H423.74L425.239 99.8354L423.74 102.427Z",
    fill: "#DADADA"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 99.1849H415.118L413.619 96.5893L415.118 93.9937H418.115L419.614 96.5893L418.115 99.1849Z",
    fill: "#DADADA"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 95.9394H409.496L407.998 93.3438L409.496 90.7524H412.494L413.993 93.3438L412.494 95.9394Z",
    fill: "#DADADA"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 92.6981H403.875L402.376 90.1025L403.875 87.5068H406.873L408.371 90.1025L406.873 92.6981Z",
    fill: "#DADADA"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M361.903 66.7461H358.905L357.402 64.1547L358.905 61.5591H361.903L363.402 64.1547L361.903 66.7461Z",
    fill: "#DADADA"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M356.251 63.4532H353.31L351.841 60.9092L353.31 58.3652H356.251L357.72 60.9092L356.251 63.4532Z",
    fill: "#DADADA"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M350.571 60.1088H347.75L346.337 57.6681L347.75 55.2231H350.571L351.979 57.6681L350.571 60.1088Z",
    fill: "#DADADA"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M344.966 56.8928H342.107L340.681 54.422L342.107 51.9512H344.966L346.396 54.422L344.966 56.8928Z",
    fill: "#DADADA"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M339.123 53.2644H336.711L335.505 51.1767L336.711 49.0933H339.123L340.329 51.1767L339.123 53.2644Z",
    fill: "#DADADA"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M333.506 50.0315H331.086L329.871 47.9352L331.086 45.8389H333.506L334.716 47.9352L333.506 50.0315Z",
    fill: "#DADADA"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M327.566 46.2395H325.779L324.887 44.6899L325.779 43.1445H327.566L328.462 44.6899L327.566 46.2395Z",
    fill: "#DADADA"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M248.694 58.9165H247.247L246.523 57.6682L247.247 56.4155H248.694L249.418 57.6682L248.694 58.9165Z",
    fill: "#DADADA"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M209.267 81.4889H207.975L207.329 80.3697L207.975 79.2505H209.267L209.913 80.3697L209.267 81.4889Z",
    fill: "#DADADA"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M181.525 98.3413H179.5L178.493 96.5894L179.5 94.8374H181.525L182.537 96.5894L181.525 98.3413Z",
    fill: "#DADADA"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 102.427H173.392L171.893 99.8354L173.392 97.2397H176.389L177.888 99.8354L176.389 102.427Z",
    fill: "#DADADA"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M175.726 107.764H174.055L173.22 106.322L174.055 104.876H175.726L176.562 106.322L175.726 107.764Z",
    fill: "#DADADA"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M175.421 204.548H174.362L173.832 203.631L174.362 202.714H175.421L175.951 203.631L175.421 204.548Z",
    fill: "#DADADA"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 212.713H173.392L171.893 210.118L173.392 207.522H176.389L177.888 210.118L176.389 212.713Z",
    fill: "#DADADA"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 219.2H173.392L171.893 216.604L173.392 214.009H176.389L177.888 216.604L176.389 219.2Z",
    fill: "#DADADA"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 225.687H173.392L171.893 223.091L173.392 220.496H176.389L177.888 223.091L176.389 225.687Z",
    fill: "#DADADA"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 232.175H173.392L171.893 229.579L173.392 226.983H176.389L177.888 229.579L176.389 232.175Z",
    fill: "#DADADA"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 238.661H173.392L171.893 236.065L173.392 233.469H176.389L177.888 236.065L176.389 238.661Z",
    fill: "#DADADA"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 248.394H167.772L166.273 245.798L167.772 243.203H170.769L172.268 245.798L170.769 248.394Z",
    fill: "#DADADA"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 251.634H173.392L171.893 249.039L173.392 246.447H176.389L177.888 249.039L176.389 251.634Z",
    fill: "#DADADA"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 254.881H179.013L177.515 252.285L179.013 249.689H182.011L183.51 252.285L182.011 254.881Z",
    fill: "#DADADA"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 258.122H184.634L183.135 255.53L184.634 252.935H187.631L189.13 255.53L187.631 258.122Z",
    fill: "#DADADA"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 261.368H190.255L188.756 258.772L190.255 256.176H193.256L194.755 258.772L193.256 261.368Z",
    fill: "#DADADA"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 264.608H195.88L194.381 262.017L195.88 259.421H198.877L200.376 262.017L198.877 264.608Z",
    fill: "#DADADA"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 267.854H201.501L200.002 265.259L201.501 262.663H204.498L205.997 265.259L204.498 267.854Z",
    fill: "#DADADA"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M428.955 202.279H426.767L425.673 200.385L426.767 198.495H428.955L430.045 200.385L428.955 202.279Z",
    fill: "#DADADA"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 196.494H426.363L424.865 193.898L426.363 191.303H429.361L430.86 193.898L429.361 196.494Z",
    fill: "#DADADA"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 190.007H426.363L424.865 187.411L426.363 184.815H429.361L430.86 187.411L429.361 190.007Z",
    fill: "#DADADA"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 183.518H426.363L424.865 180.923L426.363 178.327H429.361L430.86 180.923L429.361 183.518Z",
    fill: "#DADADA"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 177.033H426.363L424.865 174.437L426.363 171.841H429.361L430.86 174.437L429.361 177.033Z",
    fill: "#DADADA"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 170.546H426.363L424.865 167.95L426.363 165.354H429.361L430.86 167.95L429.361 170.546Z",
    fill: "#DADADA"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 164.059H426.363L424.865 161.464L426.363 158.868H429.361L430.86 161.464L429.361 164.059Z",
    fill: "#DADADA"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 157.572H426.363L424.865 154.976L426.363 152.38H429.361L430.86 154.976L429.361 157.572Z",
    fill: "#DADADA"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 151.085H426.363L424.865 148.489L426.363 145.894H429.361L430.86 148.489L429.361 151.085Z",
    fill: "#DADADA"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 138.106H426.363L424.865 135.511L426.363 132.919H429.361L430.86 135.511L429.361 138.106Z",
    fill: "#DADADA"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 131.621H426.363L424.865 129.025L426.363 126.434H429.361L430.86 129.025L429.361 131.621Z",
    fill: "#DADADA"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 125.133H426.363L424.865 122.537L426.363 119.941H429.361L430.86 122.537L429.361 125.133Z",
    fill: "#DADADA"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 118.646H426.363L424.865 116.05L426.363 113.455H429.361L430.86 116.05L429.361 118.646Z",
    fill: "#DADADA"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 112.159H426.363L424.865 109.563L426.363 106.967H429.361L430.86 109.563L429.361 112.159Z",
    fill: "#DADADA"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 105.672H426.363L424.865 103.076L426.363 100.48H429.361L430.86 103.076L429.361 105.672Z",
    fill: "#DADADA"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 99.1849H426.363L424.865 96.5893L426.363 93.9937H429.361L430.86 96.5893L429.361 99.1849Z",
    fill: "#DADADA"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 95.9394H420.742L419.239 93.3438L420.742 90.7524H423.74L425.239 93.3438L423.74 95.9394Z",
    fill: "#DADADA"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 92.6981H415.118L413.619 90.1025L415.118 87.5068H418.115L419.614 90.1025L418.115 92.6981Z",
    fill: "#DADADA"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 89.4525H409.496L407.998 86.8569L409.496 84.2612H412.494L413.993 86.8569L412.494 89.4525Z",
    fill: "#DADADA"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 86.2108H403.875L402.376 83.6152L403.875 81.0195H406.873L408.371 83.6152L406.873 86.2108Z",
    fill: "#DADADA"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 82.9657H398.255L396.756 80.3701L398.255 77.7744H401.252L402.751 80.3701L401.252 82.9657Z",
    fill: "#DADADA"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 92.6991H370.146L368.647 90.1035L370.146 87.5078H373.144L374.642 90.1035L373.144 92.6991Z",
    fill: "#DADADA"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M367.525 89.4525H364.527L363.028 86.8569L364.527 84.2612H367.525L369.023 86.8569L367.525 89.4525Z",
    fill: "#DADADA"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 92.6991H381.389L379.89 90.1035L381.389 87.5078H384.386L385.885 90.1035L384.386 92.6991Z",
    fill: "#DADADA"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M378.766 89.4525H375.768L374.27 86.8569L375.768 84.2612H378.766L380.264 86.8569L378.766 89.4525Z",
    fill: "#DADADA"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 86.2108H370.146L368.647 83.6152L370.146 81.0195H373.144L374.642 83.6152L373.144 86.2108Z",
    fill: "#DADADA"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 86.2108H381.389L379.89 83.6152L381.389 81.0195H384.386L385.885 83.6152L384.386 86.2108Z",
    fill: "#DADADA"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 79.7245H370.146L368.647 77.1288L370.146 74.5332H373.144L374.642 77.1288L373.144 79.7245Z",
    fill: "#DADADA"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M384.386 79.7245H381.389L379.89 77.1288L381.389 74.5332H384.386L385.885 77.1288L384.386 79.7245Z",
    fill: "#DADADA"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M378.766 76.4794H375.768L374.27 73.8837L375.768 71.2881H378.766L380.264 73.8837L378.766 76.4794Z",
    fill: "#DADADA"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M378.766 69.9921H375.768L374.27 67.3964L375.768 64.8008H378.766L380.264 67.3964L378.766 69.9921Z",
    fill: "#DADADA"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 66.7461H370.146L368.647 64.1547L370.146 61.5591H373.144L374.642 64.1547L373.144 66.7461Z",
    fill: "#DADADA"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M367.524 63.5048H364.526L363.027 60.9091L364.526 58.3135H367.524L369.022 60.9091L367.524 63.5048Z",
    fill: "#DADADA"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M361.369 59.3331H359.439L358.475 57.6672L359.439 55.9971H361.369L362.329 57.6672L361.369 59.3331Z",
    fill: "#DADADA"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M356.062 56.6388H353.5L352.216 54.4219L353.5 52.2051H356.062L357.346 54.4219L356.062 56.6388Z",
    fill: "#DADADA"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M311.303 31.057H308.314L306.824 28.4742L308.314 25.8872H311.303L312.797 28.4742L311.303 31.057Z",
    fill: "#DADADA"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M305.117 26.8385H303.256L302.33 25.2286L303.256 23.623H305.117L306.042 25.2286L305.117 26.8385Z",
    fill: "#DADADA"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M299.212 23.1059H297.92L297.27 21.9868L297.92 20.8633H299.212L299.858 21.9868L299.212 23.1059Z",
    fill: "#DADADA"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M214.577 71.2191H213.905L213.574 70.642L213.905 70.0605H214.577L214.913 70.642L214.577 71.2191Z",
    fill: "#DADADA"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 76.4784H207.121L205.622 73.8827L207.121 71.2871H210.118L211.617 73.8827L210.118 76.4784Z",
    fill: "#DADADA"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M204.327 79.4268H201.67L200.343 77.1282L201.67 74.8296H204.327L205.658 77.1282L204.327 79.4268Z",
    fill: "#DADADA"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 95.9394H173.392L171.893 93.3438L173.392 90.7524H176.389L177.888 93.3438L176.389 95.9394Z",
    fill: "#DADADA"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 99.1849H167.772L166.273 96.5893L167.772 93.9937H170.769L172.268 96.5893L170.769 99.1849Z",
    fill: "#DADADA"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 105.672H167.772L166.273 103.076L167.772 100.48H170.769L172.268 103.076L170.769 105.672Z",
    fill: "#DADADA"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M170.743 112.116H167.793L166.32 109.563L167.793 107.011H170.743L172.221 109.563L170.743 112.116Z",
    fill: "#DADADA"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M170.549 118.271H167.987L166.708 116.05L167.987 113.833H170.549L171.833 116.05L170.549 118.271Z",
    fill: "#DADADA"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M170.691 202.847H167.844L166.423 200.385L167.844 197.923H170.691L172.112 200.385L170.691 202.847Z",
    fill: "#DADADA"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 209.468H167.772L166.273 206.872L167.772 204.281H170.769L172.268 206.872L170.769 209.468Z",
    fill: "#DADADA"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 215.954H167.772L166.273 213.358L167.772 210.767H170.769L172.268 213.358L170.769 215.954Z",
    fill: "#DADADA"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 222.441H167.772L166.273 219.85L167.772 217.254H170.769L172.268 219.85L170.769 222.441Z",
    fill: "#DADADA"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 228.929H167.772L166.273 226.337L167.772 223.742H170.769L172.268 226.337L170.769 228.929Z",
    fill: "#DADADA"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 235.415H167.772L166.273 232.824L167.772 230.228H170.769L172.268 232.824L170.769 235.415Z",
    fill: "#DADADA"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 241.906H167.772L166.273 239.31L167.772 236.715H170.769L172.268 239.31L170.769 241.906Z",
    fill: "#DADADA"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 251.634H162.151L160.652 249.039L162.151 246.447H165.149L166.647 249.039L165.149 251.634Z",
    fill: "#DADADA"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 264.608H184.634L183.135 262.017L184.634 259.421H187.631L189.13 262.017L187.631 264.608Z",
    fill: "#DADADA"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 267.854H190.255L188.756 265.259L190.255 262.663H193.256L194.755 265.259L193.256 267.854Z",
    fill: "#DADADA"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M198.87 271.087H195.885L194.391 268.504L195.885 265.917H198.87L200.364 268.504L198.87 271.087Z",
    fill: "#DADADA"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M434.547 205.472H432.419L431.355 203.63L432.419 201.788H434.547L435.611 203.63L434.547 205.472Z",
    fill: "#DADADA"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M434.769 186.395H432.194L430.906 184.17L432.194 181.94H434.769L436.057 184.17L434.769 186.395Z",
    fill: "#DADADA"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 180.274H431.984L430.485 177.679L431.984 175.087H434.982L436.48 177.679L434.982 180.274Z",
    fill: "#DADADA"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 173.787H431.984L430.485 171.191L431.984 168.6H434.982L436.48 171.191L434.982 173.787Z",
    fill: "#DADADA"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 167.3H431.984L430.485 164.705L431.984 162.113H434.982L436.48 164.705L434.982 167.3Z",
    fill: "#DADADA"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 160.813H431.984L430.485 158.218L431.984 155.622H434.982L436.48 158.218L434.982 160.813Z",
    fill: "#DADADA"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 134.865H431.984L430.485 132.269L431.984 129.674H434.982L436.48 132.269L434.982 134.865Z",
    fill: "#DADADA"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 128.378H431.984L430.485 125.783L431.984 123.187H434.982L436.48 125.783L434.982 128.378Z",
    fill: "#DADADA"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 121.891H431.984L430.485 119.296L431.984 116.7H434.982L436.48 119.296L434.982 121.891Z",
    fill: "#DADADA"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 115.405H431.984L430.485 112.81L431.984 110.214H434.982L436.48 112.81L434.982 115.405Z",
    fill: "#DADADA"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 108.913H431.984L430.485 106.322L431.984 103.726H434.982L436.48 106.322L434.982 108.913Z",
    fill: "#DADADA"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 102.427H431.984L430.485 99.8354L431.984 97.2397H434.982L436.48 99.8354L434.982 102.427Z",
    fill: "#DADADA"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 95.9394H431.984L430.485 93.3438L431.984 90.7524H434.982L436.48 93.3438L434.982 95.9394Z",
    fill: "#DADADA"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 92.6981H426.363L424.865 90.1025L426.363 87.5068H429.361L430.86 90.1025L429.361 92.6981Z",
    fill: "#DADADA"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 89.4525H420.742L419.239 86.8569L420.742 84.2612H423.74L425.239 86.8569L423.74 89.4525Z",
    fill: "#DADADA"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 86.2108H415.118L413.619 83.6152L415.118 81.0195H418.115L419.614 83.6152L418.115 86.2108Z",
    fill: "#DADADA"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 82.9657H409.496L407.998 80.3701L409.496 77.7744H412.494L413.993 80.3701L412.494 82.9657Z",
    fill: "#DADADA"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 79.7245H403.875L402.376 77.1288L403.875 74.5332H406.873L408.371 77.1288L406.873 79.7245Z",
    fill: "#DADADA"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 76.4784H398.255L396.756 73.8827L398.255 71.2871H401.252L402.751 73.8827L401.252 76.4784Z",
    fill: "#DADADA"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 73.2334H392.634L391.135 70.642L392.634 68.0464H395.631L397.13 70.642L395.631 73.2334Z",
    fill: "#DADADA"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 63.5048H375.768L374.269 60.9091L375.768 58.3135H378.765L380.264 60.9091L378.765 63.5048Z",
    fill: "#DADADA"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M373.144 60.2588H370.146L368.647 57.6674L370.146 55.0718H373.144L374.642 57.6674L373.144 60.2588Z",
    fill: "#DADADA"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M367.037 56.1743H365.013L364 54.4224L365.013 52.6704H367.037L368.045 54.4224L367.037 56.1743Z",
    fill: "#DADADA"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M321.346 28.9831H320.756L320.463 28.4749L320.756 27.9624H321.346L321.639 28.4749L321.346 28.9831Z",
    fill: "#DADADA"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M316.036 26.2794H314.825L314.218 25.2291L314.825 24.1831H316.036L316.639 25.2291L316.036 26.2794Z",
    fill: "#DADADA"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M311.307 24.5791H308.309L306.811 21.9877L308.309 19.3921H311.307L312.806 21.9877L311.307 24.5791Z",
    fill: "#DADADA"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M305.686 21.3378H302.688L301.189 18.7421L302.688 16.1465H305.686L307.184 18.7421L305.686 21.3378Z",
    fill: "#DADADA"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M300.065 18.0918H297.068L295.569 15.4961L297.068 12.9048H300.065L301.564 15.4961L300.065 18.0918Z",
    fill: "#DADADA"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M248.513 45.6279H247.432L246.889 44.6895L247.432 43.7554H248.513L249.051 44.6895L248.513 45.6279Z",
    fill: "#DADADA"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M243.263 49.5102H241.437L240.528 47.9347L241.437 46.355H243.263L244.171 47.9347L243.263 49.5102Z",
    fill: "#DADADA"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M238.21 53.7415H235.247L233.766 51.1759L235.247 48.6147H238.21L239.692 51.1759L238.21 53.7415Z",
    fill: "#DADADA"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M232.607 57.0179H229.609L228.11 54.4223L229.609 51.8267H232.607L234.105 54.4223L232.607 57.0179Z",
    fill: "#DADADA"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M226.978 60.2498H223.993L222.499 57.6671L223.993 55.0801H226.978L228.472 57.6671L226.978 60.2498Z",
    fill: "#DADADA"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M221.245 63.3023H218.484L217.102 60.909L218.484 58.5156H221.245L222.627 60.909L221.245 63.3023Z",
    fill: "#DADADA"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M215.59 66.4831H212.898L211.55 64.1544L212.898 61.8213H215.59L216.934 64.1544L215.59 66.4831Z",
    fill: "#DADADA"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 69.9911H207.121L205.622 67.3955L207.121 64.7998H210.118L211.617 67.3955L210.118 69.9911Z",
    fill: "#DADADA"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 73.2334H201.501L200.002 70.642L201.501 68.0464H204.498L205.997 70.642L204.498 73.2334Z",
    fill: "#18A7B9"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M198.51 75.85H196.241L195.108 73.8828L196.241 71.9199H198.51L199.643 73.8828L198.51 75.85Z",
    fill: "#DADADA"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M176.338 89.3621H173.444L171.997 86.8569L173.444 84.356H176.338L177.781 86.8569L176.338 89.3621Z",
    fill: "#DADADA"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 92.6981H167.772L166.273 90.1025L167.772 87.5068H170.769L172.268 90.1025L170.769 92.6981Z",
    fill: "#DADADA"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 95.9394H162.151L160.652 93.3438L162.151 90.7524H165.149L166.647 93.3438L165.149 95.9394Z",
    fill: "#DADADA"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 102.427H162.151L160.652 99.8354L162.151 97.2397H165.149L166.647 99.8354L165.149 102.427Z",
    fill: "#DADADA"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 108.913H162.151L160.652 106.322L162.151 103.726H165.149L166.647 106.322L165.149 108.913Z",
    fill: "#DADADA"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 115.405H162.151L160.652 112.81L162.151 110.214H165.149L166.647 112.81L165.149 115.405Z",
    fill: "#DADADA"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M164.606 120.953H162.689L161.733 119.296L162.689 117.634H164.606L165.566 119.296L164.606 120.953Z",
    fill: "#DADADA"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M164.894 199.3H162.4L161.156 197.144L162.4 194.987H164.894L166.139 197.144L164.894 199.3Z",
    fill: "#DADADA"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 206.226H162.151L160.652 203.63L162.151 201.035H165.149L166.647 203.63L165.149 206.226Z",
    fill: "#DADADA"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 212.713H162.151L160.652 210.118L162.151 207.522H165.149L166.647 210.118L165.149 212.713Z",
    fill: "#DADADA"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 219.2H162.151L160.652 216.604L162.151 214.009H165.149L166.647 216.604L165.149 219.2Z",
    fill: "#DADADA"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 225.687H162.151L160.652 223.091L162.151 220.496H165.149L166.647 223.091L165.149 225.687Z",
    fill: "#DADADA"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 232.175H162.151L160.652 229.579L162.151 226.983H165.149L166.647 229.579L165.149 232.175Z",
    fill: "#DADADA"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 238.661H162.151L160.652 236.065L162.151 233.469H165.149L166.647 236.065L165.149 238.661Z",
    fill: "#DADADA"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 245.148H162.151L160.652 242.553L162.151 239.961H165.149L166.647 242.553L165.149 245.148Z",
    fill: "#DADADA"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 254.881H156.526L155.027 252.285L156.526 249.689H159.527L161.026 252.285L159.527 254.881Z",
    fill: "#DADADA"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 261.368H167.772L166.273 258.772L167.772 256.176H170.769L172.268 258.772L170.769 261.368Z",
    fill: "#DADADA"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 267.854H179.013L177.515 265.259L179.013 262.663H182.011L183.51 265.259L182.011 267.854Z",
    fill: "#DADADA"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 271.096H184.634L183.135 268.504L184.634 265.909H187.631L189.13 268.504L187.631 271.096Z",
    fill: "#DADADA"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 274.341H190.255L188.756 271.746L190.255 269.15H193.256L194.755 271.746L193.256 274.341Z",
    fill: "#DADADA"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M439.626 181.828H438.584L438.058 180.924L438.584 180.02H439.626L440.151 180.924L439.626 181.828Z",
    fill: "#DADADA"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 177.033H437.604L436.105 174.437L437.604 171.841H440.602L442.1 174.437L440.602 177.033Z",
    fill: "#DADADA"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 170.546H437.604L436.105 167.95L437.604 165.354H440.602L442.1 167.95L440.602 170.546Z",
    fill: "#DADADA"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 164.059H437.604L436.105 161.464L437.604 158.868H440.602L442.1 161.464L440.602 164.059Z",
    fill: "#DADADA"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 157.572H437.604L436.105 154.976L437.604 152.38H440.602L442.1 154.976L440.602 157.572Z",
    fill: "#DADADA"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 144.593H437.604L436.105 142.002L437.604 139.406H440.602L442.1 142.002L440.602 144.593Z",
    fill: "#DADADA"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 131.621H437.604L436.105 129.025L437.604 126.434H440.602L442.1 129.025L440.602 131.621Z",
    fill: "#DADADA"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 125.133H437.604L436.105 122.537L437.604 119.941H440.602L442.1 122.537L440.602 125.133Z",
    fill: "#DADADA"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 118.646H437.604L436.105 116.05L437.604 113.455H440.602L442.1 116.05L440.602 118.646Z",
    fill: "#DADADA"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 112.159H437.604L436.105 109.563L437.604 106.967H440.602L442.1 109.563L440.602 112.159Z",
    fill: "#DADADA"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 105.672H437.604L436.105 103.076L437.604 100.48H440.602L442.1 103.076L440.602 105.672Z",
    fill: "#DADADA"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 99.1849H437.604L436.105 96.5893L437.604 93.9937H440.602L442.1 96.5893L440.602 99.1849Z",
    fill: "#DADADA"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 92.6981H437.604L436.105 90.1025L437.604 87.5068H440.602L442.1 90.1025L440.602 92.6981Z",
    fill: "#DADADA"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 89.4525H431.984L430.485 86.8569L431.984 84.2612H434.982L436.48 86.8569L434.982 89.4525Z",
    fill: "#DADADA"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 86.2108H426.363L424.865 83.6152L426.363 81.0195H429.361L430.86 83.6152L429.361 86.2108Z",
    fill: "#DADADA"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 82.9657H420.742L419.239 80.3701L420.742 77.7744H423.74L425.239 80.3701L423.74 82.9657Z",
    fill: "#DADADA"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 79.7245H415.118L413.619 77.1288L415.118 74.5332H418.115L419.614 77.1288L418.115 79.7245Z",
    fill: "#DADADA"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 76.4784H409.496L407.998 73.8827L409.496 71.2871H412.494L413.993 73.8827L412.494 76.4784Z",
    fill: "#DADADA"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 73.2334H403.875L402.376 70.642L403.875 68.0464H406.873L408.371 70.642L406.873 73.2334Z",
    fill: "#DADADA"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 69.9911H398.255L396.756 67.3955L398.255 64.7998H401.252L402.751 67.3955L401.252 69.9911Z",
    fill: "#DADADA"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 66.7461H392.634L391.135 64.1547L392.634 61.5591H395.631L397.13 64.1547L395.631 66.7461Z",
    fill: "#DADADA"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 63.5048H387.009L385.51 60.9091L387.009 58.3135H390.011L391.51 60.9091L390.011 63.5048Z",
    fill: "#DADADA"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M384.385 60.2588H381.388L379.889 57.6674L381.388 55.0718H384.385L385.884 57.6674L384.385 60.2588Z",
    fill: "#DADADA"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M378.765 57.0179H375.768L374.269 54.4223L375.768 51.8267H378.765L380.264 54.4223L378.765 57.0179Z",
    fill: "#DADADA"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M372.111 51.9811H371.181L370.716 51.1761L371.181 50.3755H372.111L372.576 51.1761L372.111 51.9811Z",
    fill: "#DADADA"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M321.593 22.9213H320.512L319.969 21.9872L320.512 21.0488H321.593L322.136 21.9872L321.593 22.9213Z",
    fill: "#DADADA"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M316.428 20.4726H314.43L313.431 18.7421L314.43 17.0117H316.428L317.427 18.7421L316.428 20.4726Z",
    fill: "#DADADA"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M310.561 16.801H309.054L308.305 15.4967L309.054 14.1968H310.561L311.311 15.4967L310.561 16.801Z",
    fill: "#DADADA"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M304.506 12.8061H303.868L303.55 12.2549L303.868 11.7036H304.506L304.82 12.2549L304.506 12.8061Z",
    fill: "#DADADA"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M249.418 40.7083H246.524L245.081 38.2031L246.524 35.7021H249.418L250.865 38.2031L249.418 40.7083Z",
    fill: "#DADADA"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M237.901 46.7171H235.558L234.391 44.6896L235.558 42.6665H237.901L239.068 44.6896L237.901 46.7171Z",
    fill: "#DADADA"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M232.607 50.5306H229.609L228.11 47.935L229.609 45.3394H232.607L234.105 47.935L232.607 50.5306Z",
    fill: "#DADADA"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 53.7724H223.984L222.485 51.1768L223.984 48.5854H226.986L228.485 51.1768L226.986 53.7724Z",
    fill: "#DADADA"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 57.0179H218.363L216.864 54.4223L218.363 51.8267H221.36L222.859 54.4223L221.36 57.0179Z",
    fill: "#DADADA"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 60.2588H212.742L211.244 57.6674L212.742 55.0718H215.74L217.239 57.6674L215.74 60.2588Z",
    fill: "#DADADA"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 63.5048H207.121L205.622 60.9091L207.121 58.3135H210.118L211.617 60.9091L210.118 63.5048Z",
    fill: "#DADADA"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 66.7461H201.501L200.002 64.1547L201.501 61.5591H204.498L205.997 64.1547L204.498 66.7461Z",
    fill: "#DADADA"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M198.601 69.514H196.155L194.932 67.3962L196.155 65.2783H198.601L199.82 67.3962L198.601 69.514Z",
    fill: "#DADADA"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M175.137 80.8009H174.646L174.396 80.3702L174.646 79.9438H175.137L175.387 80.3702L175.137 80.8009Z",
    fill: "#DADADA"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M170.549 85.8315H167.987L166.708 83.6147L167.987 81.3936H170.549L171.833 83.6147L170.549 85.8315Z",
    fill: "#DADADA"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 89.4525H162.151L160.652 86.8569L162.151 84.2612H165.149L166.647 86.8569L165.149 89.4525Z",
    fill: "#DADADA"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 92.6981H156.526L155.027 90.1025L156.526 87.5068H159.527L161.026 90.1025L159.527 92.6981Z",
    fill: "#DADADA"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 99.1849H156.526L155.027 96.5893L156.526 93.9937H159.527L161.026 96.5893L159.527 99.1849Z",
    fill: "#DADADA"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 105.672H156.526L155.027 103.076L156.526 100.48H159.527L161.026 103.076L159.527 105.672Z",
    fill: "#DADADA"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 112.159H156.526L155.027 109.563L156.526 106.967H159.527L161.026 109.563L159.527 112.159Z",
    fill: "#DADADA"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 118.646H156.526L155.027 116.05L156.526 113.455H159.527L161.026 116.05L159.527 118.646Z",
    fill: "#DADADA"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M158.731 123.76H157.323L156.616 122.537L157.323 121.319H158.731L159.437 122.537L158.731 123.76Z",
    fill: "#DADADA"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M158.322 129.537H157.732L157.439 129.024L157.732 128.516H158.322L158.615 129.024L158.322 129.537Z",
    fill: "#DADADA"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M158.89 182.422H157.164L156.298 180.924L157.164 179.426H158.89L159.756 180.924L158.89 182.422Z",
    fill: "#DADADA"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M158.443 194.622H157.612L157.194 193.898L157.612 193.175H158.443L158.861 193.898L158.443 194.622Z",
    fill: "#DADADA"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 202.98H156.526L155.027 200.385L156.526 197.793H159.527L161.026 200.385L159.527 202.98Z",
    fill: "#DADADA"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 209.468H156.526L155.027 206.872L156.526 204.281H159.527L161.026 206.872L159.527 209.468Z",
    fill: "#DADADA"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 215.954H156.526L155.027 213.358L156.526 210.767H159.527L161.026 213.358L159.527 215.954Z",
    fill: "#DADADA"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 222.441H156.526L155.027 219.85L156.526 217.254H159.527L161.026 219.85L159.527 222.441Z",
    fill: "#DADADA"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 228.929H156.526L155.027 226.337L156.526 223.742H159.527L161.026 226.337L159.527 228.929Z",
    fill: "#DADADA"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 241.906H156.526L155.027 239.31L156.526 236.715H159.527L161.026 239.31L159.527 241.906Z",
    fill: "#DADADA"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 248.394H156.526L155.027 245.798L156.526 243.203H159.527L161.026 245.798L159.527 248.394Z",
    fill: "#DADADA"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 258.122H150.906L149.407 255.53L150.906 252.935H153.903L155.402 255.53L153.903 258.122Z",
    fill: "#DADADA"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 261.368H156.526L155.027 258.772L156.526 256.176H159.527L161.026 258.772L159.527 261.368Z",
    fill: "#DADADA"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 274.341H179.013L177.515 271.746L179.013 269.15H182.011L183.51 271.746L182.011 274.341Z",
    fill: "#DADADA"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 277.587H184.634L183.135 274.992L184.634 272.396H187.631L189.13 274.992L187.631 277.587Z",
    fill: "#DADADA"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 280.827H190.255L188.756 278.231L190.255 275.636H193.256L194.755 278.231L193.256 280.827Z",
    fill: "#DADADA"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 173.787H443.226L441.728 171.191L443.226 168.6H446.224L447.723 171.191L446.224 173.787Z",
    fill: "#DADADA"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 167.3H443.226L441.728 164.705L443.226 162.113H446.224L447.723 164.705L446.224 167.3Z",
    fill: "#DADADA"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 160.813H443.226L441.728 158.218L443.226 155.622H446.224L447.723 158.218L446.224 160.813Z",
    fill: "#DADADA"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 128.378H443.226L441.728 125.783L443.226 123.187H446.224L447.723 125.783L446.224 128.378Z",
    fill: "#DADADA"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 121.891H443.226L441.728 119.296L443.226 116.7H446.224L447.723 119.296L446.224 121.891Z",
    fill: "#DADADA"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 115.405H443.226L441.728 112.81L443.226 110.214H446.224L447.723 112.81L446.224 115.405Z",
    fill: "#DADADA"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 108.913H443.226L441.728 106.322L443.226 103.726H446.224L447.723 106.322L446.224 108.913Z",
    fill: "#DADADA"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 102.427H443.226L441.728 99.8354L443.226 97.2397H446.224L447.723 99.8354L446.224 102.427Z",
    fill: "#DADADA"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 95.9394H443.226L441.728 93.3438L443.226 90.7524H446.224L447.723 93.3438L446.224 95.9394Z",
    fill: "#DADADA"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 89.4525H443.226L441.728 86.8569L443.226 84.2612H446.224L447.723 86.8569L446.224 89.4525Z",
    fill: "#DADADA"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 86.2108H437.604L436.105 83.6152L437.604 81.0195H440.602L442.1 83.6152L440.602 86.2108Z",
    fill: "#DADADA"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 82.9657H431.984L430.485 80.3701L431.984 77.7744H434.982L436.48 80.3701L434.982 82.9657Z",
    fill: "#DADADA"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 79.7245H426.363L424.865 77.1288L426.363 74.5332H429.361L430.86 77.1288L429.361 79.7245Z",
    fill: "#DADADA"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 76.4784H420.742L419.239 73.8827L420.742 71.2871H423.74L425.239 73.8827L423.74 76.4784Z",
    fill: "#DADADA"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 73.2334H415.118L413.619 70.642L415.118 68.0464H418.115L419.614 70.642L418.115 73.2334Z",
    fill: "#DADADA"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 69.9911H409.496L407.998 67.3955L409.496 64.7998H412.494L413.993 67.3955L412.494 69.9911Z",
    fill: "#DADADA"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 66.7461H403.875L402.376 64.1547L403.875 61.5591H406.873L408.371 64.1547L406.873 66.7461Z",
    fill: "#DADADA"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 63.5048H398.255L396.756 60.9091L398.255 58.3135H401.252L402.751 60.9091L401.252 63.5048Z",
    fill: "#DADADA"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 60.2588H392.634L391.135 57.6674L392.634 55.0718H395.631L397.13 57.6674L395.631 60.2588Z",
    fill: "#DADADA"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M390.011 57.0179H387.009L385.51 54.4223L387.009 51.8267H390.011L391.51 54.4223L390.011 57.0179Z",
    fill: "#DADADA"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M384.381 53.7635H381.396L379.902 51.1765L381.396 48.5938H384.381L385.875 51.1765L384.381 53.7635Z",
    fill: "#DADADA"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M377.667 48.6285H376.866L376.466 47.9351L376.866 47.2417H377.667L378.068 47.9351L377.667 48.6285Z",
    fill: "#DADADA"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M372.928 46.9102H370.362L369.083 44.689L370.362 42.4722H372.928L374.208 44.689L372.928 46.9102Z",
    fill: "#DADADA"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M366.481 42.2397H365.564L365.107 41.4477L365.564 40.6514H366.481L366.942 41.4477L366.481 42.2397Z",
    fill: "#DADADA"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M322.29 17.6437H319.809L318.569 15.4957L319.809 13.3521H322.29L323.53 15.4957L322.29 17.6437Z",
    fill: "#DADADA"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M316.699 14.4544H314.158L312.892 12.2548L314.158 10.0552H316.699L317.969 12.2548L316.699 14.4544Z",
    fill: "#DADADA"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M253.915 29.0348H253.269L252.946 28.4749L253.269 27.915H253.915L254.238 28.4749L253.915 29.0348Z",
    fill: "#DADADA"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M249.452 34.2814H246.489L245.007 31.7159L246.489 29.1504H249.452L250.933 31.7159L249.452 34.2814Z",
    fill: "#DADADA"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M243.848 37.557H240.851L239.352 34.9614L240.851 32.3657H243.848L245.347 34.9614L243.848 37.557Z",
    fill: "#DADADA"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M232.607 44.0438H229.609L228.11 41.4482L229.609 38.8525H232.607L234.105 41.4482L232.607 44.0438Z",
    fill: "#DADADA"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 47.2855H223.984L222.485 44.6899L223.984 42.0942H226.986L228.485 44.6899L226.986 47.2855Z",
    fill: "#DADADA"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 50.5306H218.363L216.864 47.935L218.363 45.3394H221.36L222.859 47.935L221.36 50.5306Z",
    fill: "#DADADA"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 53.7724H212.742L211.244 51.1768L212.742 48.5854H215.74L217.239 51.1768L215.74 53.7724Z",
    fill: "#DADADA"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 57.0179H207.121L205.622 54.4223L207.121 51.8267H210.118L211.617 54.4223L210.118 57.0179Z",
    fill: "#DADADA"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 60.2588H201.501L200.002 57.6674L201.501 55.0718H204.498L205.997 57.6674L204.498 60.2588Z",
    fill: "#DADADA"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 63.5048H195.88L194.381 60.9091L195.88 58.3135H198.877L200.376 60.9091L198.877 63.5048Z",
    fill: "#DADADA"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M164.945 82.6213H162.348L161.048 80.37L162.348 78.123H164.945L166.246 80.37L164.945 82.6213Z",
    fill: "#DADADA"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 86.2108H156.526L155.027 83.6152L156.526 81.0195H159.527L161.026 83.6152L159.527 86.2108Z",
    fill: "#DADADA"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 89.4525H150.906L149.407 86.8569L150.906 84.2612H153.903L155.402 86.8569L153.903 89.4525Z",
    fill: "#DADADA"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 95.9394H150.906L149.407 93.3438L150.906 90.7524H153.903L155.402 93.3438L153.903 95.9394Z",
    fill: "#DADADA"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 102.427H150.906L149.407 99.8354L150.906 97.2397H153.903L155.402 99.8354L153.903 102.427Z",
    fill: "#DADADA"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 108.913H150.906L149.407 106.322L150.906 103.726H153.903L155.402 106.322L153.903 108.913Z",
    fill: "#DADADA"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 115.405H150.906L149.407 112.81L150.906 110.214H153.903L155.402 112.81L153.903 115.405Z",
    fill: "#DADADA"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 121.891H150.906L149.407 119.296L150.906 116.7H153.903L155.402 119.296L153.903 121.891Z",
    fill: "#DADADA"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 128.378H150.906L149.407 125.783L150.906 123.187H153.903L155.402 125.783L153.903 128.378Z",
    fill: "#DADADA"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M152.851 171.966H151.96L151.512 171.191L151.96 170.42H152.851L153.299 171.191L152.851 171.966Z",
    fill: "#DADADA"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M153.735 179.981H151.078L149.747 177.678L151.078 175.379H153.735L155.062 177.678L153.735 179.981Z",
    fill: "#DADADA"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 199.74H150.906L149.407 197.144L150.906 194.548H153.903L155.402 197.144L153.903 199.74Z",
    fill: "#DADADA"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 206.226H150.906L149.407 203.63L150.906 201.035H153.903L155.402 203.63L153.903 206.226Z",
    fill: "#DADADA"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 212.713H150.906L149.407 210.118L150.906 207.522H153.903L155.402 210.118L153.903 212.713Z",
    fill: "#DADADA"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 219.2H150.906L149.407 216.604L150.906 214.009H153.903L155.402 216.604L153.903 219.2Z",
    fill: "#DADADA"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 225.687H150.906L149.407 223.091L150.906 220.496H153.903L155.402 223.091L153.903 225.687Z",
    fill: "#DADADA"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 232.175H150.906L149.407 229.579L150.906 226.983H153.903L155.402 229.579L153.903 232.175Z",
    fill: "#DADADA"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 238.661H150.906L149.407 236.065L150.906 233.469H153.903L155.402 236.065L153.903 238.661Z",
    fill: "#DADADA"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 245.148H150.906L149.407 242.553L150.906 239.961H153.903L155.402 242.553L153.903 245.148Z",
    fill: "#DADADA"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 251.634H150.906L149.407 249.039L150.906 246.447H153.903L155.402 249.039L153.903 251.634Z",
    fill: "#DADADA"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M153.704 264.264H151.107L149.807 262.017L151.107 259.766H153.704L155.005 262.017L153.704 264.264Z",
    fill: "#DADADA"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 267.854H156.526L155.027 265.259L156.526 262.663H159.527L161.026 265.259L159.527 267.854Z",
    fill: "#DADADA"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 271.096H162.151L160.652 268.504L162.151 265.909H165.149L166.647 268.504L165.149 271.096Z",
    fill: "#DADADA"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 274.341H167.772L166.273 271.746L167.772 269.15H170.769L172.268 271.746L170.769 274.341Z",
    fill: "#DADADA"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 277.587H173.392L171.893 274.992L173.392 272.396H176.389L177.888 274.992L176.389 277.587Z",
    fill: "#DADADA"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 280.827H179.013L177.515 278.231L179.013 275.636H182.011L183.51 278.231L182.011 280.827Z",
    fill: "#DADADA"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 284.074H184.634L183.135 281.478L184.634 278.882H187.631L189.13 281.478L187.631 284.074Z",
    fill: "#DADADA"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M192.404 285.838H191.107L190.461 284.719L191.107 283.6H192.404L193.05 284.719L192.404 285.838Z",
    fill: "#DADADA"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M451.276 176.047H449.42L448.489 174.437L449.42 172.827H451.276L452.206 174.437L451.276 176.047Z",
    fill: "#DADADA"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 170.546H448.847L447.349 167.95L448.847 165.354H451.845L453.348 167.95L451.845 170.546Z",
    fill: "#DADADA"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 164.059H448.847L447.349 161.464L448.847 158.868H451.845L453.348 161.464L451.845 164.059Z",
    fill: "#DADADA"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 157.572H448.847L447.349 154.976L448.847 152.38H451.845L453.348 154.976L451.845 157.572Z",
    fill: "#DADADA"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 151.085H448.847L447.349 148.489L448.847 145.894H451.845L453.348 148.489L451.845 151.085Z",
    fill: "#DADADA"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 144.593H448.847L447.349 142.002L448.847 139.406H451.845L453.348 142.002L451.845 144.593Z",
    fill: "#DADADA"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 138.106H448.847L447.349 135.511L448.847 132.919H451.845L453.348 135.511L451.845 138.106Z",
    fill: "#DADADA"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 131.621H448.847L447.349 129.025L448.847 126.434H451.845L453.348 129.025L451.845 131.621Z",
    fill: "#DADADA"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 125.133H448.847L447.349 122.537L448.847 119.941H451.845L453.348 122.537L451.845 125.133Z",
    fill: "#DADADA"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 118.646H448.847L447.349 116.05L448.847 113.455H451.845L453.348 116.05L451.845 118.646Z",
    fill: "#DADADA"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 112.159H448.847L447.349 109.563L448.847 106.967H451.845L453.348 109.563L451.845 112.159Z",
    fill: "#DADADA"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 105.672H448.847L447.349 103.076L448.847 100.48H451.845L453.348 103.076L451.845 105.672Z",
    fill: "#DADADA"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 99.1849H448.847L447.349 96.5893L448.847 93.9937H451.845L453.348 96.5893L451.845 99.1849Z",
    fill: "#DADADA"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 92.6981H448.847L447.349 90.1025L448.847 87.5068H451.845L453.348 90.1025L451.845 92.6981Z",
    fill: "#DADADA"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 86.2108H448.847L447.349 83.6152L448.847 81.0195H451.845L453.348 83.6152L451.845 86.2108Z",
    fill: "#DADADA"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 82.9657H443.226L441.728 80.3701L443.226 77.7744H446.224L447.723 80.3701L446.224 82.9657Z",
    fill: "#DADADA"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 79.7245H437.604L436.105 77.1288L437.604 74.5332H440.602L442.1 77.1288L440.602 79.7245Z",
    fill: "#DADADA"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 76.4784H431.984L430.485 73.8827L431.984 71.2871H434.982L436.48 73.8827L434.982 76.4784Z",
    fill: "#DADADA"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 73.2334H426.363L424.865 70.642L426.363 68.0464H429.361L430.86 70.642L429.361 73.2334Z",
    fill: "#DADADA"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 69.9911H420.742L419.239 67.3955L420.742 64.7998H423.74L425.239 67.3955L423.74 69.9911Z",
    fill: "#DADADA"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 66.7461H415.118L413.619 64.1547L415.118 61.5591H418.115L419.614 64.1547L418.115 66.7461Z",
    fill: "#DADADA"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 63.5048H409.496L407.998 60.9091L409.496 58.3135H412.494L413.993 60.9091L412.494 63.5048Z",
    fill: "#DADADA"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M406.873 60.2588H403.875L402.376 57.6674L403.875 55.0718H406.873L408.371 57.6674L406.873 60.2588Z",
    fill: "#DADADA"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M401.252 57.0179H398.255L396.756 54.4223L398.255 51.8267H401.252L402.751 54.4223L401.252 57.0179Z",
    fill: "#DADADA"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M395.631 53.7724H392.634L391.135 51.1768L392.634 48.5854H395.631L397.13 51.1768L395.631 53.7724Z",
    fill: "#DADADA"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M389.196 49.1274H387.822L387.133 47.935L387.822 46.7427H389.196L389.885 47.935L389.196 49.1274Z",
    fill: "#DADADA"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M372.64 39.9247H370.65L369.66 38.2029L370.65 36.4854H372.64L373.63 38.2029L372.64 39.9247Z",
    fill: "#DADADA"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M332.64 16.0995H331.947L331.603 15.4966L331.947 14.8979H332.64L332.989 15.4966L332.64 16.0995Z",
    fill: "#DADADA"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M328.001 14.5533H325.344L324.017 12.2547L325.344 9.95605H328.001L329.332 12.2547L328.001 14.5533Z",
    fill: "#DADADA"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M321.399 9.61271H320.705L320.356 9.00977L320.705 8.41113H321.399L321.743 9.00977L321.399 9.61271Z",
    fill: "#DADADA"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M254.047 22.7699H253.138L252.686 21.9865L253.138 21.1987H254.047L254.499 21.9865L254.047 22.7699Z",
    fill: "#DADADA"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M249.469 27.8241H246.472L244.973 25.2285L246.472 22.6328H249.469L250.968 25.2285L249.469 27.8241Z",
    fill: "#DADADA"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 40.7982H223.984L222.485 38.2026L223.984 35.6069H226.986L228.485 38.2026L226.986 40.7982Z",
    fill: "#DADADA"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 44.0438H218.363L216.864 41.4482L218.363 38.8525H221.36L222.859 41.4482L221.36 44.0438Z",
    fill: "#DADADA"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 47.2855H212.742L211.244 44.6899L212.742 42.0942H215.74L217.239 44.6899L215.74 47.2855Z",
    fill: "#DADADA"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 50.5306H207.121L205.622 47.935L207.121 45.3394H210.118L211.617 47.935L210.118 50.5306Z",
    fill: "#DADADA"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 53.7724H201.501L200.002 51.1768L201.501 48.5854H204.498L205.997 51.1768L204.498 53.7724Z",
    fill: "#DADADA"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M198.305 56.0275H196.448L195.518 54.4219L196.448 52.812H198.305L199.235 54.4219L198.305 56.0275Z",
    fill: "#DADADA"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M175.24 67.9985H174.542L174.198 67.3955L174.542 66.7969H175.24L175.585 67.3955L175.24 67.9985Z",
    fill: "#DADADA"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 73.2334H167.772L166.273 70.642L167.772 68.0464H170.769L172.268 70.642L170.769 73.2334Z",
    fill: "#DADADA"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M164.214 74.86H163.086L162.521 73.8829L163.086 72.9058H164.214L164.778 73.8829L164.214 74.86Z",
    fill: "#DADADA"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 79.7245H156.526L155.027 77.1288L156.526 74.5332H159.527L161.026 77.1288L159.527 79.7245Z",
    fill: "#DADADA"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M153.897 82.9569H150.913L149.418 80.3698L150.913 77.7871H153.897L155.392 80.3698L153.897 82.9569Z",
    fill: "#DADADA"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M147.829 91.915H145.736L144.689 90.1027L145.736 88.2905H147.829L148.876 90.1027L147.829 91.915Z",
    fill: "#DADADA"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M148.204 99.0513H145.361L143.94 96.5892L145.361 94.127H148.204L149.629 96.5892L148.204 99.0513Z",
    fill: "#DADADA"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 105.672H145.284L143.786 103.076L145.284 100.48H148.282L149.781 103.076L148.282 105.672Z",
    fill: "#DADADA"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 112.159H145.284L143.786 109.563L145.284 106.967H148.282L149.781 109.563L148.282 112.159Z",
    fill: "#DADADA"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 131.621H145.284L143.786 129.025L145.284 126.434H148.282L149.781 129.025L148.282 131.621Z",
    fill: "#DADADA"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M148.234 138.025H145.331L143.88 135.511L145.331 133.001H148.234L149.685 135.511L148.234 138.025Z",
    fill: "#DADADA"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M147.037 142.437H146.529L146.279 142.002L146.529 141.563H147.037L147.287 142.002L147.037 142.437Z",
    fill: "#DADADA"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M147.335 168.906H146.232L145.681 167.95L146.232 166.995H147.335L147.89 167.95L147.335 168.906Z",
    fill: "#DADADA"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M147.196 175.148H146.374L145.96 174.438L146.374 173.723H147.196L147.606 174.438L147.196 175.148Z",
    fill: "#DADADA"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M147.619 182.37H145.948L145.117 180.924L145.948 179.478H147.619L148.454 180.924L147.619 182.37Z",
    fill: "#DADADA"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M148.213 196.373H145.353L143.928 193.898L145.353 191.427H148.213L149.638 193.898L148.213 196.373Z",
    fill: "#DADADA"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 202.98H145.284L143.786 200.385L145.284 197.793H148.282L149.781 200.385L148.282 202.98Z",
    fill: "#DADADA"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 209.468H145.284L143.786 206.872L145.284 204.281H148.282L149.781 206.872L148.282 209.468Z",
    fill: "#DADADA"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 215.954H145.284L143.786 213.358L145.284 210.767H148.282L149.781 213.358L148.282 215.954Z",
    fill: "#DADADA"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 222.441H145.284L143.786 219.85L145.284 217.254H148.282L149.781 219.85L148.282 222.441Z",
    fill: "#DADADA"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 228.929H145.284L143.786 226.337L145.284 223.742H148.282L149.781 226.337L148.282 228.929Z",
    fill: "#DADADA"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 235.415H145.284L143.786 232.824L145.284 230.228H148.282L149.781 232.824L148.282 235.415Z",
    fill: "#DADADA"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 241.906H145.284L143.786 239.31L145.284 236.715H148.282L149.781 239.31L148.282 241.906Z",
    fill: "#DADADA"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 248.394H145.284L143.786 245.798L145.284 243.203H148.282L149.781 245.798L148.282 248.394Z",
    fill: "#DADADA"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 254.881H145.284L143.786 252.285L145.284 249.689H148.282L149.781 252.285L148.282 254.881Z",
    fill: "#DADADA"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M153.622 270.61H151.189L149.97 268.505L151.189 266.396H153.622L154.836 268.505L153.622 270.61Z",
    fill: "#DADADA"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 274.341H156.526L155.027 271.746L156.526 269.15H159.527L161.026 271.746L159.527 274.341Z",
    fill: "#DADADA"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 277.587H162.151L160.652 274.992L162.151 272.396H165.149L166.647 274.992L165.149 277.587Z",
    fill: "#DADADA"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 280.827H167.772L166.273 278.231L167.772 275.636H170.769L172.268 278.231L170.769 280.827Z",
    fill: "#DADADA"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 284.074H173.392L171.893 281.478L173.392 278.882H176.389L177.888 281.478L176.389 284.074Z",
    fill: "#DADADA"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M182.011 287.315H179.013L177.515 284.719L179.013 282.124H182.011L183.51 284.719L182.011 287.315Z",
    fill: "#DADADA"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M187.614 290.531H184.651L183.169 287.965L184.651 285.4H187.614L189.095 287.965L187.614 290.531Z",
    fill: "#DADADA"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M457.214 186.326H454.721L453.476 184.17L454.721 182.009H457.214L458.459 184.17L457.214 186.326Z",
    fill: "#DADADA"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 180.274H454.467L452.968 177.679L454.467 175.087H457.469L458.968 177.679L457.469 180.274Z",
    fill: "#DADADA"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 173.787H454.467L452.968 171.191L454.467 168.6H457.469L458.968 171.191L457.469 173.787Z",
    fill: "#DADADA"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 167.3H454.467L452.968 164.705L454.467 162.113H457.469L458.968 164.705L457.469 167.3Z",
    fill: "#DADADA"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 160.813H454.467L452.968 158.218L454.467 155.622H457.469L458.968 158.218L457.469 160.813Z",
    fill: "#DADADA"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 154.326H454.467L452.968 151.73L454.467 149.135H457.469L458.968 151.73L457.469 154.326Z",
    fill: "#DADADA"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 147.839H454.467L452.968 145.244L454.467 142.648H457.469L458.968 145.244L457.469 147.839Z",
    fill: "#DADADA"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 141.352H454.467L452.968 138.756L454.467 136.161H457.469L458.968 138.756L457.469 141.352Z",
    fill: "#DADADA"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 134.865H454.467L452.968 132.269L454.467 129.674H457.469L458.968 132.269L457.469 134.865Z",
    fill: "#DADADA"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 128.378H454.467L452.968 125.783L454.467 123.187H457.469L458.968 125.783L457.469 128.378Z",
    fill: "#DADADA"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 121.891H454.467L452.968 119.296L454.467 116.7H457.469L458.968 119.296L457.469 121.891Z",
    fill: "#DADADA"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 115.405H454.467L452.968 112.81L454.467 110.214H457.469L458.968 112.81L457.469 115.405Z",
    fill: "#DADADA"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 108.913H454.467L452.968 106.322L454.467 103.726H457.469L458.968 106.322L457.469 108.913Z",
    fill: "#DADADA"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 102.427H454.467L452.968 99.8354L454.467 97.2397H457.469L458.968 99.8354L457.469 102.427Z",
    fill: "#DADADA"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 95.9394H454.467L452.968 93.3438L454.467 90.7524H457.469L458.968 93.3438L457.469 95.9394Z",
    fill: "#DADADA"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 89.4525H454.467L452.968 86.8569L454.467 84.2612H457.469L458.968 86.8569L457.469 89.4525Z",
    fill: "#DADADA"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 82.9657H454.467L452.968 80.3701L454.467 77.7744H457.469L458.968 80.3701L457.469 82.9657Z",
    fill: "#DADADA"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 79.7245H448.847L447.349 77.1288L448.847 74.5332H451.845L453.348 77.1288L451.845 79.7245Z",
    fill: "#DADADA"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 76.4784H443.226L441.728 73.8827L443.226 71.2871H446.224L447.723 73.8827L446.224 76.4784Z",
    fill: "#DADADA"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 73.2334H437.604L436.105 70.642L437.604 68.0464H440.602L442.1 70.642L440.602 73.2334Z",
    fill: "#DADADA"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 69.9911H431.984L430.485 67.3955L431.984 64.7998H434.982L436.48 67.3955L434.982 69.9911Z",
    fill: "#DADADA"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 66.7461H426.363L424.865 64.1547L426.363 61.5591H429.361L430.86 64.1547L429.361 66.7461Z",
    fill: "#DADADA"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 63.5048H420.742L419.239 60.9091L420.742 58.3135H423.74L425.239 60.9091L423.74 63.5048Z",
    fill: "#DADADA"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 60.2588H415.118L413.619 57.6674L415.118 55.0718H418.115L419.614 57.6674L418.115 60.2588Z",
    fill: "#DADADA"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 57.0179H409.496L407.998 54.4223L409.496 51.8267H412.494L413.993 54.4223L412.494 57.0179Z",
    fill: "#DADADA"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M406.791 53.6294H403.957L402.54 51.1758L403.957 48.7266H406.791L408.208 51.1758L406.791 53.6294Z",
    fill: "#DADADA"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M401.192 50.428H398.311L396.873 47.9357L398.311 45.4434H401.192L402.635 47.9357L401.192 50.428Z",
    fill: "#DADADA"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M395.489 47.0394H392.772L391.415 44.6892L392.772 42.3389H395.489L396.846 44.6892L395.489 47.0394Z",
    fill: "#DADADA"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M378.537 37.1562H375.996L374.725 34.9609L375.996 32.7612H378.537L379.807 34.9609L378.537 37.1562Z",
    fill: "#DADADA"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M371.891 32.1423H371.4L371.15 31.7159L371.4 31.2896H371.891L372.141 31.7159L371.891 32.1423Z",
    fill: "#DADADA"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M260.642 14.7257H257.786L256.356 12.2549L257.786 9.77979H260.642L262.071 12.2549L260.642 14.7257Z",
    fill: "#DADADA"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M255.004 17.9403H252.183L250.77 15.4954L252.183 13.0547H255.004L256.416 15.4954L255.004 17.9403Z",
    fill: "#DADADA"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M249.469 21.3378H246.472L244.973 18.7421L246.472 16.1465H249.469L250.968 18.7421L249.469 21.3378Z",
    fill: "#DADADA"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M238.229 27.8241H235.231L233.732 25.2285L235.231 22.6328H238.229L239.727 25.2285L238.229 27.8241Z",
    fill: "#DADADA"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 34.3109H223.984L222.485 31.7153L223.984 29.1196H226.986L228.485 31.7153L226.986 34.3109Z",
    fill: "#DADADA"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 37.557H218.363L216.864 34.9614L218.363 32.3657H221.36L222.859 34.9614L221.36 37.557Z",
    fill: "#DADADA"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 40.7982H212.742L211.244 38.2026L212.742 35.6069H215.74L217.239 38.2026L215.74 40.7982Z",
    fill: "#DADADA"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 44.0438H207.121L205.622 41.4482L207.121 38.8525H210.118L211.617 41.4482L210.118 44.0438Z",
    fill: "#DADADA"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 47.2855H201.501L200.002 44.6899L201.501 42.0942H204.498L205.997 44.6899L204.498 47.2855Z",
    fill: "#DADADA"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M198.731 50.2771H196.026L194.674 47.9354L196.026 45.5938H198.731L200.079 47.9354L198.731 50.2771Z",
    fill: "#DADADA"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M181.352 59.1179H179.672L178.833 57.6672L179.672 56.208H181.352L182.192 57.6672L181.352 59.1179Z",
    fill: "#DADADA"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 63.5048H173.392L171.893 60.9091L173.392 58.3135H176.389L177.888 60.9091L176.389 63.5048Z",
    fill: "#DADADA"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 66.7461H167.772L166.273 64.1547L167.772 61.5591H170.769L172.268 64.1547L170.769 66.7461Z",
    fill: "#DADADA"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M165.139 69.9832H162.155L160.66 67.3962L162.155 64.8135H165.139L166.634 67.3962L165.139 69.9832Z",
    fill: "#DADADA"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M153.884 76.4479H150.921L149.44 73.8824L150.921 71.3169H153.884L155.366 73.8824L153.884 76.4479Z",
    fill: "#DADADA"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M142.135 95.0348H140.184L139.211 93.3431L140.184 91.6558H142.135L143.113 93.3431L142.135 95.0348Z",
    fill: "#DADADA"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M142.592 102.306H139.733L138.307 99.8355L139.733 97.3604H142.592L144.018 99.8355L142.592 102.306Z",
    fill: "#DADADA"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 128.378H139.662L138.164 125.783L139.662 123.187H142.66L144.159 125.783L142.66 128.378Z",
    fill: "#DADADA"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 134.865H139.662L138.164 132.269L139.662 129.674H142.66L144.159 132.269L142.66 134.865Z",
    fill: "#DADADA"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 141.352H139.662L138.164 138.756L139.662 136.161H142.66L144.159 138.756L142.66 141.352Z",
    fill: "#DADADA"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M142.385 147.361H139.938L138.715 145.243L139.938 143.125H142.385L143.608 145.243L142.385 147.361Z",
    fill: "#DADADA"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M141.774 172.25H140.551L139.939 171.191L140.551 170.137H141.774L142.385 171.191L141.774 172.25Z",
    fill: "#DADADA"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M141.692 178.595H140.632L140.103 177.678L140.632 176.766H141.692L142.221 177.678L141.692 178.595Z",
    fill: "#DADADA"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M142.358 199.218H139.959L138.762 197.144L139.959 195.069H142.358L143.56 197.144L142.358 199.218Z",
    fill: "#DADADA"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 206.226H139.662L138.164 203.63L139.662 201.035H142.66L144.159 203.63L142.66 206.226Z",
    fill: "#DADADA"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 212.713H139.662L138.164 210.118L139.662 207.522H142.66L144.159 210.118L142.66 212.713Z",
    fill: "#DADADA"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 219.2H139.662L138.164 216.604L139.662 214.009H142.66L144.159 216.604L142.66 219.2Z",
    fill: "#DADADA"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 225.687H139.662L138.164 223.091L139.662 220.496H142.66L144.159 223.091L142.66 225.687Z",
    fill: "#DADADA"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 232.175H139.662L138.164 229.579L139.662 226.983H142.66L144.159 229.579L142.66 232.175Z",
    fill: "#DADADA"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 238.661H139.662L138.164 236.065L139.662 233.469H142.66L144.159 236.065L142.66 238.661Z",
    fill: "#DADADA"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M142.639 245.109H139.685L138.212 242.553L139.685 240H142.639L144.112 242.553L142.639 245.109Z",
    fill: "#DADADA"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M142.045 250.568H140.279L139.396 249.039L140.279 247.516H142.045L142.924 249.039L142.045 250.568Z",
    fill: "#DADADA"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M153.524 276.924H151.289L150.173 274.991L151.289 273.059H153.524L154.639 274.991L153.524 276.924Z",
    fill: "#DADADA"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 280.827H156.526L155.027 278.231L156.526 275.636H159.527L161.026 278.231L159.527 280.827Z",
    fill: "#DADADA"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 284.074H162.151L160.652 281.478L162.151 278.882H165.149L166.647 281.478L165.149 284.074Z",
    fill: "#DADADA"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 287.315H167.772L166.273 284.719L167.772 282.124H170.769L172.268 284.719L170.769 287.315Z",
    fill: "#DADADA"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 290.561H173.392L171.893 287.966L173.392 285.37H176.389L177.888 287.966L176.389 290.561Z",
    fill: "#DADADA"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M182.007 293.793H179.018L177.528 291.206L179.018 288.624H182.007L183.501 291.206L182.007 293.793Z",
    fill: "#DADADA"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M462.659 215.214H460.519L459.451 213.358L460.519 211.507H462.659L463.727 213.358L462.659 215.214Z",
    fill: "#DADADA"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M462.482 208.422H460.695L459.804 206.872L460.695 205.327H462.482L463.378 206.872L462.482 208.422Z",
    fill: "#DADADA"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M462.845 189.58H460.338L459.085 187.41L460.338 185.245H462.845L464.094 187.41L462.845 189.58Z",
    fill: "#DADADA"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 183.518H460.092L458.594 180.923L460.092 178.327H463.09L464.589 180.923L463.09 183.518Z",
    fill: "#DADADA"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 177.033H460.092L458.594 174.437L460.092 171.841H463.09L464.589 174.437L463.09 177.033Z",
    fill: "#DADADA"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 170.546H460.092L458.594 167.95L460.092 165.354H463.09L464.589 167.95L463.09 170.546Z",
    fill: "#DADADA"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 164.059H460.092L458.594 161.464L460.092 158.868H463.09L464.589 161.464L463.09 164.059Z",
    fill: "#DADADA"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 157.572H460.092L458.594 154.976L460.092 152.38H463.09L464.589 154.976L463.09 157.572Z",
    fill: "#DADADA"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 151.085H460.092L458.594 148.489L460.092 145.894H463.09L464.589 148.489L463.09 151.085Z",
    fill: "#DADADA"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 144.593H460.092L458.594 142.002L460.092 139.406H463.09L464.589 142.002L463.09 144.593Z",
    fill: "#DADADA"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 138.106H460.092L458.594 135.511L460.092 132.919H463.09L464.589 135.511L463.09 138.106Z",
    fill: "#DADADA"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 131.621H460.092L458.594 129.025L460.092 126.434H463.09L464.589 129.025L463.09 131.621Z",
    fill: "#DADADA"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 125.133H460.092L458.594 122.537L460.092 119.941H463.09L464.589 122.537L463.09 125.133Z",
    fill: "#DADADA"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 118.646H460.092L458.594 116.05L460.092 113.455H463.09L464.589 116.05L463.09 118.646Z",
    fill: "#DADADA"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 112.159H460.092L458.594 109.563L460.092 106.967H463.09L464.589 109.563L463.09 112.159Z",
    fill: "#DADADA"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 105.672H460.092L458.594 103.076L460.092 100.48H463.09L464.589 103.076L463.09 105.672Z",
    fill: "#DADADA"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 99.1849H460.092L458.594 96.5893L460.092 93.9937H463.09L464.589 96.5893L463.09 99.1849Z",
    fill: "#DADADA"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 92.6981H460.092L458.594 90.1025L460.092 87.5068H463.09L464.589 90.1025L463.09 92.6981Z",
    fill: "#DADADA"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 86.2108H460.092L458.594 83.6152L460.092 81.0195H463.09L464.589 83.6152L463.09 86.2108Z",
    fill: "#DADADA"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 79.7245H460.092L458.594 77.1288L460.092 74.5332H463.09L464.589 77.1288L463.09 79.7245Z",
    fill: "#DADADA"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 76.4784H454.467L452.968 73.8827L454.467 71.2871H457.469L458.968 73.8827L457.469 76.4784Z",
    fill: "#DADADA"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 73.2334H448.847L447.349 70.642L448.847 68.0464H451.845L453.348 70.642L451.845 73.2334Z",
    fill: "#DADADA"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 69.9911H443.226L441.728 67.3955L443.226 64.7998H446.224L447.723 67.3955L446.224 69.9911Z",
    fill: "#DADADA"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 66.7461H437.604L436.105 64.1547L437.604 61.5591H440.602L442.1 64.1547L440.602 66.7461Z",
    fill: "#DADADA"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 63.5048H431.984L430.485 60.9091L431.984 58.3135H434.982L436.48 60.9091L434.982 63.5048Z",
    fill: "#DADADA"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 60.2588H426.363L424.865 57.6674L426.363 55.0718H429.361L430.86 57.6674L429.361 60.2588Z",
    fill: "#DADADA"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 57.0179H420.742L419.239 54.4223L420.742 51.8267H423.74L425.239 54.4223L423.74 57.0179Z",
    fill: "#DADADA"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M418.115 53.7724H415.118L413.619 51.1768L415.118 48.5854H418.115L419.614 51.1768L418.115 53.7724Z",
    fill: "#DADADA"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M412.494 50.5306H409.496L407.998 47.935L409.496 45.3394H412.494L413.993 47.935L412.494 50.5306Z",
    fill: "#DADADA"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M406.184 46.0975H404.565L403.751 44.6899L404.565 43.2866H406.184L406.998 44.6899L406.184 46.0975Z",
    fill: "#DADADA"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M400.112 42.0685H399.397L399.035 41.4483L399.397 40.8281H400.112L400.469 41.4483L400.112 42.0685Z",
    fill: "#DADADA"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M383.916 33.4978H381.861L380.832 31.7157L381.861 29.9336H383.916L384.945 31.7157L383.916 33.4978Z",
    fill: "#DADADA"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M254.591 10.7398H252.592L251.593 9.00933L252.592 7.2832H254.591L255.59 9.00933L254.591 10.7398Z",
    fill: "#DADADA"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M249.469 14.8505H246.472L244.973 12.2548L246.472 9.65918H249.469L250.968 12.2548L249.469 14.8505Z",
    fill: "#DADADA"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 27.8241H223.984L222.485 25.2285L223.984 22.6328H226.986L228.485 25.2285L226.986 27.8241Z",
    fill: "#DADADA"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 31.0659H218.363L216.864 28.4745L218.363 25.8789H221.36L222.859 28.4745L221.36 31.0659Z",
    fill: "#DADADA"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 34.3109H212.742L211.244 31.7153L212.742 29.1196H215.74L217.239 31.7153L215.74 34.3109Z",
    fill: "#DADADA"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 37.557H207.121L205.622 34.9614L207.121 32.3657H210.118L211.617 34.9614L210.118 37.557Z",
    fill: "#DADADA"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 40.7982H201.501L200.002 38.2026L201.501 35.6069H204.498L205.997 38.2026L204.498 40.7982Z",
    fill: "#DADADA"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M198.861 44.0143H195.898L194.416 41.4488L195.898 38.8833H198.861L200.342 41.4488L198.861 44.0143Z",
    fill: "#DADADA"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M192.086 45.2624H191.427L191.1 44.6896L191.427 44.1211H192.086L192.413 44.6896L192.086 45.2624Z",
    fill: "#DADADA"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M175.808 56.0112H173.973L173.056 54.4228L173.973 52.8345H175.808L176.725 54.4228L175.808 56.0112Z",
    fill: "#DADADA"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 60.2588H167.772L166.273 57.6674L167.772 55.0718H170.769L172.268 57.6674L170.769 60.2588Z",
    fill: "#DADADA"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M165.136 63.4837H162.16L160.674 60.9096L162.16 58.3354H165.136L166.621 60.9096L165.136 63.4837Z",
    fill: "#DADADA"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M159.515 66.7283H156.539L155.053 64.1542L156.539 61.5801H159.515L161 64.1542L159.515 66.7283Z",
    fill: "#DADADA"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M152.744 67.9867H152.063L151.723 67.3967L152.063 66.8066H152.744L153.088 67.3967L152.744 67.9867Z",
    fill: "#DADADA"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M147.472 71.8296H146.093L145.409 70.6416L146.093 69.4492H147.472L148.161 70.6416L147.472 71.8296Z",
    fill: "#DADADA"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M135.992 90.8857H135.088L134.636 90.1023L135.088 89.3188H135.992L136.445 90.1023L135.992 90.8857Z",
    fill: "#DADADA"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 99.1849H134.043L132.544 96.5893L134.043 93.9937H137.04L138.539 96.5893L137.04 99.1849Z",
    fill: "#DADADA"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 105.672H134.043L132.544 103.076L134.043 100.48H137.04L138.539 103.076L137.04 105.672Z",
    fill: "#DADADA"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 118.646H134.043L132.544 116.05L134.043 113.455H137.04L138.539 116.05L137.04 118.646Z",
    fill: "#DADADA"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 131.621H134.043L132.544 129.025L134.043 126.434H137.04L138.539 129.025L137.04 131.621Z",
    fill: "#DADADA"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 138.106H134.043L132.544 135.511L134.043 132.919H137.04L138.539 135.511L137.04 138.106Z",
    fill: "#DADADA"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 144.593H134.043L132.544 142.002L134.043 139.406H137.04L138.539 142.002L137.04 144.593Z",
    fill: "#DADADA"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M136.996 151.012H134.081L132.625 148.489L134.081 145.962H136.996L138.456 148.489L136.996 151.012Z",
    fill: "#DADADA"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M136.023 155.812H135.059L134.576 154.977L135.059 154.142H136.023L136.506 154.977L136.023 155.812Z",
    fill: "#DADADA"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M136.798 163.641H134.283L133.025 161.463L134.283 159.285H136.798L138.056 161.463L136.798 163.641Z",
    fill: "#DADADA"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M135.941 175.131H135.14L134.74 174.438L135.14 173.745H135.941L136.338 174.438L135.941 175.131Z",
    fill: "#DADADA"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M136.967 202.86H134.111L132.682 200.385L134.111 197.914H136.967L138.397 200.385L136.967 202.86Z",
    fill: "#DADADA"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M135.963 207.607H135.114L134.692 206.871L135.114 206.14H135.963L136.385 206.871L135.963 207.607Z",
    fill: "#18A7B9"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M136.449 214.939H134.627L133.718 213.359L134.627 211.784H136.449L137.362 213.359L136.449 214.939Z",
    fill: "#DADADA"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 222.441H134.043L132.544 219.85L134.043 217.254H137.04L138.539 219.85L137.04 222.441Z",
    fill: "#DADADA"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M137.027 228.911H134.051L132.565 226.337L134.051 223.763H137.027L138.513 226.337L137.027 228.911Z",
    fill: "#DADADA"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M136.127 233.839H134.951L134.366 232.823L134.951 231.803H136.127L136.717 232.823L136.127 233.839Z",
    fill: "#DADADA"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M136.851 241.579H134.228L132.918 239.31L134.228 237.042H136.851L138.16 239.31L136.851 241.579Z",
    fill: "#DADADA"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M153.256 282.955H151.551L150.698 281.478L151.551 280.002H153.256L154.109 281.478L153.256 282.955Z",
    fill: "#DADADA"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 287.315H156.526L155.027 284.719L156.526 282.124H159.527L161.026 284.719L159.527 287.315Z",
    fill: "#DADADA"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 290.561H162.151L160.652 287.966L162.151 285.37H165.149L166.647 287.966L165.149 290.561Z",
    fill: "#18A7B9"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 293.802H167.772L166.273 291.207L167.772 288.615H170.769L172.268 291.207L170.769 293.802Z",
    fill: "#DADADA"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 297.048H173.392L171.893 294.452L173.392 291.856H176.389L177.888 294.452L176.389 297.048Z",
    fill: "#DADADA"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M181.283 299.028H179.742L178.971 297.698L179.742 296.363H181.283L182.054 297.698L181.283 299.028Z",
    fill: "#DADADA"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M468.194 224.792H466.23L465.248 223.092L466.23 221.392H468.194L469.176 223.092L468.194 224.792Z",
    fill: "#DADADA"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M468.625 219.045H465.8L464.392 216.604L465.8 214.164H468.625L470.033 216.604L468.625 219.045Z",
    fill: "#DADADA"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M467.678 210.922H466.747L466.282 210.117L466.747 209.312H467.678L468.143 210.117L467.678 210.922Z",
    fill: "#DADADA"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M468.646 206.114H465.777L464.343 203.63L465.777 201.146H468.646L470.08 203.63L468.646 206.114Z",
    fill: "#DADADA"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M467.665 197.927H466.761L466.309 197.144L466.761 196.36H467.665L468.117 197.144L467.665 197.927Z",
    fill: "#DADADA"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M468.629 193.106H465.795L464.378 190.657L465.795 188.203H468.629L470.046 190.657L468.629 193.106Z",
    fill: "#DADADA"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 186.761H465.714L464.215 184.17L465.714 181.574H468.711L470.21 184.17L468.711 186.761Z",
    fill: "#DADADA"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 180.274H465.714L464.215 177.679L465.714 175.087H468.711L470.21 177.679L468.711 180.274Z",
    fill: "#DADADA"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 173.787H465.714L464.215 171.191L465.714 168.6H468.711L470.21 171.191L468.711 173.787Z",
    fill: "#DADADA"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 167.3H465.714L464.215 164.705L465.714 162.113H468.711L470.21 164.705L468.711 167.3Z",
    fill: "#DADADA"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 160.813H465.714L464.215 158.218L465.714 155.622H468.711L470.21 158.218L468.711 160.813Z",
    fill: "#DADADA"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 154.326H465.714L464.215 151.73L465.714 149.135H468.711L470.21 151.73L468.711 154.326Z",
    fill: "#DADADA"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 147.839H465.714L464.215 145.244L465.714 142.648H468.711L470.21 145.244L468.711 147.839Z",
    fill: "#DADADA"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 141.352H465.714L464.215 138.756L465.714 136.161H468.711L470.21 138.756L468.711 141.352Z",
    fill: "#DADADA"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 134.865H465.714L464.215 132.269L465.714 129.674H468.711L470.21 132.269L468.711 134.865Z",
    fill: "#DADADA"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 128.378H465.714L464.215 125.783L465.714 123.187H468.711L470.21 125.783L468.711 128.378Z",
    fill: "#DADADA"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 121.891H465.714L464.215 119.296L465.714 116.7H468.711L470.21 119.296L468.711 121.891Z",
    fill: "#DADADA"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 115.405H465.714L464.215 112.81L465.714 110.214H468.711L470.21 112.81L468.711 115.405Z",
    fill: "#DADADA"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 108.913H465.714L464.215 106.322L465.714 103.726H468.711L470.21 106.322L468.711 108.913Z",
    fill: "#DADADA"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 102.427H465.714L464.215 99.8354L465.714 97.2397H468.711L470.21 99.8354L468.711 102.427Z",
    fill: "#DADADA"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 95.9394H465.714L464.215 93.3438L465.714 90.7524H468.711L470.21 93.3438L468.711 95.9394Z",
    fill: "#DADADA"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 89.4525H465.714L464.215 86.8569L465.714 84.2612H468.711L470.21 86.8569L468.711 89.4525Z",
    fill: "#DADADA"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 82.9657H465.714L464.215 80.3701L465.714 77.7744H468.711L470.21 80.3701L468.711 82.9657Z",
    fill: "#DADADA"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 76.4784H465.714L464.215 73.8827L465.714 71.2871H468.711L470.21 73.8827L468.711 76.4784Z",
    fill: "#DADADA"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 73.2334H460.092L458.594 70.642L460.092 68.0464H463.09L464.589 70.642L463.09 73.2334Z",
    fill: "#DADADA"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 69.9911H454.467L452.968 67.3955L454.467 64.7998H457.469L458.968 67.3955L457.469 69.9911Z",
    fill: "#DADADA"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 66.7461H448.847L447.349 64.1547L448.847 61.5591H451.845L453.348 64.1547L451.845 66.7461Z",
    fill: "#DADADA"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 63.5048H443.226L441.728 60.9091L443.226 58.3135H446.224L447.723 60.9091L446.224 63.5048Z",
    fill: "#DADADA"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 60.2588H437.604L436.105 57.6674L437.604 55.0718H440.602L442.1 57.6674L440.602 60.2588Z",
    fill: "#DADADA"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 57.0179H431.984L430.485 54.4223L431.984 51.8267H434.982L436.48 54.4223L434.982 57.0179Z",
    fill: "#DADADA"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 53.7724H426.363L424.865 51.1768L426.363 48.5854H429.361L430.86 51.1768L429.361 53.7724Z",
    fill: "#DADADA"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M418.068 47.2035H415.165L413.714 44.6896L415.165 42.1758H418.068L419.524 44.6896L418.068 47.2035Z",
    fill: "#DADADA"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M411.702 42.6715H410.289L409.587 41.4491L410.289 40.2266H411.702L412.408 41.4491L411.702 42.6715Z",
    fill: "#DADADA"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M389.821 30.7425H387.198L385.889 28.474L387.198 26.2012H389.821L391.13 28.474L389.821 30.7425Z",
    fill: "#DADADA"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M254.616 4.29606H252.57L251.545 2.52259L252.57 0.753418H254.616L255.637 2.52259L254.616 4.29606Z",
    fill: "#DADADA"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M249.331 8.11853H246.613L245.256 5.76825L246.613 3.41797H249.331L250.687 5.76825L249.331 8.11853Z",
    fill: "#DADADA"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M243.021 10.1712H241.678L241.01 9.009L241.678 7.85107H243.021L243.689 9.009L243.021 10.1712Z",
    fill: "#DADADA"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M238.229 14.8505H235.231L233.732 12.2548L235.231 9.65918H238.229L239.727 12.2548L238.229 14.8505Z",
    fill: "#DADADA"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M232.607 18.0918H229.609L228.11 15.4961L229.609 12.9048H232.607L234.105 15.4961L232.607 18.0918Z",
    fill: "#DADADA"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 21.3378H223.984L222.485 18.7421L223.984 16.1465H226.986L228.485 18.7421L226.986 21.3378Z",
    fill: "#DADADA"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 24.5791H218.363L216.864 21.9877L218.363 19.3921H221.36L222.859 21.9877L221.36 24.5791Z",
    fill: "#DADADA"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 27.8241H212.742L211.244 25.2285L212.742 22.6328H215.74L217.239 25.2285L215.74 27.8241Z",
    fill: "#DADADA"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 31.0659H207.121L205.622 28.4745L207.121 25.8789H210.118L211.617 28.4745L210.118 31.0659Z",
    fill: "#DADADA"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 34.3109H201.501L200.002 31.7153L201.501 29.1196H204.498L205.997 31.7153L204.498 34.3109Z",
    fill: "#DADADA"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 37.557H195.88L194.381 34.9614L195.88 32.3657H198.877L200.376 34.9614L198.877 37.557Z",
    fill: "#DADADA"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M192.31 39.1578H191.203L190.652 38.2022L191.203 37.2466H192.31L192.861 38.2022L192.31 39.1578Z",
    fill: "#DADADA"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 53.7724H167.772L166.273 51.1768L167.772 48.5854H170.769L172.268 51.1768L170.769 53.7724Z",
    fill: "#DADADA"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M165.066 56.875H162.232L160.815 54.4214L162.232 51.9678H165.066L166.479 54.4214L165.066 56.875Z",
    fill: "#DADADA"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M142.307 69.3809H140.016L138.871 67.3965L140.016 65.4121H142.307L143.453 67.3965L142.307 69.3809Z",
    fill: "#DADADA"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M130.553 74.98H129.283L128.649 73.8823L129.283 72.7847H130.553L131.186 73.8823L130.553 74.98Z",
    fill: "#DADADA"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M130.378 87.6533H129.46L129.004 86.857L129.46 86.0649H130.378L130.834 86.857L130.378 87.6533Z",
    fill: "#DADADA"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 95.9394H128.417L126.923 93.3438L128.417 90.7524H131.419L132.918 93.3438L131.419 95.9394Z",
    fill: "#DADADA"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 102.427H128.417L126.923 99.8354L128.417 97.2397H131.419L132.918 99.8354L131.419 102.427Z",
    fill: "#DADADA"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 108.913H128.417L126.923 106.322L128.417 103.726H131.419L132.918 106.322L131.419 108.913Z",
    fill: "#DADADA"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 128.378H128.417L126.923 125.783L128.417 123.187H131.419L132.918 125.783L131.419 128.378Z",
    fill: "#DADADA"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 134.865H128.417L126.923 132.269L128.417 129.674H131.419L132.918 132.269L131.419 134.865Z",
    fill: "#DADADA"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 141.352H128.417L126.923 138.756L128.417 136.161H131.419L132.918 138.756L131.419 141.352Z",
    fill: "#DADADA"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 147.839H128.417L126.923 145.244L128.417 142.648H131.419L132.918 145.244L131.419 147.839Z",
    fill: "#DADADA"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 154.326H128.417L126.923 151.73L128.417 149.135H131.419L132.918 151.73L131.419 154.326Z",
    fill: "#DADADA"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M130.485 159.194H129.357L128.788 158.217L129.357 157.24H130.485L131.049 158.217L130.485 159.194Z",
    fill: "#DADADA"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M131.225 173.451H128.615L127.31 171.191L128.615 168.936H131.225L132.53 171.191L131.225 173.451Z",
    fill: "#DADADA"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M130.265 191.256H129.572L129.223 190.657L129.572 190.054H130.265L130.614 190.657L130.265 191.256Z",
    fill: "#DADADA"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M130.378 197.935H129.46L129.004 197.143L129.46 196.347H130.378L130.834 197.143L130.378 197.935Z",
    fill: "#DADADA"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M130.532 204.69H129.309L128.697 203.631L129.309 202.572H130.532L131.143 203.631L130.532 204.69Z",
    fill: "#DADADA"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M153.739 290.276H151.073L149.738 287.965L151.073 285.653H153.739L155.074 287.965L153.739 290.276Z",
    fill: "#DADADA"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 293.802H156.526L155.027 291.207L156.526 288.615H159.527L161.026 291.207L159.527 293.802Z",
    fill: "#DADADA"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 297.048H162.151L160.652 294.452L162.151 291.856H165.149L166.647 294.452L165.149 297.048Z",
    fill: "#DADADA"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 300.29H167.772L166.273 297.698L167.772 295.103H170.769L172.268 297.698L170.769 300.29Z",
    fill: "#DADADA"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 303.535H173.392L171.893 300.939L173.392 298.344H176.389L177.888 300.939L176.389 303.535Z",
    fill: "#DADADA"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M474.246 228.777H471.425L470.012 226.337L471.425 223.892H474.246L475.654 226.337L474.246 228.777Z",
    fill: "#DADADA"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M474.216 222.239H471.451L470.073 219.85L471.451 217.457H474.216L475.598 219.85L474.216 222.239Z",
    fill: "#DADADA"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M473.474 214.469H472.191L471.553 213.359L472.191 212.252H473.474L474.116 213.359L473.474 214.469Z",
    fill: "#DADADA"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M473.574 208.155H472.093L471.352 206.872L472.093 205.594H473.574L474.315 206.872L473.574 208.155Z",
    fill: "#DADADA"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 196.494H471.334L469.835 193.898L471.334 191.303H474.332L475.83 193.898L474.332 196.494Z",
    fill: "#DADADA"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 190.007H471.334L469.835 187.411L471.334 184.815H474.332L475.83 187.411L474.332 190.007Z",
    fill: "#DADADA"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 183.518H471.334L469.835 180.923L471.334 178.327H474.332L475.83 180.923L474.332 183.518Z",
    fill: "#DADADA"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 177.033H471.334L469.835 174.437L471.334 171.841H474.332L475.83 174.437L474.332 177.033Z",
    fill: "#DADADA"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 170.546H471.334L469.835 167.95L471.334 165.354H474.332L475.83 167.95L474.332 170.546Z",
    fill: "#DADADA"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 164.059H471.334L469.835 161.464L471.334 158.868H474.332L475.83 161.464L474.332 164.059Z",
    fill: "#DADADA"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 157.572H471.334L469.835 154.976L471.334 152.38H474.332L475.83 154.976L474.332 157.572Z",
    fill: "#DADADA"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 151.085H471.334L469.835 148.489L471.334 145.894H474.332L475.83 148.489L474.332 151.085Z",
    fill: "#DADADA"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 144.593H471.334L469.835 142.002L471.334 139.406H474.332L475.83 142.002L474.332 144.593Z",
    fill: "#DADADA"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 138.106H471.334L469.835 135.511L471.334 132.919H474.332L475.83 135.511L474.332 138.106Z",
    fill: "#DADADA"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 131.621H471.334L469.835 129.025L471.334 126.434H474.332L475.83 129.025L474.332 131.621Z",
    fill: "#DADADA"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 125.133H471.334L469.835 122.537L471.334 119.941H474.332L475.83 122.537L474.332 125.133Z",
    fill: "#DADADA"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 118.646H471.334L469.835 116.05L471.334 113.455H474.332L475.83 116.05L474.332 118.646Z",
    fill: "#DADADA"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 112.159H471.334L469.835 109.563L471.334 106.967H474.332L475.83 109.563L474.332 112.159Z",
    fill: "#DADADA"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 105.672H471.334L469.835 103.076L471.334 100.48H474.332L475.83 103.076L474.332 105.672Z",
    fill: "#DADADA"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 99.1849H471.334L469.835 96.5893L471.334 93.9937H474.332L475.83 96.5893L474.332 99.1849Z",
    fill: "#DADADA"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 92.6981H471.334L469.835 90.1025L471.334 87.5068H474.332L475.83 90.1025L474.332 92.6981Z",
    fill: "#DADADA"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 86.2108H471.334L469.835 83.6152L471.334 81.0195H474.332L475.83 83.6152L474.332 86.2108Z",
    fill: "#DADADA"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 79.7245H471.334L469.835 77.1288L471.334 74.5332H474.332L475.83 77.1288L474.332 79.7245Z",
    fill: "#DADADA"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 73.2334H471.334L469.835 70.642L471.334 68.0464H474.332L475.83 70.642L474.332 73.2334Z",
    fill: "#DADADA"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 69.9911H465.714L464.215 67.3955L465.714 64.7998H468.711L470.21 67.3955L468.711 69.9911Z",
    fill: "#DADADA"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 66.7461H460.092L458.594 64.1547L460.092 61.5591H463.09L464.589 64.1547L463.09 66.7461Z",
    fill: "#DADADA"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 63.5048H454.467L452.968 60.9091L454.467 58.3135H457.469L458.968 60.9091L457.469 63.5048Z",
    fill: "#DADADA"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 60.2588H448.847L447.349 57.6674L448.847 55.0718H451.845L453.348 57.6674L451.845 60.2588Z",
    fill: "#DADADA"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 57.0179H443.226L441.728 54.4223L443.226 51.8267H446.224L447.723 54.4223L446.224 57.0179Z",
    fill: "#18A7B9"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 53.7724H437.604L436.105 51.1768L437.604 48.5854H440.602L442.1 51.1768L440.602 53.7724Z",
    fill: "#DADADA"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 50.5306H431.984L430.485 47.935L431.984 45.3394H434.982L436.48 47.935L434.982 50.5306Z",
    fill: "#DADADA"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 47.2855H426.363L424.865 44.6899L426.363 42.0942H429.361L430.86 44.6899L429.361 47.2855Z",
    fill: "#DADADA"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 44.0438H420.742L419.239 41.4482L420.742 38.8525H423.74L425.239 41.4482L423.74 44.0438Z",
    fill: "#DADADA"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M417.693 40.0662H415.544L414.467 38.2023L415.544 36.3428H417.693L418.77 38.2023L417.693 40.0662Z",
    fill: "#DADADA"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M377.813 16.4424H376.719L376.172 15.4954L376.719 14.5527H377.813L378.36 15.4954L377.813 16.4424Z",
    fill: "#DADADA"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M243.801 5.0365H240.898L239.447 2.52264L240.898 0.00878906H243.801L245.252 2.52264L243.801 5.0365Z",
    fill: "#DADADA"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M238.15 8.22958H235.307L233.882 5.76738L235.307 3.30518H238.15L239.575 5.76738L238.15 8.22958Z",
    fill: "#DADADA"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M232.607 11.6045H229.609L228.11 9.00881L229.609 6.41748H232.607L234.105 9.00881L232.607 11.6045Z",
    fill: "#DADADA"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 14.8505H223.984L222.485 12.2548L223.984 9.65918H226.986L228.485 12.2548L226.986 14.8505Z",
    fill: "#DADADA"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 18.0918H218.363L216.864 15.4961L218.363 12.9048H221.36L222.859 15.4961L221.36 18.0918Z",
    fill: "#DADADA"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 21.3378H212.742L211.244 18.7421L212.742 16.1465H215.74L217.239 18.7421L215.74 21.3378Z",
    fill: "#DADADA"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 24.5791H207.121L205.622 21.9877L207.121 19.3921H210.118L211.617 21.9877L210.118 24.5791Z",
    fill: "#DADADA"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 27.8241H201.501L200.002 25.2285L201.501 22.6328H204.498L205.997 25.2285L204.498 27.8241Z",
    fill: "#DADADA"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M193.209 34.2294H190.302L188.851 31.7155L190.302 29.2017H193.209L194.66 31.7155L193.209 34.2294Z",
    fill: "#DADADA"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M170.145 46.209H168.392L167.518 44.6895L168.392 43.1743H170.145L171.019 44.6895L170.145 46.209Z",
    fill: "#DADADA"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 50.5306H162.151L160.652 47.935L162.151 45.3394H165.149L166.647 47.935L165.149 50.5306Z",
    fill: "#DADADA"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M159.148 53.1224H156.904L155.78 51.1767L156.904 49.2354H159.148L160.272 51.1767L159.148 53.1224Z",
    fill: "#DADADA"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 60.2588H145.284L143.786 57.6674L145.284 55.0718H148.282L149.781 57.6674L148.282 60.2588Z",
    fill: "#DADADA"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M142.592 63.3839H139.733L138.307 60.9088L139.733 58.438H142.592L144.018 60.9088L142.592 63.3839Z",
    fill: "#DADADA"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 66.7461H134.043L132.544 64.1547L134.043 61.5591H137.04L138.539 64.1547L137.04 66.7461Z",
    fill: "#DADADA"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 69.9911H128.417L126.923 67.3955L128.417 64.7998H131.419L132.918 67.3955L131.419 69.9911Z",
    fill: "#DADADA"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 73.2334H122.796L121.297 70.642L122.796 68.0464H125.794L127.297 70.642L125.794 73.2334Z",
    fill: "#DADADA"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M125.743 79.6297H122.853L121.406 77.1288L122.853 74.6235H125.743L127.19 77.1288L125.743 79.6297Z",
    fill: "#DADADA"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M125.617 85.9052H122.973L121.65 83.6152L122.973 81.3252H125.617L126.943 83.6152L125.617 85.9052Z",
    fill: "#DADADA"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 92.6981H122.796L121.297 90.1025L122.796 87.5068H125.794L127.297 90.1025L125.794 92.6981Z",
    fill: "#DADADA"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 99.1849H122.796L121.297 96.5893L122.796 93.9937H125.794L127.297 96.5893L125.794 99.1849Z",
    fill: "#DADADA"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 105.672H122.796L121.297 103.076L122.796 100.48H125.794L127.297 103.076L125.794 105.672Z",
    fill: "#DADADA"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 112.159H122.796L121.297 109.563L122.796 106.967H125.794L127.297 109.563L125.794 112.159Z",
    fill: "#DADADA"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 118.646H122.796L121.297 116.05L122.796 113.455H125.794L127.297 116.05L125.794 118.646Z",
    fill: "#DADADA"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 125.133H122.796L121.297 122.537L122.796 119.941H125.794L127.297 122.537L125.794 125.133Z",
    fill: "#DADADA"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 131.621H122.796L121.297 129.025L122.796 126.434H125.794L127.297 129.025L125.794 131.621Z",
    fill: "#DADADA"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 138.106H122.796L121.297 135.511L122.796 132.919H125.794L127.297 135.511L125.794 138.106Z",
    fill: "#DADADA"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 144.593H122.796L121.297 142.002L122.796 139.406H125.794L127.297 142.002L125.794 144.593Z",
    fill: "#DADADA"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 151.085H122.796L121.297 148.489L122.796 145.894H125.794L127.297 148.489L125.794 151.085Z",
    fill: "#DADADA"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M125.743 157.477H122.853L121.406 154.976L122.853 152.471H125.743L127.19 154.976L125.743 157.477Z",
    fill: "#DADADA"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 190.007H122.796L121.297 187.411L122.796 184.815H125.794L127.297 187.411L125.794 190.007Z",
    fill: "#DADADA"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 196.494H122.796L121.297 193.898L122.796 191.303H125.794L127.297 193.898L125.794 196.494Z",
    fill: "#DADADA"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M124.536 200.803H124.054L123.812 200.385L124.054 199.967H124.536L124.777 200.385L124.536 200.803Z",
    fill: "#DADADA"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 297.048H150.906L149.407 294.452L150.906 291.856H153.903L155.402 294.452L153.903 297.048Z",
    fill: "#DADADA"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 300.29H156.526L155.027 297.698L156.526 295.103H159.527L161.026 297.698L159.527 300.29Z",
    fill: "#DADADA"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 303.535H162.151L160.652 300.939L162.151 298.344H165.149L166.647 300.939L165.149 303.535Z",
    fill: "#DADADA"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M170.757 306.758H167.785L166.295 304.184L167.785 301.605H170.757L172.243 304.184L170.757 306.758Z",
    fill: "#DADADA"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M479.194 230.86H477.712L476.972 229.578L477.712 228.295H479.194L479.935 229.578L479.194 230.86Z",
    fill: "#DADADA"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M479.835 199.532H477.071L475.692 197.143L477.071 194.75H479.835L481.218 197.143L479.835 199.532Z",
    fill: "#DADADA"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 193.248H476.955L475.457 190.656L476.955 188.061H479.953L481.452 190.656L479.953 193.248Z",
    fill: "#DADADA"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 186.761H476.955L475.457 184.17L476.955 181.574H479.953L481.452 184.17L479.953 186.761Z",
    fill: "#DADADA"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M479.032 178.677H477.882L477.305 177.678L477.882 176.684H479.032L479.609 177.678L479.032 178.677Z",
    fill: "#DADADA"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 173.787H476.955L475.457 171.191L476.955 168.6H479.953L481.452 171.191L479.953 173.787Z",
    fill: "#DADADA"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 167.3H476.955L475.457 164.705L476.955 162.113H479.953L481.452 164.705L479.953 167.3Z",
    fill: "#DADADA"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 160.813H476.955L475.457 158.218L476.955 155.622H479.953L481.452 158.218L479.953 160.813Z",
    fill: "#DADADA"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 154.326H476.955L475.457 151.73L476.955 149.135H479.953L481.452 151.73L479.953 154.326Z",
    fill: "#DADADA"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 147.839H476.955L475.457 145.244L476.955 142.648H479.953L481.452 145.244L479.953 147.839Z",
    fill: "#DADADA"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 141.352H476.955L475.457 138.756L476.955 136.161H479.953L481.452 138.756L479.953 141.352Z",
    fill: "#DADADA"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 134.865H476.955L475.457 132.269L476.955 129.674H479.953L481.452 132.269L479.953 134.865Z",
    fill: "#DADADA"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 128.378H476.955L475.457 125.783L476.955 123.187H479.953L481.452 125.783L479.953 128.378Z",
    fill: "#DADADA"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 121.891H476.955L475.457 119.296L476.955 116.7H479.953L481.452 119.296L479.953 121.891Z",
    fill: "#DADADA"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 108.913H476.955L475.457 106.322L476.955 103.726H479.953L481.452 106.322L479.953 108.913Z",
    fill: "#DADADA"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 102.427H476.955L475.457 99.8354L476.955 97.2397H479.953L481.452 99.8354L479.953 102.427Z",
    fill: "#DADADA"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 95.9394H476.955L475.457 93.3438L476.955 90.7524H479.953L481.452 93.3438L479.953 95.9394Z",
    fill: "#DADADA"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 89.4525H476.955L475.457 86.8569L476.955 84.2612H479.953L481.452 86.8569L479.953 89.4525Z",
    fill: "#DADADA"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 82.9657H476.955L475.457 80.3701L476.955 77.7744H479.953L481.452 80.3701L479.953 82.9657Z",
    fill: "#DADADA"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 76.4784H476.955L475.457 73.8827L476.955 71.2871H479.953L481.452 73.8827L479.953 76.4784Z",
    fill: "#DADADA"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 69.9911H476.955L475.457 67.3955L476.955 64.7998H479.953L481.452 67.3955L479.953 69.9911Z",
    fill: "#DADADA"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 66.7461H471.334L469.835 64.1547L471.334 61.5591H474.332L475.83 64.1547L474.332 66.7461Z",
    fill: "#DADADA"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 63.5048H465.714L464.215 60.9091L465.714 58.3135H468.711L470.21 60.9091L468.711 63.5048Z",
    fill: "#DADADA"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 60.2588H460.092L458.594 57.6674L460.092 55.0718H463.09L464.589 57.6674L463.09 60.2588Z",
    fill: "#DADADA"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 57.0179H454.467L452.968 54.4223L454.467 51.8267H457.469L458.968 54.4223L457.469 57.0179Z",
    fill: "#DADADA"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 53.7724H448.847L447.349 51.1768L448.847 48.5854H451.845L453.348 51.1768L451.845 53.7724Z",
    fill: "#DADADA"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 50.5306H443.226L441.728 47.935L443.226 45.3394H446.224L447.723 47.935L446.224 50.5306Z",
    fill: "#DADADA"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 47.2855H437.604L436.105 44.6899L437.604 42.0942H440.602L442.1 44.6899L440.602 47.2855Z",
    fill: "#DADADA"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 44.0438H431.984L430.485 41.4482L431.984 38.8525H434.982L436.48 41.4482L434.982 44.0438Z",
    fill: "#DADADA"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M429.361 40.7982H426.363L424.865 38.2026L426.363 35.6069H429.361L430.86 38.2026L429.361 40.7982Z",
    fill: "#DADADA"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M423.697 37.4833H420.781L419.321 34.9609L420.781 32.4341H423.697L425.157 34.9609L423.697 37.4833Z",
    fill: "#DADADA"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M232.563 5.04923H229.648L228.192 2.52246L229.648 0H232.563L234.023 2.52246L232.563 5.04923Z",
    fill: "#DADADA"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M226.986 8.36364H223.984L222.485 5.768L223.984 3.17236H226.986L228.485 5.768L226.986 8.36364Z",
    fill: "#DADADA"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M221.36 11.6045H218.363L216.864 9.00881L218.363 6.41748H221.36L222.859 9.00881L221.36 11.6045Z",
    fill: "#DADADA"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M215.74 14.8505H212.742L211.244 12.2548L212.742 9.65918H215.74L217.239 12.2548L215.74 14.8505Z",
    fill: "#DADADA"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M210.118 18.0918H207.121L205.622 15.4961L207.121 12.9048H210.118L211.617 15.4961L210.118 18.0918Z",
    fill: "#DADADA"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 21.3378H201.501L200.002 18.7421L201.501 16.1465H204.498L205.997 18.7421L204.498 21.3378Z",
    fill: "#18A7B9"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 24.5791H195.88L194.381 21.9877L195.88 19.3921H198.877L200.376 21.9877L198.877 24.5791Z",
    fill: "#DADADA"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 27.8241H190.255L188.756 25.2285L190.255 22.6328H193.256L194.755 25.2285L193.256 27.8241Z",
    fill: "#DADADA"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 31.0659H184.634L183.135 28.4745L184.634 25.8789H187.631L189.13 28.4745L187.631 31.0659Z",
    fill: "#DADADA"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M181.084 32.702H179.942L179.37 31.7162L179.942 30.7305H181.084L181.652 31.7162L181.084 32.702Z",
    fill: "#DADADA"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M163.938 41.9484H163.361L163.072 41.4488L163.361 40.9492H163.938L164.222 41.4488L163.938 41.9484Z",
    fill: "#DADADA"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 47.2855H156.526L155.027 44.6899L156.526 42.0942H159.527L161.026 44.6899L159.527 47.2855Z",
    fill: "#DADADA"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 50.5306H150.906L149.407 47.935L150.906 45.3394H153.903L155.402 47.935L153.903 50.5306Z",
    fill: "#DADADA"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M147.958 53.2123H145.607L144.431 51.1763L145.607 49.1445H147.958L149.134 51.1763L147.958 53.2123Z",
    fill: "#DADADA"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M142.027 55.9198H140.296L139.435 54.4218L140.296 52.9238H142.027L142.889 54.4218L142.027 55.9198Z",
    fill: "#DADADA"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M137.04 60.2588H134.043L132.544 57.6674L134.043 55.0718H137.04L138.539 57.6674L137.04 60.2588Z",
    fill: "#DADADA"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M131.419 63.5048H128.417L126.923 60.9091L128.417 58.3135H131.419L132.918 60.9091L131.419 63.5048Z",
    fill: "#DADADA"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 66.7461H122.796L121.297 64.1547L122.796 61.5591H125.794L127.297 64.1547L125.794 66.7461Z",
    fill: "#DADADA"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 69.9911H117.176L115.677 67.3955L117.176 64.7998H120.173L121.672 67.3955L120.173 69.9911Z",
    fill: "#DADADA"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 76.4784H117.176L115.677 73.8827L117.176 71.2871H120.173L121.672 73.8827L120.173 76.4784Z",
    fill: "#DADADA"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 82.9657H117.176L115.677 80.3701L117.176 77.7744H120.173L121.672 80.3701L120.173 82.9657Z",
    fill: "#DADADA"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 89.4525H117.176L115.677 86.8569L117.176 84.2612H120.173L121.672 86.8569L120.173 89.4525Z",
    fill: "#DADADA"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 95.9394H117.176L115.677 93.3438L117.176 90.7524H120.173L121.672 93.3438L120.173 95.9394Z",
    fill: "#DADADA"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 102.427H117.176L115.677 99.8354L117.176 97.2397H120.173L121.672 99.8354L120.173 102.427Z",
    fill: "#DADADA"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 108.913H117.176L115.677 106.322L117.176 103.726H120.173L121.672 106.322L120.173 108.913Z",
    fill: "#DADADA"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 115.405H117.176L115.677 112.81L117.176 110.214H120.173L121.672 112.81L120.173 115.405Z",
    fill: "#DADADA"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 121.891H117.176L115.677 119.296L117.176 116.7H120.173L121.672 119.296L120.173 121.891Z",
    fill: "#DADADA"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 128.378H117.176L115.677 125.783L117.176 123.187H120.173L121.672 125.783L120.173 128.378Z",
    fill: "#DADADA"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 134.865H117.176L115.677 132.269L117.176 129.674H120.173L121.672 132.269L120.173 134.865Z",
    fill: "#DADADA"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 141.352H117.176L115.677 138.756L117.176 136.161H120.173L121.672 138.756L120.173 141.352Z",
    fill: "#DADADA"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 147.839H117.176L115.677 145.244L117.176 142.648H120.173L121.672 145.244L120.173 147.839Z",
    fill: "#DADADA"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 154.326H117.176L115.677 151.73L117.176 149.135H120.173L121.672 151.73L120.173 154.326Z",
    fill: "#DADADA"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M119.687 159.969H117.667L116.655 158.217L117.667 156.47H119.687L120.699 158.217L119.687 159.969Z",
    fill: "#DADADA"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 180.274H117.176L115.677 177.679L117.176 175.087H120.173L121.672 177.679L120.173 180.274Z",
    fill: "#DADADA"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M120.036 186.52H117.319L115.962 184.17L117.319 181.815H120.036L121.393 184.17L120.036 186.52Z",
    fill: "#DADADA"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 303.431H150.965L149.522 300.939L150.965 298.447H153.846L155.285 300.939L153.846 303.431Z",
    fill: "#DADADA"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 306.776H156.526L155.027 304.184L156.526 301.589H159.527L161.026 304.184L159.527 306.776Z",
    fill: "#DADADA"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 310.022H162.151L160.652 307.426L162.151 304.831H165.149L166.647 307.426L165.149 310.022Z",
    fill: "#DADADA"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M169.693 311.403H168.844L168.422 310.672L168.844 309.936H169.693L170.115 310.672L169.693 311.403Z",
    fill: "#DADADA"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M485.517 235.316H482.636L481.198 232.823L482.636 230.331H485.517L486.956 232.823L485.517 235.316Z",
    fill: "#DADADA"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M485.112 221.641H483.04L482.006 219.851L483.04 218.06H485.112L486.145 219.851L485.112 221.641Z",
    fill: "#DADADA"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M484.397 194.458H483.751L483.428 193.898L483.751 193.338H484.397L484.725 193.898L484.397 194.458Z",
    fill: "#DADADA"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M484.613 188.337H483.541L483.007 187.411L483.541 186.486H484.613L485.147 187.411L484.613 188.337Z",
    fill: "#DADADA"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M485.186 182.848H482.968L481.853 180.924L482.968 179H485.186L486.297 180.924L485.186 182.848Z",
    fill: "#DADADA"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M485.5 176.899H482.653L481.232 174.437L482.653 171.975H485.5L486.921 174.437L485.5 176.899Z",
    fill: "#DADADA"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 170.546H482.576L481.078 167.95L482.576 165.354H485.578L487.077 167.95L485.578 170.546Z",
    fill: "#DADADA"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 164.059H482.576L481.078 161.464L482.576 158.868H485.578L487.077 161.464L485.578 164.059Z",
    fill: "#DADADA"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 157.572H482.576L481.078 154.976L482.576 152.38H485.578L487.077 154.976L485.578 157.572Z",
    fill: "#18A7B9"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 151.085H482.576L481.078 148.489L482.576 145.894H485.578L487.077 148.489L485.578 151.085Z",
    fill: "#DADADA"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 144.593H482.576L481.078 142.002L482.576 139.406H485.578L487.077 142.002L485.578 144.593Z",
    fill: "#DADADA"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 138.106H482.576L481.078 135.511L482.576 132.919H485.578L487.077 135.511L485.578 138.106Z",
    fill: "#DADADA"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 131.621H482.576L481.078 129.025L482.576 126.434H485.578L487.077 129.025L485.578 131.621Z",
    fill: "#DADADA"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 125.133H482.576L481.078 122.537L482.576 119.941H485.578L487.077 122.537L485.578 125.133Z",
    fill: "#DADADA"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 118.646H482.576L481.078 116.05L482.576 113.455H485.578L487.077 116.05L485.578 118.646Z",
    fill: "#DADADA"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 112.159H482.576L481.078 109.563L482.576 106.967H485.578L487.077 109.563L485.578 112.159Z",
    fill: "#DADADA"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 105.672H482.576L481.078 103.076L482.576 100.48H485.578L487.077 103.076L485.578 105.672Z",
    fill: "#DADADA"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 99.1849H482.576L481.078 96.5893L482.576 93.9937H485.578L487.077 96.5893L485.578 99.1849Z",
    fill: "#DADADA"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 92.6981H482.576L481.078 90.1025L482.576 87.5068H485.578L487.077 90.1025L485.578 92.6981Z",
    fill: "#DADADA"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 86.2108H482.576L481.078 83.6152L482.576 81.0195H485.578L487.077 83.6152L485.578 86.2108Z",
    fill: "#DADADA"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 79.7245H482.576L481.078 77.1288L482.576 74.5332H485.578L487.077 77.1288L485.578 79.7245Z",
    fill: "#DADADA"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 73.2334H482.576L481.078 70.642L482.576 68.0464H485.578L487.077 70.642L485.578 73.2334Z",
    fill: "#DADADA"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 66.7461H482.576L481.078 64.1547L482.576 61.5591H485.578L487.077 64.1547L485.578 66.7461Z",
    fill: "#DADADA"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 63.5048H476.955L475.457 60.9091L476.955 58.3135H479.953L481.452 60.9091L479.953 63.5048Z",
    fill: "#DADADA"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 60.2588H471.334L469.835 57.6674L471.334 55.0718H474.332L475.83 57.6674L474.332 60.2588Z",
    fill: "#DADADA"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 57.0179H465.714L464.215 54.4223L465.714 51.8267H468.711L470.21 54.4223L468.711 57.0179Z",
    fill: "#DADADA"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 53.7724H460.092L458.594 51.1768L460.092 48.5854H463.09L464.589 51.1768L463.09 53.7724Z",
    fill: "#DADADA"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 50.5306H454.467L452.968 47.935L454.467 45.3394H457.469L458.968 47.935L457.469 50.5306Z",
    fill: "#DADADA"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 47.2855H448.847L447.349 44.6899L448.847 42.0942H451.845L453.348 44.6899L451.845 47.2855Z",
    fill: "#DADADA"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 44.0438H443.226L441.728 41.4482L443.226 38.8525H446.224L447.723 41.4482L446.224 44.0438Z",
    fill: "#DADADA"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M440.602 40.7982H437.604L436.105 38.2026L437.604 35.6069H440.602L442.1 38.2026L440.602 40.7982Z",
    fill: "#DADADA"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M434.982 37.557H431.984L430.485 34.9614L431.984 32.3657H434.982L436.48 34.9614L434.982 37.557Z",
    fill: "#DADADA"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M428.65 33.0806H427.074L426.286 31.7161L427.074 30.3516H428.65L429.438 31.7161L428.65 33.0806Z",
    fill: "#DADADA"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M221.067 4.61007H218.656L217.454 2.52236L218.656 0.438965H221.067L222.273 2.52236L221.067 4.61007Z",
    fill: "#DADADA"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M215.429 7.82129H213.052L211.868 5.76802L213.052 3.71045H215.429L216.618 5.76802L215.429 7.82129Z",
    fill: "#DADADA"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M209.77 11.0064H207.466L206.316 9.00912L207.466 7.01611H209.77L210.925 9.00912L209.77 11.0064Z",
    fill: "#DADADA"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M204.498 14.8505H201.501L200.002 12.2548L201.501 9.65918H204.498L205.997 12.2548L204.498 14.8505Z",
    fill: "#DADADA"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M198.877 18.0918H195.88L194.381 15.4961L195.88 12.9048H198.877L200.376 15.4961L198.877 18.0918Z",
    fill: "#DADADA"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M193.256 21.3378H190.255L188.756 18.7421L190.255 16.1465H193.256L194.755 18.7421L193.256 21.3378Z",
    fill: "#DADADA"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M187.631 24.5791H184.634L183.135 21.9877L184.634 19.3921H187.631L189.13 21.9877L187.631 24.5791Z",
    fill: "#DADADA"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M181.197 26.4087H179.831L179.151 25.2292L179.831 24.0498H181.197L181.877 25.2292L181.197 26.4087Z",
    fill: "#DADADA"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M176.295 30.9066H173.487L172.083 28.4745L173.487 26.0425H176.295L177.699 28.4745L176.295 30.9066Z",
    fill: "#DADADA"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 43.9402H150.965L149.522 41.4479L150.965 38.9556H153.846L155.285 41.4479L153.846 43.9402Z",
    fill: "#DADADA"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M148.282 47.2855H145.284L143.786 44.6899L145.284 42.0942H148.282L149.781 44.6899L148.282 47.2855Z",
    fill: "#DADADA"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 50.5306H139.662L138.164 47.935L139.662 45.3394H142.66L144.159 47.935L142.66 50.5306Z",
    fill: "#DADADA"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M137.031 53.7635H134.046L132.552 51.1765L134.046 48.5938H137.031L138.525 51.1765L137.031 53.7635Z",
    fill: "#DADADA"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M131.264 56.7508H128.572L127.224 54.422L128.572 52.0933H131.264L132.612 54.422L131.264 56.7508Z",
    fill: "#DADADA"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 60.2588H122.796L121.297 57.6674L122.796 55.0718H125.794L127.297 57.6674L125.794 60.2588Z",
    fill: "#DADADA"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M120.173 63.5048H117.176L115.677 60.9091L117.176 58.3135H120.173L121.672 60.9091L120.173 63.5048Z",
    fill: "#DADADA"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 66.7461H111.554L110.055 64.1547L111.554 61.5591H114.551L116.05 64.1547L114.551 66.7461Z",
    fill: "#DADADA"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 73.2334H111.554L110.055 70.642L111.554 68.0464H114.551L116.05 70.642L114.551 73.2334Z",
    fill: "#DADADA"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 79.7245H111.554L110.055 77.1288L111.554 74.5332H114.551L116.05 77.1288L114.551 79.7245Z",
    fill: "#DADADA"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 86.2108H111.554L110.055 83.6152L111.554 81.0195H114.551L116.05 83.6152L114.551 86.2108Z",
    fill: "#DADADA"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 92.6981H111.554L110.055 90.1025L111.554 87.5068H114.551L116.05 90.1025L114.551 92.6981Z",
    fill: "#DADADA"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 99.1849H111.554L110.055 96.5893L111.554 93.9937H114.551L116.05 96.5893L114.551 99.1849Z",
    fill: "#DADADA"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 105.672H111.554L110.055 103.076L111.554 100.48H114.551L116.05 103.076L114.551 105.672Z",
    fill: "#DADADA"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 112.159H111.554L110.055 109.563L111.554 106.967H114.551L116.05 109.563L114.551 112.159Z",
    fill: "#DADADA"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 118.646H111.554L110.055 116.05L111.554 113.455H114.551L116.05 116.05L114.551 118.646Z",
    fill: "#DADADA"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 125.133H111.554L110.055 122.537L111.554 119.941H114.551L116.05 122.537L114.551 125.133Z",
    fill: "#18A7B9"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 131.621H111.554L110.055 129.025L111.554 126.434H114.551L116.05 129.025L114.551 131.621Z",
    fill: "#DADADA"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 138.106H111.554L110.055 135.511L111.554 132.919H114.551L116.05 135.511L114.551 138.106Z",
    fill: "#DADADA"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 144.593H111.554L110.055 142.002L111.554 139.406H114.551L116.05 142.002L114.551 144.593Z",
    fill: "#DADADA"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 151.085H111.554L110.055 148.489L111.554 145.894H114.551L116.05 148.489L114.551 151.085Z",
    fill: "#DADADA"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 157.477H111.606L110.163 154.976L111.606 152.471H114.5L115.947 154.976L114.5 157.477Z",
    fill: "#DADADA"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M113.446 175.118H112.662L112.266 174.438L112.662 173.757H113.446L113.842 174.438L113.446 175.118Z",
    fill: "#DADADA"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M114.539 183.498H111.567L110.077 180.924L111.567 178.35H114.539L116.029 180.924L114.539 183.498Z",
    fill: "#DADADA"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M114.549 189.998H111.56L110.07 187.411L111.56 184.828H114.549L116.039 187.411L114.549 189.998Z",
    fill: "#DADADA"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M153.765 309.776H151.048L149.691 307.426L151.048 305.076H153.765L155.122 307.426L153.765 309.776Z",
    fill: "#DADADA"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 313.264H156.526L155.027 310.672L156.526 308.077H159.527L161.026 310.672L159.527 313.264Z",
    fill: "#DADADA"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 316.509H162.151L160.652 313.913L162.151 311.317H165.149L166.647 313.913L165.149 316.509Z",
    fill: "#DADADA"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M491.079 283.868H488.318L486.936 281.479L488.318 279.085H491.079L492.461 281.479L491.079 283.868Z",
    fill: "#DADADA"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M491.172 277.544H488.222L486.745 274.991L488.222 272.435H491.172L492.65 274.991L491.172 277.544Z",
    fill: "#DADADA"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M490.402 269.722H488.994L488.288 268.504L488.994 267.282H490.402L491.108 268.504L490.402 269.722Z",
    fill: "#DADADA"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M490.928 238.192H488.469L487.242 236.065L488.469 233.939H490.928L492.156 236.065L490.928 238.192Z",
    fill: "#DADADA"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 225.687H488.196L486.697 223.091L488.196 220.496H491.198L492.697 223.091L491.198 225.687Z",
    fill: "#DADADA"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 219.2H488.196L486.697 216.604L488.196 214.009H491.198L492.697 216.604L491.198 219.2Z",
    fill: "#DADADA"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M490.054 210.729H489.347L488.994 210.118L489.347 209.506H490.054L490.402 210.118L490.054 210.729Z",
    fill: "#DADADA"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 173.787H488.196L486.697 171.191L488.196 168.6H491.198L492.697 171.191L491.198 173.787Z",
    fill: "#DADADA"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 167.3H488.196L486.697 164.705L488.196 162.113H491.198L492.697 164.705L491.198 167.3Z",
    fill: "#DADADA"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 160.813H488.196L486.697 158.218L488.196 155.622H491.198L492.697 158.218L491.198 160.813Z",
    fill: "#DADADA"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 154.326H488.196L486.697 151.73L488.196 149.135H491.198L492.697 151.73L491.198 154.326Z",
    fill: "#DADADA"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 147.839H488.196L486.697 145.244L488.196 142.648H491.198L492.697 145.244L491.198 147.839Z",
    fill: "#DADADA"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 141.352H488.196L486.697 138.756L488.196 136.161H491.198L492.697 138.756L491.198 141.352Z",
    fill: "#DADADA"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 134.865H488.196L486.697 132.269L488.196 129.674H491.198L492.697 132.269L491.198 134.865Z",
    fill: "#DADADA"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 128.378H488.196L486.697 125.783L488.196 123.187H491.198L492.697 125.783L491.198 128.378Z",
    fill: "#DADADA"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 121.891H488.196L486.697 119.296L488.196 116.7H491.198L492.697 119.296L491.198 121.891Z",
    fill: "#DADADA"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 115.405H488.196L486.697 112.81L488.196 110.214H491.198L492.697 112.81L491.198 115.405Z",
    fill: "#DADADA"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 108.913H488.196L486.697 106.322L488.196 103.726H491.198L492.697 106.322L491.198 108.913Z",
    fill: "#DADADA"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 102.427H488.196L486.697 99.8354L488.196 97.2397H491.198L492.697 99.8354L491.198 102.427Z",
    fill: "#DADADA"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 95.9394H488.196L486.697 93.3438L488.196 90.7524H491.198L492.697 93.3438L491.198 95.9394Z",
    fill: "#DADADA"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 89.4525H488.196L486.697 86.8569L488.196 84.2612H491.198L492.697 86.8569L491.198 89.4525Z",
    fill: "#DADADA"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 82.9657H488.196L486.697 80.3701L488.196 77.7744H491.198L492.697 80.3701L491.198 82.9657Z",
    fill: "#DADADA"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 76.4784H488.196L486.697 73.8827L488.196 71.2871H491.198L492.697 73.8827L491.198 76.4784Z",
    fill: "#DADADA"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 69.9911H488.196L486.697 67.3955L488.196 64.7998H491.198L492.697 67.3955L491.198 69.9911Z",
    fill: "#DADADA"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 63.5048H488.196L486.697 60.9091L488.196 58.3135H491.198L492.697 60.9091L491.198 63.5048Z",
    fill: "#DADADA"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 60.2588H482.576L481.078 57.6674L482.576 55.0718H485.578L487.077 57.6674L485.578 60.2588Z",
    fill: "#DADADA"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 57.0179H476.955L475.457 54.4223L476.955 51.8267H479.953L481.452 54.4223L479.953 57.0179Z",
    fill: "#DADADA"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 53.7724H471.334L469.835 51.1768L471.334 48.5854H474.332L475.83 51.1768L474.332 53.7724Z",
    fill: "#DADADA"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 50.5306H465.714L464.215 47.935L465.714 45.3394H468.711L470.21 47.935L468.711 50.5306Z",
    fill: "#DADADA"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M463.09 47.2855H460.092L458.594 44.6899L460.092 42.0942H463.09L464.589 44.6899L463.09 47.2855Z",
    fill: "#DADADA"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M457.469 44.0438H454.467L452.968 41.4482L454.467 38.8525H457.469L458.968 41.4482L457.469 44.0438Z",
    fill: "#DADADA"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 40.7982H448.847L447.349 38.2026L448.847 35.6069H451.845L453.348 38.2026L451.845 40.7982Z",
    fill: "#DADADA"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 37.557H443.226L441.728 34.9614L443.226 32.3657H446.224L447.723 34.9614L446.224 37.557Z",
    fill: "#DADADA"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M440.586 34.2814H437.623L436.142 31.7159L437.623 29.1504H440.586L442.068 31.7159L440.586 34.2814Z",
    fill: "#DADADA"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M433.905 29.2061H433.061L432.635 28.4744L433.061 27.7383H433.905L434.327 28.4744L433.905 29.2061Z",
    fill: "#DADADA"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M198.452 10.8728H196.303L195.226 9.00898L196.303 7.14941H198.452L199.528 9.00898L198.452 10.8728Z",
    fill: "#DADADA"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M193.17 14.7089H190.341L188.924 12.2553L190.341 9.80176H193.17L194.587 12.2553L193.17 14.7089Z",
    fill: "#DADADA"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M187.623 18.0739H184.647L183.162 15.4955L184.647 12.9214H187.623L189.109 15.4955L187.623 18.0739Z",
    fill: "#DADADA"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M180.994 19.5764H180.03L179.547 18.7413L180.03 17.9062H180.994L181.477 18.7413L180.994 19.5764Z",
    fill: "#DADADA"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M175.959 23.838H173.823L172.751 21.9871L173.823 20.1318H175.959L177.032 21.9871L175.959 23.838Z",
    fill: "#DADADA"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M159.179 33.7087H156.875L155.721 31.7157L156.875 29.7227H159.179L160.333 31.7157L159.179 33.7087Z",
    fill: "#DADADA"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M153.704 37.2087H151.107L149.807 34.9617L151.107 32.7104H153.704L155.005 34.9617L153.704 37.2087Z",
    fill: "#DADADA"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M147.704 39.7994H145.861L144.935 38.2025L145.861 36.6055H147.704L148.63 38.2025L147.704 39.7994Z",
    fill: "#DADADA"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M142.609 43.9495H139.715L138.268 41.4486L139.715 38.9434H142.609L144.052 41.4486L142.609 43.9495Z",
    fill: "#DADADA"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M131.359 50.428H128.478L127.039 47.9357L128.478 45.4434H131.359L132.797 47.9357L131.359 50.428Z",
    fill: "#DADADA"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M119.118 55.1835H118.235L117.795 54.4216L118.235 53.6597H119.118L119.557 54.4216L119.118 55.1835Z",
    fill: "#DADADA"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 60.2588H111.554L110.055 57.6674L111.554 55.0718H114.551L116.05 57.6674L114.551 60.2588Z",
    fill: "#DADADA"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 63.5048H105.933L104.435 60.9091L105.933 58.3135H108.931L110.43 60.9091L108.931 63.5048Z",
    fill: "#DADADA"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 69.9911H105.933L104.435 67.3955L105.933 64.7998H108.931L110.43 67.3955L108.931 69.9911Z",
    fill: "#DADADA"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 76.4784H105.933L104.435 73.8827L105.933 71.2871H108.931L110.43 73.8827L108.931 76.4784Z",
    fill: "#DADADA"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 82.9657H105.933L104.435 80.3701L105.933 77.7744H108.931L110.43 80.3701L108.931 82.9657Z",
    fill: "#DADADA"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 89.4525H105.933L104.435 86.8569L105.933 84.2612H108.931L110.43 86.8569L108.931 89.4525Z",
    fill: "#DADADA"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 95.9394H105.933L104.435 93.3438L105.933 90.7524H108.931L110.43 93.3438L108.931 95.9394Z",
    fill: "#DADADA"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 102.427H105.933L104.435 99.8354L105.933 97.2397H108.931L110.43 99.8354L108.931 102.427Z",
    fill: "#DADADA"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 108.913H105.933L104.435 106.322L105.933 103.726H108.931L110.43 106.322L108.931 108.913Z",
    fill: "#DADADA"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 115.405H105.933L104.435 112.81L105.933 110.214H108.931L110.43 112.81L108.931 115.405Z",
    fill: "#DADADA"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 121.891H105.933L104.435 119.296L105.933 116.7H108.931L110.43 119.296L108.931 121.891Z",
    fill: "#DADADA"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 128.378H105.933L104.435 125.783L105.933 123.187H108.931L110.43 125.783L108.931 128.378Z",
    fill: "#DADADA"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 134.865H105.933L104.435 132.269L105.933 129.674H108.931L110.43 132.269L108.931 134.865Z",
    fill: "#DADADA"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 141.352H105.933L104.435 138.756L105.933 136.161H108.931L110.43 138.756L108.931 141.352Z",
    fill: "#DADADA"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 147.839H105.933L104.435 145.244L105.933 142.648H108.931L110.43 145.244L108.931 147.839Z",
    fill: "#DADADA"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 154.326H105.933L104.435 151.73L105.933 149.135H108.931L110.43 151.73L108.931 154.326Z",
    fill: "#DADADA"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M108.556 160.163H106.308L105.184 158.218L106.308 156.276H108.556L109.676 158.218L108.556 160.163Z",
    fill: "#DADADA"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M107.804 178.32H107.063L106.692 177.678L107.063 177.041H107.804L108.174 177.678L107.804 178.32Z",
    fill: "#DADADA"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M108.919 186.744H105.947L104.457 184.17L105.947 181.596H108.919L110.405 184.17L108.919 186.744Z",
    fill: "#DADADA"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 316.509H150.906L149.407 313.913L150.906 311.317H153.903L155.402 313.913L153.903 316.509Z",
    fill: "#DADADA"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 319.755H156.526L155.027 317.159L156.526 314.563H159.527L161.026 317.159L159.527 319.755Z",
    fill: "#DADADA"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M165.139 322.987H162.155L160.66 320.4L162.155 317.817H165.139L166.634 320.4L165.139 322.987Z",
    fill: "#DADADA"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M490.457 289.278H488.937L488.179 287.965L488.937 286.652H490.457L491.215 287.965L490.457 289.278Z",
    fill: "#DADADA"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 287.315H493.821L492.323 284.719L493.821 282.124H496.819L498.318 284.719L496.819 287.315Z",
    fill: "#DADADA"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 280.827H493.821L492.323 278.231L493.821 275.636H496.819L498.318 278.231L496.819 280.827Z",
    fill: "#DADADA"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 274.341H493.821L492.323 271.746L493.821 269.15H496.819L498.318 271.746L496.819 274.341Z",
    fill: "#DADADA"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M496.393 267.122H494.244L493.167 265.258L494.244 263.395H496.393L497.469 265.258L496.393 267.122Z",
    fill: "#18A7B9"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M496.743 228.799H493.896L492.475 226.337L493.896 223.875H496.743L498.164 226.337L496.743 228.799Z",
    fill: "#DADADA"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 222.441H493.821L492.323 219.85L493.821 217.254H496.819L498.318 219.85L496.819 222.441Z",
    fill: "#DADADA"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 215.954H493.821L492.323 213.358L493.821 210.767H496.819L498.318 213.358L496.819 215.954Z",
    fill: "#DADADA"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M496.552 209.011H494.085L492.853 206.872L494.085 204.737H496.552L497.789 206.872L496.552 209.011Z",
    fill: "#DADADA"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M496.677 170.3H493.963L492.603 167.949L493.963 165.599H496.677L498.033 167.949L496.677 170.3Z",
    fill: "#DADADA"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 164.059H493.821L492.323 161.464L493.821 158.868H496.819L498.318 161.464L496.819 164.059Z",
    fill: "#DADADA"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 157.572H493.821L492.323 154.976L493.821 152.38H496.819L498.318 154.976L496.819 157.572Z",
    fill: "#DADADA"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 151.085H493.821L492.323 148.489L493.821 145.894H496.819L498.318 148.489L496.819 151.085Z",
    fill: "#DADADA"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 144.593H493.821L492.323 142.002L493.821 139.406H496.819L498.318 142.002L496.819 144.593Z",
    fill: "#DADADA"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M496.131 136.919H494.507L493.697 135.511L494.507 134.108H496.131L496.945 135.511L496.131 136.919Z",
    fill: "#DADADA"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 131.621H493.821L492.323 129.025L493.821 126.434H496.819L498.318 129.025L496.819 131.621Z",
    fill: "#DADADA"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 125.133H493.821L492.323 122.537L493.821 119.941H496.819L498.318 122.537L496.819 125.133Z",
    fill: "#DADADA"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 118.646H493.821L492.323 116.05L493.821 113.455H496.819L498.318 116.05L496.819 118.646Z",
    fill: "#DADADA"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 112.159H493.821L492.323 109.563L493.821 106.967H496.819L498.318 109.563L496.819 112.159Z",
    fill: "#DADADA"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 105.672H493.821L492.323 103.076L493.821 100.48H496.819L498.318 103.076L496.819 105.672Z",
    fill: "#DADADA"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 99.1849H493.821L492.323 96.5893L493.821 93.9937H496.819L498.318 96.5893L496.819 99.1849Z",
    fill: "#DADADA"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 92.6981H493.821L492.323 90.1025L493.821 87.5068H496.819L498.318 90.1025L496.819 92.6981Z",
    fill: "#DADADA"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 86.2108H493.821L492.323 83.6152L493.821 81.0195H496.819L498.318 83.6152L496.819 86.2108Z",
    fill: "#18A7B9"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 79.7245H493.821L492.323 77.1288L493.821 74.5332H496.819L498.318 77.1288L496.819 79.7245Z",
    fill: "#DADADA"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 73.2334H493.821L492.323 70.642L493.821 68.0464H496.819L498.318 70.642L496.819 73.2334Z",
    fill: "#DADADA"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 66.7461H493.821L492.323 64.1547L493.821 61.5591H496.819L498.318 64.1547L496.819 66.7461Z",
    fill: "#DADADA"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 60.2588H493.821L492.323 57.6674L493.821 55.0718H496.819L498.318 57.6674L496.819 60.2588Z",
    fill: "#DADADA"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 57.0179H488.196L486.697 54.4223L488.196 51.8267H491.198L492.697 54.4223L491.198 57.0179Z",
    fill: "#DADADA"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 53.7724H482.576L481.078 51.1768L482.576 48.5854H485.578L487.077 51.1768L485.578 53.7724Z",
    fill: "#DADADA"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 50.5306H476.955L475.457 47.935L476.955 45.3394H479.953L481.452 47.935L479.953 50.5306Z",
    fill: "#DADADA"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M474.332 47.2855H471.334L469.835 44.6899L471.334 42.0942H474.332L475.83 44.6899L474.332 47.2855Z",
    fill: "#DADADA"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M468.711 44.0438H465.714L464.215 41.4482L465.714 38.8525H468.711L470.21 41.4482L468.711 44.0438Z",
    fill: "#DADADA"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M463.06 40.7467H460.123L458.65 38.2027L460.123 35.6587H463.06L464.529 38.2027L463.06 40.7467Z",
    fill: "#DADADA"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M457.443 37.5133H454.493L453.016 34.9607L454.493 32.4038H457.443L458.921 34.9607L457.443 37.5133Z",
    fill: "#DADADA"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M451.845 34.3109H448.847L447.349 31.7153L448.847 29.1196H451.845L453.348 31.7153L451.845 34.3109Z",
    fill: "#DADADA"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M446.224 31.0659H443.226L441.728 28.4745L443.226 25.8789H446.224L447.723 28.4745L446.224 31.0659Z",
    fill: "#DADADA"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M428.955 20.6357H426.767L425.673 18.7417L426.767 16.8477H428.955L430.045 18.7417L428.955 20.6357Z",
    fill: "#DADADA"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M422.943 16.718H421.535L420.829 15.4955L421.535 14.2773H422.943L423.649 15.4955L422.943 16.718Z",
    fill: "#DADADA"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M187.171 10.8001H185.099L184.065 9.00944L185.099 7.21875H187.171L188.204 9.00944L187.171 10.8001Z",
    fill: "#DADADA"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M181.344 13.6881H179.686L178.854 12.2547L179.686 10.8213H181.344L182.171 12.2547L181.344 13.6881Z",
    fill: "#DADADA"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M176.213 17.7862H173.568L172.246 15.4962L173.568 13.2104H176.213L177.535 15.4962L176.213 17.7862Z",
    fill: "#DADADA"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M170.158 20.278H168.383L167.496 18.7413L168.383 17.2046H170.158L171.045 18.7413L170.158 20.278Z",
    fill: "#DADADA"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M165.084 24.467H162.215L160.781 21.9876L162.215 19.5039H165.084L166.518 21.9876L165.084 24.467Z",
    fill: "#DADADA"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 27.8241H156.526L155.027 25.2285L156.526 22.6328H159.527L161.026 25.2285L159.527 27.8241Z",
    fill: "#DADADA"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 31.0659H150.906L149.407 28.4745L150.906 25.8789H153.903L155.402 28.4745L153.903 31.0659Z",
    fill: "#DADADA"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M147.411 32.8046H146.154L145.525 31.7155L146.154 30.6265H147.411L148.04 31.7155L147.411 32.8046Z",
    fill: "#DADADA"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M141.89 36.2227H140.435L139.703 34.9614L140.435 33.7002H141.89L142.618 34.9614L141.89 36.2227Z",
    fill: "#DADADA"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M125.009 45.9212H123.584L122.873 44.6901L123.584 43.459H125.009L125.72 44.6901L125.009 45.9212Z",
    fill: "#DADADA"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M119.578 49.5019H117.769L116.865 47.935L117.769 46.3682H119.578L120.487 47.935L119.578 49.5019Z",
    fill: "#DADADA"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M113.975 52.7779H112.132L111.206 51.1766L112.132 49.5796H113.975L114.901 51.1766L113.975 52.7779Z",
    fill: "#DADADA"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M107.855 55.1535H107.011L106.584 54.4217L107.011 53.6899H107.855L108.277 54.4217L107.855 55.1535Z",
    fill: "#DADADA"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 60.2588H100.313L98.8145 57.6674L100.313 55.0718H103.311L104.809 57.6674L103.311 60.2588Z",
    fill: "#DADADA"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 66.7461H100.313L98.8145 64.1547L100.313 61.5591H103.311L104.809 64.1547L103.311 66.7461Z",
    fill: "#DADADA"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 73.2334H100.313L98.8145 70.642L100.313 68.0464H103.311L104.809 70.642L103.311 73.2334Z",
    fill: "#DADADA"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 79.7245H100.313L98.8145 77.1288L100.313 74.5332H103.311L104.809 77.1288L103.311 79.7245Z",
    fill: "#DADADA"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 86.2108H100.313L98.8145 83.6152L100.313 81.0195H103.311L104.809 83.6152L103.311 86.2108Z",
    fill: "#DADADA"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 92.6981H100.313L98.8145 90.1025L100.313 87.5068H103.311L104.809 90.1025L103.311 92.6981Z",
    fill: "#DADADA"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 99.1849H100.313L98.8145 96.5893L100.313 93.9937H103.311L104.809 96.5893L103.311 99.1849Z",
    fill: "#DADADA"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 105.672H100.313L98.8145 103.076L100.313 100.48H103.311L104.809 103.076L103.311 105.672Z",
    fill: "#DADADA"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 112.159H100.313L98.8145 109.563L100.313 106.967H103.311L104.809 109.563L103.311 112.159Z",
    fill: "#DADADA"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 118.646H100.313L98.8145 116.05L100.313 113.455H103.311L104.809 116.05L103.311 118.646Z",
    fill: "#DADADA"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 131.621H100.313L98.8145 129.025L100.313 126.434H103.311L104.809 129.025L103.311 131.621Z",
    fill: "#DADADA"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 138.106H100.313L98.8145 135.511L100.313 132.919H103.311L104.809 135.511L103.311 138.106Z",
    fill: "#DADADA"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 144.593H100.313L98.8145 142.002L100.313 139.406H103.311L104.809 142.002L103.311 144.593Z",
    fill: "#DADADA"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 151.085H100.313L98.8145 148.489L100.313 145.894H103.311L104.809 148.489L103.311 151.085Z",
    fill: "#DADADA"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 157.572H100.313L98.8145 154.976L100.313 152.38H103.311L104.809 154.976L103.311 157.572Z",
    fill: "#DADADA"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 164.059H100.313L98.8145 161.464L100.313 158.868H103.311L104.809 161.464L103.311 164.059Z",
    fill: "#DADADA"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 170.546H100.313L98.8145 167.95L100.313 165.354H103.311L104.809 167.95L103.311 170.546Z",
    fill: "#DADADA"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 177.033H100.313L98.8145 174.437L100.313 171.841H103.311L104.809 174.437L103.311 177.033Z",
    fill: "#DADADA"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 183.518H100.313L98.8145 180.923L100.313 178.327H103.311L104.809 180.923L103.311 183.518Z",
    fill: "#DADADA"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M102.135 187.971H101.489L101.166 187.411L101.489 186.852H102.135L102.458 187.411L102.135 187.971Z",
    fill: "#DADADA"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M153.897 322.987H150.913L149.418 320.4L150.913 317.817H153.897L155.392 320.4L153.897 322.987Z",
    fill: "#DADADA"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 326.242H156.526L155.027 323.646L156.526 321.05H159.527L161.026 323.646L159.527 326.242Z",
    fill: "#DADADA"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M165.123 329.444H162.173L160.7 326.887L162.173 324.334H165.123L166.6 326.887L165.123 329.444Z",
    fill: "#DADADA"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M490.19 295.308H489.204L488.708 294.452L489.204 293.595H490.19L490.685 294.452L490.19 295.308Z",
    fill: "#DADADA"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 293.802H493.821L492.323 291.207L493.821 288.615H496.819L498.318 291.207L496.819 293.802Z",
    fill: "#DADADA"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 290.561H499.443L497.944 287.966L499.443 285.37H502.441L503.939 287.966L502.441 290.561Z",
    fill: "#DADADA"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 284.074H499.443L497.944 281.478L499.443 278.882H502.441L503.939 281.478L502.441 284.074Z",
    fill: "#DADADA"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 277.587H499.443L497.944 274.992L499.443 272.396H502.441L503.939 274.992L502.441 277.587Z",
    fill: "#DADADA"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 271.096H499.443L497.944 268.504L499.443 265.909H502.441L503.939 268.504L502.441 271.096Z",
    fill: "#DADADA"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M502.38 264.509H499.498L498.06 262.017L499.498 259.521H502.38L503.822 262.017L502.38 264.509Z",
    fill: "#DADADA"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M501.205 255.987H500.675L500.412 255.53L500.675 255.069H501.205L501.472 255.53L501.205 255.987Z",
    fill: "#DADADA"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M501.859 224.68H500.024L499.107 223.091L500.024 221.503H501.859L502.776 223.091L501.859 224.68Z",
    fill: "#DADADA"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M501.415 217.431H500.463L499.989 216.605L500.463 215.778H501.415L501.893 216.605L501.415 217.431Z",
    fill: "#DADADA"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M501.859 211.706H500.024L499.107 210.118L500.024 208.529H501.859L502.776 210.118L501.859 211.706Z",
    fill: "#DADADA"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M501.682 172.474H500.201L499.46 171.192L500.201 169.913H501.682L502.423 171.192L501.682 172.474Z",
    fill: "#DADADA"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M501.393 165.488H500.489L500.037 164.704L500.489 163.921H501.393L501.845 164.704L501.393 165.488Z",
    fill: "#DADADA"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M502.298 160.568H499.585L498.224 158.218L499.585 155.868H502.298L503.659 158.218L502.298 160.568Z",
    fill: "#DADADA"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M502.393 154.245H499.49L498.039 151.731L499.49 149.217H502.393L503.845 151.731L502.393 154.245Z",
    fill: "#DADADA"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M501.196 145.683H500.688L500.438 145.244L500.688 144.805H501.196L501.446 145.244L501.196 145.683Z",
    fill: "#DADADA"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M501.553 139.816H500.33L499.718 138.757L500.33 137.698H501.553L502.165 138.757L501.553 139.816Z",
    fill: "#DADADA"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M502.25 134.538H499.632L498.318 132.269L499.632 130.001H502.25L503.564 132.269L502.25 134.538Z",
    fill: "#DADADA"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 128.378H499.443L497.944 125.783L499.443 123.187H502.441L503.939 125.783L502.441 128.378Z",
    fill: "#DADADA"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 121.891H499.443L497.944 119.296L499.443 116.7H502.441L503.939 119.296L502.441 121.891Z",
    fill: "#DADADA"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 115.405H499.443L497.944 112.81L499.443 110.214H502.441L503.939 112.81L502.441 115.405Z",
    fill: "#DADADA"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 108.913H499.443L497.944 106.322L499.443 103.726H502.441L503.939 106.322L502.441 108.913Z",
    fill: "#DADADA"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 102.427H499.443L497.944 99.8354L499.443 97.2397H502.441L503.939 99.8354L502.441 102.427Z",
    fill: "#DADADA"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 95.9394H499.443L497.944 93.3438L499.443 90.7524H502.441L503.939 93.3438L502.441 95.9394Z",
    fill: "#DADADA"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 89.4525H499.443L497.944 86.8569L499.443 84.2612H502.441L503.939 86.8569L502.441 89.4525Z",
    fill: "#DADADA"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 82.9657H499.443L497.944 80.3701L499.443 77.7744H502.441L503.939 80.3701L502.441 82.9657Z",
    fill: "#DADADA"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 76.4784H499.443L497.944 73.8827L499.443 71.2871H502.441L503.939 73.8827L502.441 76.4784Z",
    fill: "#DADADA"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 69.9911H499.443L497.944 67.3955L499.443 64.7998H502.441L503.939 67.3955L502.441 69.9911Z",
    fill: "#DADADA"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 63.5048H499.443L497.944 60.9091L499.443 58.3135H502.441L503.939 60.9091L502.441 63.5048Z",
    fill: "#DADADA"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 57.0179H499.443L497.944 54.4223L499.443 51.8267H502.441L503.939 54.4223L502.441 57.0179Z",
    fill: "#DADADA"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 53.7724H493.821L492.323 51.1768L493.821 48.5854H496.819L498.318 51.1768L496.819 53.7724Z",
    fill: "#DADADA"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M491.198 50.5306H488.196L486.697 47.935L488.196 45.3394H491.198L492.697 47.935L491.198 50.5306Z",
    fill: "#DADADA"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M485.578 47.2855H482.576L481.078 44.6899L482.576 42.0942H485.578L487.077 44.6899L485.578 47.2855Z",
    fill: "#DADADA"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M479.943 44.0223H476.967L475.481 41.4481L476.967 38.874H479.943L481.429 41.4481L479.943 44.0223Z",
    fill: "#DADADA"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M473.496 39.3518H472.169L471.506 38.2025L472.169 37.0532H473.496L474.163 38.2025L473.496 39.3518Z",
    fill: "#DADADA"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M462.272 32.895H460.907L460.226 31.7156L460.907 30.5361H462.272L462.952 31.7156L462.272 32.895Z",
    fill: "#DADADA"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M457.456 31.0486H454.48L452.995 28.4745L454.48 25.9004H457.456L458.942 28.4745L457.456 31.0486Z",
    fill: "#DADADA"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M434.189 16.718H432.777L432.07 15.4955L432.777 14.2773H434.189L434.891 15.4955L434.189 16.718Z",
    fill: "#DADADA"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M181.567 7.58842H179.461L178.406 5.7676L179.461 3.94678H181.567L182.618 5.7676L181.567 7.58842Z",
    fill: "#DADADA"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M176.389 11.6045H173.392L171.893 9.00881L173.392 6.41748H176.389L177.888 9.00881L176.389 11.6045Z",
    fill: "#DADADA"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M170.769 14.8505H167.772L166.273 12.2548L167.772 9.65918H170.769L172.268 12.2548L170.769 14.8505Z",
    fill: "#DADADA"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 18.0918H162.151L160.652 15.4961L162.151 12.9048H165.149L166.647 15.4961L165.149 18.0918Z",
    fill: "#DADADA"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 21.3378H156.526L155.027 18.7421L156.526 16.1465H159.527L161.026 18.7421L159.527 21.3378Z",
    fill: "#DADADA"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 24.5791H150.906L149.407 21.9877L150.906 19.3921H153.903L155.402 21.9877L153.903 24.5791Z",
    fill: "#DADADA"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M148.075 27.4674H145.491L144.199 25.2291L145.491 22.9907H148.075L149.372 25.2291L148.075 27.4674Z",
    fill: "#DADADA"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M142.358 30.5489H139.959L138.762 28.4741L139.959 26.395H142.358L143.56 28.4741L142.358 30.5489Z",
    fill: "#DADADA"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M135.916 32.3661H135.162L134.788 31.7157L135.162 31.0654H135.916L136.295 31.7157L135.916 32.3661Z",
    fill: "#DADADA"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M125.794 40.7982H122.796L121.297 38.2026L122.796 35.6069H125.794L127.297 38.2026L125.794 40.7982Z",
    fill: "#DADADA"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M119.157 42.2834H118.192L117.71 41.4484L118.192 40.6133H119.157L119.639 41.4484L119.157 42.2834Z",
    fill: "#DADADA"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M114.551 47.2855H111.554L110.055 44.6899L111.554 42.0942H114.551L116.05 44.6899L114.551 47.2855Z",
    fill: "#DADADA"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M108.931 50.5306H105.933L104.435 47.935L105.933 45.3394H108.931L110.43 47.935L108.931 50.5306Z",
    fill: "#DADADA"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M103.092 53.3979H100.529L99.25 51.1768L100.529 48.96H103.092L104.375 51.1768L103.092 53.3979Z",
    fill: "#DADADA"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5528 56.7802H94.8267L93.4614 54.4213L94.8267 52.0581H97.5528L98.9181 54.4213L97.5528 56.7802Z",
    fill: "#DADADA"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 63.5048H94.6921L93.1934 60.9091L94.6921 58.3135H97.6896L99.1883 60.9091L97.6896 63.5048Z",
    fill: "#DADADA"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 69.9911H94.6921L93.1934 67.3955L94.6921 64.7998H97.6896L99.1883 67.3955L97.6896 69.9911Z",
    fill: "#DADADA"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 76.4784H94.6921L93.1934 73.8827L94.6921 71.2871H97.6896L99.1883 73.8827L97.6896 76.4784Z",
    fill: "#DADADA"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 82.9657H94.6921L93.1934 80.3701L94.6921 77.7744H97.6896L99.1883 80.3701L97.6896 82.9657Z",
    fill: "#DADADA"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 89.4525H94.6921L93.1934 86.8569L94.6921 84.2612H97.6896L99.1883 86.8569L97.6896 89.4525Z",
    fill: "#DADADA"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 95.9394H94.6921L93.1934 93.3438L94.6921 90.7524H97.6896L99.1883 93.3438L97.6896 95.9394Z",
    fill: "#DADADA"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 102.427H94.6921L93.1934 99.8354L94.6921 97.2397H97.6896L99.1883 99.8354L97.6896 102.427Z",
    fill: "#DADADA"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 108.913H94.6921L93.1934 106.322L94.6921 103.726H97.6896L99.1883 106.322L97.6896 108.913Z",
    fill: "#DADADA"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 115.405H94.6921L93.1934 112.81L94.6921 110.214H97.6896L99.1883 112.81L97.6896 115.405Z",
    fill: "#DADADA"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 121.891H94.6921L93.1934 119.296L94.6921 116.7H97.6896L99.1883 119.296L97.6896 121.891Z",
    fill: "#DADADA"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 128.378H94.6921L93.1934 125.783L94.6921 123.187H97.6896L99.1883 125.783L97.6896 128.378Z",
    fill: "#DADADA"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 134.865H94.6921L93.1934 132.269L94.6921 129.674H97.6896L99.1883 132.269L97.6896 134.865Z",
    fill: "#DADADA"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 141.352H94.6921L93.1934 138.756L94.6921 136.161H97.6896L99.1883 138.756L97.6896 141.352Z",
    fill: "#DADADA"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 147.839H94.6921L93.1934 145.244L94.6921 142.648H97.6896L99.1883 145.244L97.6896 147.839Z",
    fill: "#DADADA"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 154.326H94.6921L93.1934 151.73L94.6921 149.135H97.6896L99.1883 151.73L97.6896 154.326Z",
    fill: "#DADADA"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 160.813H94.6921L93.1934 158.218L94.6921 155.622H97.6896L99.1883 158.218L97.6896 160.813Z",
    fill: "#DADADA"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 167.3H94.6921L93.1934 164.705L94.6921 162.113H97.6896L99.1883 164.705L97.6896 167.3Z",
    fill: "#DADADA"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 173.787H94.6921L93.1934 171.191L94.6921 168.6H97.6896L99.1883 171.191L97.6896 173.787Z",
    fill: "#DADADA"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 180.274H94.6921L93.1934 177.679L94.6921 175.087H97.6896L99.1883 177.679L97.6896 180.274Z",
    fill: "#DADADA"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9018 185.401H95.4762L94.7656 184.17L95.4762 182.938H96.9018L97.6124 184.17L96.9018 185.401Z",
    fill: "#DADADA"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M153.704 329.138H151.107L149.807 326.887L151.107 324.64H153.704L155.005 326.887L153.704 329.138Z",
    fill: "#18A7B9"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 332.728H156.526L155.027 330.132L156.526 327.537H159.527L161.026 330.132L159.527 332.728Z",
    fill: "#DADADA"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M164.088 334.14H163.205L162.766 333.378L163.205 332.612H164.088L164.527 333.378L164.088 334.14Z",
    fill: "#DADADA"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M507.311 292.502H505.816L505.067 291.206L505.816 289.915H507.311L508.056 291.206L507.311 292.502Z",
    fill: "#DADADA"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 287.315H505.063L503.564 284.719L505.063 282.124H508.061L509.559 284.719L508.061 287.315Z",
    fill: "#DADADA"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 280.827H505.063L503.564 278.231L505.063 275.636H508.061L509.559 278.231L508.061 280.827Z",
    fill: "#DADADA"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 274.341H505.063L503.564 271.746L505.063 269.15H508.061L509.559 271.746L508.061 274.341Z",
    fill: "#DADADA"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 267.854H505.063L503.564 265.259L505.063 262.663H508.061L509.559 265.259L508.061 267.854Z",
    fill: "#DADADA"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 261.368H505.063L503.564 258.772L505.063 256.176H508.061L509.559 258.772L508.061 261.368Z",
    fill: "#DADADA"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M507.174 227.392H505.951L505.339 226.338L505.951 225.279H507.174L507.786 226.338L507.174 227.392Z",
    fill: "#DADADA"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M507.961 222.269H505.162L503.762 219.85L505.162 217.426H507.961L509.361 219.85L507.961 222.269Z",
    fill: "#DADADA"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 183.518H505.063L503.564 180.923L505.063 178.327H508.061L509.559 180.923L508.061 183.518Z",
    fill: "#DADADA"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M507.591 137.293H505.532L504.503 135.511L505.532 133.733H507.591L508.62 135.511L507.591 137.293Z",
    fill: "#DADADA"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 131.621H505.063L503.564 129.025L505.063 126.434H508.061L509.559 129.025L508.061 131.621Z",
    fill: "#DADADA"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 125.133H505.063L503.564 122.537L505.063 119.941H508.061L509.559 122.537L508.061 125.133Z",
    fill: "#DADADA"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 118.646H505.063L503.564 116.05L505.063 113.455H508.061L509.559 116.05L508.061 118.646Z",
    fill: "#DADADA"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 112.159H505.063L503.564 109.563L505.063 106.967H508.061L509.559 109.563L508.061 112.159Z",
    fill: "#DADADA"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 105.672H505.063L503.564 103.076L505.063 100.48H508.061L509.559 103.076L508.061 105.672Z",
    fill: "#DADADA"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 99.1849H505.063L503.564 96.5893L505.063 93.9937H508.061L509.559 96.5893L508.061 99.1849Z",
    fill: "#DADADA"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 92.6981H505.063L503.564 90.1025L505.063 87.5068H508.061L509.559 90.1025L508.061 92.6981Z",
    fill: "#DADADA"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 86.2108H505.063L503.564 83.6152L505.063 81.0195H508.061L509.559 83.6152L508.061 86.2108Z",
    fill: "#DADADA"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 79.7245H505.063L503.564 77.1288L505.063 74.5332H508.061L509.559 77.1288L508.061 79.7245Z",
    fill: "#DADADA"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 73.2334H505.063L503.564 70.642L505.063 68.0464H508.061L509.559 70.642L508.061 73.2334Z",
    fill: "#DADADA"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 66.7461H505.063L503.564 64.1547L505.063 61.5591H508.061L509.559 64.1547L508.061 66.7461Z",
    fill: "#DADADA"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 60.2588H505.063L503.564 57.6674L505.063 55.0718H508.061L509.559 57.6674L508.061 60.2588Z",
    fill: "#DADADA"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 53.7724H505.063L503.564 51.1768L505.063 48.5854H508.061L509.559 51.1768L508.061 53.7724Z",
    fill: "#DADADA"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M502.441 50.5306H499.443L497.944 47.935L499.443 45.3394H502.441L503.939 47.935L502.441 50.5306Z",
    fill: "#DADADA"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M496.819 47.2855H493.821L492.323 44.6899L493.821 42.0942H496.819L498.318 44.6899L496.819 47.2855Z",
    fill: "#DADADA"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M490.522 42.8726H488.877L488.05 41.4478L488.877 40.0229H490.522L491.345 41.4478L490.522 42.8726Z",
    fill: "#DADADA"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M170.446 7.80354H168.095L166.919 5.7675L168.095 3.73145H170.446L171.622 5.7675L170.446 7.80354Z",
    fill: "#DADADA"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 11.6045H162.151L160.652 9.00881L162.151 6.41748H165.149L166.647 9.00881L165.149 11.6045Z",
    fill: "#DADADA"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 18.0918H150.906L149.407 15.4961L150.906 12.9048H153.903L155.402 15.4961L153.903 18.0918Z",
    fill: "#DADADA"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M147.67 20.278H145.895L145.008 18.7413L145.895 17.2046H147.67L148.557 18.7413L147.67 20.278Z",
    fill: "#DADADA"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M142.351 24.041H139.973L138.789 21.9877L139.973 19.9302H142.351L143.535 21.9877L142.351 24.041Z",
    fill: "#DADADA"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M130.326 29.1765H129.512L129.107 28.4745L129.512 27.7725H130.326L130.731 28.4745L130.326 29.1765Z",
    fill: "#DADADA"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M125.553 33.8938H123.038L121.78 31.7157L123.038 29.5376H125.553L126.815 31.7157L125.553 33.8938Z",
    fill: "#DADADA"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M119.303 36.0511H118.046L117.417 34.9621L118.046 33.873H119.303L119.932 34.9621L119.303 36.0511Z",
    fill: "#DADADA"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M114.325 40.4028H111.784L110.513 38.2031L111.784 36.0078H114.325L115.595 38.2031L114.325 40.4028Z",
    fill: "#DADADA"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M108.919 44.0223H105.947L104.457 41.4481L105.947 38.874H108.919L110.405 41.4481L108.919 44.0223Z",
    fill: "#DADADA"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 47.2855H100.313L98.8145 44.6899L100.313 42.0942H103.311L104.809 44.6899L103.311 47.2855Z",
    fill: "#DADADA"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5179 50.234H94.8606L93.5342 47.9353L94.8606 45.6367H97.5179L98.8487 47.9353L97.5179 50.234Z",
    fill: "#DADADA"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9153 51.7797H90.2219L89.873 51.1768L90.2219 50.5781H90.9153L91.2598 51.1768L90.9153 51.7797Z",
    fill: "#DADADA"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 60.2588H89.0671L87.5684 57.6674L89.0671 55.0718H92.0646L93.5676 57.6674L92.0646 60.2588Z",
    fill: "#DADADA"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 66.7461H89.0671L87.5684 64.1547L89.0671 61.5591H92.0646L93.5676 64.1547L92.0646 66.7461Z",
    fill: "#18A7B9"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 73.2334H89.0671L87.5684 70.642L89.0671 68.0464H92.0646L93.5676 70.642L92.0646 73.2334Z",
    fill: "#DADADA"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 79.7245H89.0671L87.5684 77.1288L89.0671 74.5332H92.0646L93.5676 77.1288L92.0646 79.7245Z",
    fill: "#DADADA"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 86.2108H89.0671L87.5684 83.6152L89.0671 81.0195H92.0646L93.5676 83.6152L92.0646 86.2108Z",
    fill: "#DADADA"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 99.1849H89.0671L87.5684 96.5893L89.0671 93.9937H92.0646L93.5676 96.5893L92.0646 99.1849Z",
    fill: "#DADADA"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 105.672H89.0671L87.5684 103.076L89.0671 100.48H92.0646L93.5676 103.076L92.0646 105.672Z",
    fill: "#DADADA"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 112.159H89.0671L87.5684 109.563L89.0671 106.967H92.0646L93.5676 109.563L92.0646 112.159Z",
    fill: "#DADADA"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 118.646H89.0671L87.5684 116.05L89.0671 113.455H92.0646L93.5676 116.05L92.0646 118.646Z",
    fill: "#DADADA"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 125.133H89.0671L87.5684 122.537L89.0671 119.941H92.0646L93.5676 122.537L92.0646 125.133Z",
    fill: "#DADADA"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 131.621H89.0671L87.5684 129.025L89.0671 126.434H92.0646L93.5676 129.025L92.0646 131.621Z",
    fill: "#DADADA"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 138.106H89.0671L87.5684 135.511L89.0671 132.919H92.0646L93.5676 135.511L92.0646 138.106Z",
    fill: "#DADADA"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 144.593H89.0671L87.5684 142.002L89.0671 139.406H92.0646L93.5676 142.002L92.0646 144.593Z",
    fill: "#DADADA"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 151.085H89.0671L87.5684 148.489L89.0671 145.894H92.0646L93.5676 148.489L92.0646 151.085Z",
    fill: "#DADADA"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 157.572H89.0671L87.5684 154.976L89.0671 152.38H92.0646L93.5676 154.976L92.0646 157.572Z",
    fill: "#DADADA"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 164.059H89.0671L87.5684 161.464L89.0671 158.868H92.0646L93.5676 161.464L92.0646 164.059Z",
    fill: "#DADADA"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 170.546H89.0671L87.5684 167.95L89.0671 165.354H92.0646L93.5676 167.95L92.0646 170.546Z",
    fill: "#DADADA"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0421 176.989H89.092L87.6147 174.437L89.092 171.884H92.0421L93.5193 174.437L92.0421 176.989Z",
    fill: "#DADADA"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1775 181.983H89.9544L89.3472 180.924L89.9544 179.865H91.1775L91.7891 180.924L91.1775 181.983Z",
    fill: "#DADADA"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M153.223 334.79H151.59L150.772 333.378L151.59 331.962H153.223L154.041 333.378L153.223 334.79Z",
    fill: "#DADADA"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M159.527 339.215H156.526L155.027 336.62L156.526 334.024H159.527L161.026 336.62L159.527 339.215Z",
    fill: "#DADADA"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M165.041 342.275H162.254L160.863 339.86L162.254 337.45H165.041L166.436 339.86L165.041 342.275Z",
    fill: "#DADADA"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M169.928 344.247H168.611L167.952 343.107L168.611 341.966H169.928L170.587 343.107L169.928 344.247Z",
    fill: "#DADADA"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M513.329 289.95H511.038L509.892 287.965L511.038 285.981H513.329L514.479 287.965L513.329 289.95Z",
    fill: "#DADADA"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 284.074H510.684L509.186 281.478L510.684 278.882H513.682L515.181 281.478L513.682 284.074Z",
    fill: "#DADADA"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 264.608H510.684L509.186 262.017L510.684 259.421H513.682L515.181 262.017L513.682 264.608Z",
    fill: "#DADADA"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 258.122H510.684L509.186 255.53L510.684 252.935H513.682L515.181 255.53L513.682 258.122Z",
    fill: "#DADADA"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M513.303 250.976H511.068L509.952 249.039L511.068 247.106H513.303L514.418 249.039L513.303 250.976Z",
    fill: "#DADADA"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M512.761 198.138H511.611L511.034 197.144L511.611 196.145H512.761L513.338 197.144L512.761 198.138Z",
    fill: "#DADADA"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M512.648 191.458H511.722L511.257 190.657L511.722 189.852H512.648L513.113 190.657L512.648 191.458Z",
    fill: "#DADADA"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M513.608 141.219H510.762L509.34 138.757L510.762 136.294H513.608L515.03 138.757L513.608 141.219Z",
    fill: "#DADADA"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M513.294 134.194H511.072L509.961 132.27L511.072 130.346H513.294L514.406 132.27L513.294 134.194Z",
    fill: "#DADADA"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M513.673 128.357H510.697L509.211 125.783L510.697 123.209H513.673L515.159 125.783L513.673 128.357Z",
    fill: "#DADADA"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 121.891H510.684L509.186 119.296L510.684 116.7H513.682L515.181 119.296L513.682 121.891Z",
    fill: "#DADADA"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 115.405H510.684L509.186 112.81L510.684 110.214H513.682L515.181 112.81L513.682 115.405Z",
    fill: "#DADADA"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 102.427H510.684L509.186 99.8354L510.684 97.2397H513.682L515.181 99.8354L513.682 102.427Z",
    fill: "#DADADA"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 95.9394H510.684L509.186 93.3438L510.684 90.7524H513.682L515.181 93.3438L513.682 95.9394Z",
    fill: "#DADADA"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 89.4525H510.684L509.186 86.8569L510.684 84.2612H513.682L515.181 86.8569L513.682 89.4525Z",
    fill: "#DADADA"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 82.9657H510.684L509.186 80.3701L510.684 77.7744H513.682L515.181 80.3701L513.682 82.9657Z",
    fill: "#DADADA"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 76.4784H510.684L509.186 73.8827L510.684 71.2871H513.682L515.181 73.8827L513.682 76.4784Z",
    fill: "#DADADA"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 69.9911H510.684L509.186 67.3955L510.684 64.7998H513.682L515.181 67.3955L513.682 69.9911Z",
    fill: "#DADADA"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 63.5048H510.684L509.186 60.9091L510.684 58.3135H513.682L515.181 60.9091L513.682 63.5048Z",
    fill: "#DADADA"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 57.0179H510.684L509.186 54.4223L510.684 51.8267H513.682L515.181 54.4223L513.682 57.0179Z",
    fill: "#DADADA"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 50.5306H510.684L509.186 47.935L510.684 45.3394H513.682L515.181 47.935L513.682 50.5306Z",
    fill: "#DADADA"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M508.061 47.2855H505.063L503.564 44.6899L505.063 42.0942H508.061L509.559 44.6899L508.061 47.2855Z",
    fill: "#DADADA"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M501.764 42.8726H500.119L499.296 41.4478L500.119 40.0229H501.764L502.587 41.4478L501.764 42.8726Z",
    fill: "#DADADA"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M158.933 7.33439H157.12L156.216 5.76754L157.12 4.20068H158.933L159.838 5.76754L158.933 7.33439Z",
    fill: "#DADADA"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M153.903 11.6045H150.906L149.407 9.00881L150.906 6.41748H153.903L155.402 9.00881L153.903 11.6045Z",
    fill: "#DADADA"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M147.872 14.1357H145.698L144.608 12.2546L145.698 10.3735H147.872L148.958 12.2546L147.872 14.1357Z",
    fill: "#DADADA"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M142.66 18.0918H139.662L138.164 15.4961L139.662 12.9048H142.66L144.159 15.4961L142.66 18.0918Z",
    fill: "#DADADA"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M119.152 29.2961H118.2L117.722 28.4739L118.2 27.6475H119.152L119.626 28.4739L119.152 29.2961Z",
    fill: "#DADADA"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M114.466 34.1563H111.641L110.232 31.7156L111.641 29.2749H114.466L115.874 31.7156L114.466 34.1563Z",
    fill: "#DADADA"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M108.479 36.7738H106.386L105.34 34.9616L106.386 33.1494H108.479L109.526 34.9616L108.479 36.7738Z",
    fill: "#DADADA"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M103.301 40.7894H100.317L98.8223 38.2024L100.317 35.6196H103.301L104.796 38.2024L103.301 40.7894Z",
    fill: "#DADADA"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6896 44.0438H94.6921L93.1934 41.4482L94.6921 38.8525H97.6896L99.1883 41.4482L97.6896 44.0438Z",
    fill: "#DADADA"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9448 45.345H90.1911L89.8164 44.6904L90.1911 44.04H90.9448L91.3194 44.6904L90.9448 45.345Z",
    fill: "#DADADA"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 57.0179H83.4455L81.9468 54.4223L83.4455 51.8267H86.443L87.9417 54.4223L86.443 57.0179Z",
    fill: "#DADADA"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 63.5048H83.4455L81.9468 60.9091L83.4455 58.3135H86.443L87.9417 60.9091L86.443 63.5048Z",
    fill: "#DADADA"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 69.9911H83.4455L81.9468 67.3955L83.4455 64.7998H86.443L87.9417 67.3955L86.443 69.9911Z",
    fill: "#DADADA"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 76.4784H83.4455L81.9468 73.8827L83.4455 71.2871H86.443L87.9417 73.8827L86.443 76.4784Z",
    fill: "#DADADA"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 82.9657H83.4455L81.9468 80.3701L83.4455 77.7744H86.443L87.9417 80.3701L86.443 82.9657Z",
    fill: "#DADADA"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 89.4525H83.4455L81.9468 86.8569L83.4455 84.2612H86.443L87.9417 86.8569L86.443 89.4525Z",
    fill: "#DADADA"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 95.9394H83.4455L81.9468 93.3438L83.4455 90.7524H86.443L87.9417 93.3438L86.443 95.9394Z",
    fill: "#DADADA"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 102.427H83.4455L81.9468 99.8354L83.4455 97.2397H86.443L87.9417 99.8354L86.443 102.427Z",
    fill: "#DADADA"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 108.913H83.4455L81.9468 106.322L83.4455 103.726H86.443L87.9417 106.322L86.443 108.913Z",
    fill: "#DADADA"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 115.405H83.4455L81.9468 112.81L83.4455 110.214H86.443L87.9417 112.81L86.443 115.405Z",
    fill: "#DADADA"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 121.891H83.4455L81.9468 119.296L83.4455 116.7H86.443L87.9417 119.296L86.443 121.891Z",
    fill: "#DADADA"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 128.378H83.4455L81.9468 125.783L83.4455 123.187H86.443L87.9417 125.783L86.443 128.378Z",
    fill: "#DADADA"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 134.865H83.4455L81.9468 132.269L83.4455 129.674H86.443L87.9417 132.269L86.443 134.865Z",
    fill: "#DADADA"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 141.352H83.4455L81.9468 138.756L83.4455 136.161H86.443L87.9417 138.756L86.443 141.352Z",
    fill: "#DADADA"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 147.839H83.4455L81.9468 145.244L83.4455 142.648H86.443L87.9417 145.244L86.443 147.839Z",
    fill: "#DADADA"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 154.326H83.4455L81.9468 151.73L83.4455 149.135H86.443L87.9417 151.73L86.443 154.326Z",
    fill: "#DADADA"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 160.813H83.4455L81.9468 158.218L83.4455 155.622H86.443L87.9417 158.218L86.443 160.813Z",
    fill: "#DADADA"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3492 167.137H83.5412L82.1372 164.705L83.5412 162.273H86.3492L87.7575 164.705L86.3492 167.137Z",
    fill: "#DADADA"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M158.309 343.598H157.745L157.46 343.107L157.745 342.62H158.309L158.589 343.107L158.309 343.598Z",
    fill: "#DADADA"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 287.315H516.304L514.806 284.719L516.304 282.124H519.302L520.801 284.719L519.302 287.315Z",
    fill: "#DADADA"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 274.341H516.304L514.806 271.746L516.304 269.15H519.302L520.801 271.746L519.302 274.341Z",
    fill: "#DADADA"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 261.368H516.304L514.806 258.772L516.304 256.176H519.302L520.801 258.772L519.302 261.368Z",
    fill: "#DADADA"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 254.881H516.304L514.806 252.285L516.304 249.689H519.302L520.801 252.285L519.302 254.881Z",
    fill: "#DADADA"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M518.252 246.573H517.361L516.913 245.798L517.361 245.023H518.252L518.7 245.798L518.252 246.573Z",
    fill: "#DADADA"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M519.259 196.412H516.352L514.901 193.898L516.352 191.384H519.259L520.711 193.898L519.259 196.412Z",
    fill: "#DADADA"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M518.928 150.43H516.685L515.561 148.489L516.685 146.543H518.928L520.052 148.489L518.928 150.43Z",
    fill: "#DADADA"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M518.037 142.398H517.576L517.348 142.002L517.576 141.602H518.037L518.265 142.002L518.037 142.398Z",
    fill: "#DADADA"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M519.22 124.991H516.386L514.974 122.537L516.386 120.088H519.22L520.637 122.537L519.22 124.991Z",
    fill: "#DADADA"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 118.646H516.304L514.806 116.05L516.304 113.455H519.302L520.801 116.05L519.302 118.646Z",
    fill: "#DADADA"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M519.263 99.1123H516.348L514.888 96.5899L516.348 94.0674H519.263L520.719 96.5899L519.263 99.1123Z",
    fill: "#DADADA"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M518.785 91.8029H516.821L515.844 90.1026L516.821 88.4023H518.785L519.767 90.1026L518.785 91.8029Z",
    fill: "#DADADA"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 86.2108H516.304L514.806 83.6152L516.304 81.0195H519.302L520.801 83.6152L519.302 86.2108Z",
    fill: "#DADADA"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 79.7245H516.304L514.806 77.1288L516.304 74.5332H519.302L520.801 77.1288L519.302 79.7245Z",
    fill: "#DADADA"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 73.2334H516.304L514.806 70.642L516.304 68.0464H519.302L520.801 70.642L519.302 73.2334Z",
    fill: "#DADADA"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 66.7461H516.304L514.806 64.1547L516.304 61.5591H519.302L520.801 64.1547L519.302 66.7461Z",
    fill: "#DADADA"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 60.2588H516.304L514.806 57.6674L516.304 55.0718H519.302L520.801 57.6674L519.302 60.2588Z",
    fill: "#DADADA"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 53.7724H516.304L514.806 51.1768L516.304 48.5854H519.302L520.801 51.1768L519.302 53.7724Z",
    fill: "#DADADA"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 47.2855H516.304L514.806 44.6899L516.304 42.0942H519.302L520.801 44.6899L519.302 47.2855Z",
    fill: "#DADADA"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 44.0438H510.684L509.186 41.4482L510.684 38.8525H513.682L515.181 41.4482L513.682 44.0438Z",
    fill: "#DADADA"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M507.303 39.4854H505.821L505.081 38.2027L505.821 36.9199H507.303L508.044 38.2027L507.303 39.4854Z",
    fill: "#DADADA"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M147.041 6.21611H146.524L146.266 5.76821L146.524 5.32031H147.041L147.299 5.76821L147.041 6.21611Z",
    fill: "#DADADA"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M141.416 9.44848H140.908L140.658 9.0092L140.908 8.57422H141.416L141.666 9.0092L141.416 9.44848Z",
    fill: "#DADADA"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M113.626 26.2142H112.485L111.912 25.2284L112.485 24.2427H113.626L114.195 25.2284L113.626 26.2142Z",
    fill: "#DADADA"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M107.795 29.1037H107.067L106.705 28.4749L107.067 27.8418H107.795L108.161 28.4749L107.795 29.1037Z",
    fill: "#DADADA"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M102.462 32.8478H101.157L100.507 31.7157L101.157 30.5879H102.462L103.117 31.7157L102.462 32.8478Z",
    fill: "#DADADA"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6257 37.4445H94.7574L93.3232 34.9608L94.7574 32.4771H97.6257L99.0598 34.9608L97.6257 37.4445Z",
    fill: "#DADADA"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0646 40.7982H89.0671L87.5684 38.2026L89.0671 35.6069H92.0646L93.5676 38.2026L92.0646 40.7982Z",
    fill: "#DADADA"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M86.443 44.0438H83.4455L81.9468 41.4482L83.4455 38.8525H86.443L87.9417 41.4482L86.443 44.0438Z",
    fill: "#DADADA"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1939 52.6832H78.4539L77.584 51.1766L78.4539 49.6743H80.1939L81.0638 51.1766L80.1939 52.6832Z",
    fill: "#DADADA"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 60.2588H77.8254L76.3267 57.6674L77.8254 55.0718H80.8229L82.3216 57.6674L80.8229 60.2588Z",
    fill: "#DADADA"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 66.7461H77.8254L76.3267 64.1547L77.8254 61.5591H80.8229L82.3216 64.1547L80.8229 66.7461Z",
    fill: "#DADADA"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 73.2334H77.8254L76.3267 70.642L77.8254 68.0464H80.8229L82.3216 70.642L80.8229 73.2334Z",
    fill: "#DADADA"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 79.7245H77.8254L76.3267 77.1288L77.8254 74.5332H80.8229L82.3216 77.1288L80.8229 79.7245Z",
    fill: "#DADADA"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 86.2108H77.8254L76.3267 83.6152L77.8254 81.0195H80.8229L82.3216 83.6152L80.8229 86.2108Z",
    fill: "#DADADA"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 92.6981H77.8254L76.3267 90.1025L77.8254 87.5068H80.8229L82.3216 90.1025L80.8229 92.6981Z",
    fill: "#DADADA"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 99.1849H77.8254L76.3267 96.5893L77.8254 93.9937H80.8229L82.3216 96.5893L80.8229 99.1849Z",
    fill: "#DADADA"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 105.672H77.8254L76.3267 103.076L77.8254 100.48H80.8229L82.3216 103.076L80.8229 105.672Z",
    fill: "#DADADA"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 112.159H77.8254L76.3267 109.563L77.8254 106.967H80.8229L82.3216 109.563L80.8229 112.159Z",
    fill: "#DADADA"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 118.646H77.8254L76.3267 116.05L77.8254 113.455H80.8229L82.3216 116.05L80.8229 118.646Z",
    fill: "#DADADA"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 125.133H77.8254L76.3267 122.537L77.8254 119.941H80.8229L82.3216 122.537L80.8229 125.133Z",
    fill: "#DADADA"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 131.621H77.8254L76.3267 129.025L77.8254 126.434H80.8229L82.3216 129.025L80.8229 131.621Z",
    fill: "#DADADA"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 138.106H77.8254L76.3267 135.511L77.8254 132.919H80.8229L82.3216 135.511L80.8229 138.106Z",
    fill: "#DADADA"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 144.593H77.8254L76.3267 142.002L77.8254 139.406H80.8229L82.3216 142.002L80.8229 144.593Z",
    fill: "#DADADA"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8229 151.085H77.8254L76.3267 148.489L77.8254 145.894H80.8229L82.3216 148.489L80.8229 151.085Z",
    fill: "#DADADA"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7884 157.507H77.8598L76.3955 154.976L77.8598 152.44H80.7884L82.2527 154.976L80.7884 157.507Z",
    fill: "#DADADA"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6112 163.688H78.0358L76.748 161.463L78.0358 159.233H80.6112L81.8989 161.463L80.6112 163.688Z",
    fill: "#DADADA"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4309 169.861H78.2173L77.1147 167.95L78.2173 166.034H80.4309L81.5335 167.95L80.4309 169.861Z",
    fill: "#DADADA"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M524.002 295.45H522.852L522.275 294.452L522.852 293.453H524.002L524.579 294.452L524.002 295.45Z",
    fill: "#DADADA"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 290.561H521.93L520.431 287.966L521.93 285.37H524.927L526.426 287.966L524.927 290.561Z",
    fill: "#DADADA"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 284.074H521.93L520.431 281.478L521.93 278.882H524.927L526.426 281.478L524.927 284.074Z",
    fill: "#DADADA"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 258.122H521.93L520.431 255.53L521.93 252.935H524.927L526.426 255.53L524.927 258.122Z",
    fill: "#DADADA"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 251.634H521.93L520.431 249.039L521.93 246.447H524.927L526.426 249.039L524.927 251.634Z",
    fill: "#DADADA"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M524.127 243.766H522.727L522.03 242.552L522.727 241.343H524.127L524.829 242.552L524.127 243.766Z",
    fill: "#DADADA"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M524.26 224.537H522.594L521.758 223.091L522.594 221.645H524.26L525.096 223.091L524.26 224.537Z",
    fill: "#DADADA"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M524.854 219.079H521.999L520.569 216.604L521.999 214.133H524.854L526.284 216.604L524.854 219.079Z",
    fill: "#DADADA"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M524.82 147.655H522.034L520.643 145.244L522.034 142.833H524.82L526.215 145.244L524.82 147.655Z",
    fill: "#DADADA"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M523.708 119.783H523.144L522.864 119.296L523.144 118.805H523.708L523.993 119.296L523.708 119.783Z",
    fill: "#DADADA"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 108.913H521.93L520.431 106.322L521.93 103.726H524.927L526.426 106.322L524.927 108.913Z",
    fill: "#DADADA"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M524.067 94.4551H522.788L522.146 93.3446L522.788 92.2383H524.067L524.708 93.3446L524.067 94.4551Z",
    fill: "#DADADA"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M524.872 82.8748H521.982L520.535 80.3696L521.982 77.8687H524.872L526.319 80.3696L524.872 82.8748Z",
    fill: "#DADADA"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 76.4784H521.93L520.431 73.8827L521.93 71.2871H524.927L526.426 73.8827L524.927 76.4784Z",
    fill: "#DADADA"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 69.9911H521.93L520.431 67.3955L521.93 64.7998H524.927L526.426 67.3955L524.927 69.9911Z",
    fill: "#DADADA"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 63.5048H521.93L520.431 60.9091L521.93 58.3135H524.927L526.426 60.9091L524.927 63.5048Z",
    fill: "#DADADA"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 57.0179H521.93L520.431 54.4223L521.93 51.8267H524.927L526.426 54.4223L524.927 57.0179Z",
    fill: "#DADADA"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M524.927 50.5306H521.93L520.431 47.935L521.93 45.3394H524.927L526.426 47.935L524.927 50.5306Z",
    fill: "#DADADA"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M507.897 34.0274H505.227L503.892 31.7158L505.227 29.4043H507.897L509.232 31.7158L507.897 34.0274Z",
    fill: "#DADADA"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M502.13 30.5273H499.753L498.568 28.4741L499.753 26.4165H502.13L503.314 28.4741L502.13 30.5273Z",
    fill: "#DADADA"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M91.104 32.6415H90.0316L89.4976 31.716L90.0316 30.7905H91.104L91.638 31.716L91.104 32.6415Z",
    fill: "#DADADA"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6991 36.2615H84.1918L83.4424 34.9615L84.1918 33.6572H85.6991L86.4528 34.9615L85.6991 36.2615Z",
    fill: "#DADADA"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 57.0179H72.2048L70.7061 54.4223L72.2048 51.8267H75.2023L76.701 54.4223L75.2023 57.0179Z",
    fill: "#DADADA"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 63.5048H72.2048L70.7061 60.9091L72.2048 58.3135H75.2023L76.701 60.9091L75.2023 63.5048Z",
    fill: "#DADADA"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 69.9911H72.2048L70.7061 67.3955L72.2048 64.7998H75.2023L76.701 67.3955L75.2023 69.9911Z",
    fill: "#DADADA"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 76.4784H72.2048L70.7061 73.8827L72.2048 71.2871H75.2023L76.701 73.8827L75.2023 76.4784Z",
    fill: "#DADADA"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 82.9657H72.2048L70.7061 80.3701L72.2048 77.7744H75.2023L76.701 80.3701L75.2023 82.9657Z",
    fill: "#DADADA"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 89.4525H72.2048L70.7061 86.8569L72.2048 84.2612H75.2023L76.701 86.8569L75.2023 89.4525Z",
    fill: "#DADADA"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 95.9394H72.2048L70.7061 93.3438L72.2048 90.7524H75.2023L76.701 93.3438L75.2023 95.9394Z",
    fill: "#DADADA"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 102.427H72.2048L70.7061 99.8354L72.2048 97.2397H75.2023L76.701 99.8354L75.2023 102.427Z",
    fill: "#DADADA"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 108.913H72.2048L70.7061 106.322L72.2048 103.726H75.2023L76.701 106.322L75.2023 108.913Z",
    fill: "#DADADA"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 115.405H72.2048L70.7061 112.81L72.2048 110.214H75.2023L76.701 112.81L75.2023 115.405Z",
    fill: "#DADADA"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 121.891H72.2048L70.7061 119.296L72.2048 116.7H75.2023L76.701 119.296L75.2023 121.891Z",
    fill: "#DADADA"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 128.378H72.2048L70.7061 125.783L72.2048 123.187H75.2023L76.701 125.783L75.2023 128.378Z",
    fill: "#DADADA"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 134.865H72.2048L70.7061 132.269L72.2048 129.674H75.2023L76.701 132.269L75.2023 134.865Z",
    fill: "#DADADA"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 141.352H72.2048L70.7061 138.756L72.2048 136.161H75.2023L76.701 138.756L75.2023 141.352Z",
    fill: "#DADADA"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 147.839H72.2048L70.7061 145.244L72.2048 142.648H75.2023L76.701 145.244L75.2023 147.839Z",
    fill: "#DADADA"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2023 154.326H72.2048L70.7061 151.73L72.2048 149.135H75.2023L76.701 151.73L75.2023 154.326Z",
    fill: "#DADADA"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1069 160.649H72.2989L70.8906 158.217L72.2989 155.785H75.1069L76.5109 158.217L75.1069 160.649Z",
    fill: "#DADADA"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M529.468 298.417H528.633L528.215 297.698L528.633 296.975H529.468L529.886 297.698L529.468 298.417Z",
    fill: "#DADADA"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 293.802H527.551L526.053 291.207L527.551 288.615H530.549L532.048 291.207L530.549 293.802Z",
    fill: "#DADADA"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 287.315H527.551L526.053 284.719L527.551 282.124H530.549L532.048 284.719L530.549 287.315Z",
    fill: "#DADADA"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 280.827H527.551L526.053 278.231L527.551 275.636H530.549L532.048 278.231L530.549 280.827Z",
    fill: "#DADADA"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 254.881H527.551L526.053 252.285L527.551 249.689H530.549L532.048 252.285L530.549 254.881Z",
    fill: "#DADADA"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 248.394H527.551L526.053 245.798L527.551 243.203H530.549L532.048 245.798L530.549 248.394Z",
    fill: "#DADADA"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 144.593H527.551L526.053 142.002L527.551 139.406H530.549L532.048 142.002L530.549 144.593Z",
    fill: "#DADADA"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M529.83 123.893H528.266L527.487 122.537L528.266 121.186H529.83L530.613 122.537L529.83 123.893Z",
    fill: "#DADADA"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M529.519 110.377H528.58L528.106 109.563L528.58 108.75H529.519L529.988 109.563L529.519 110.377Z",
    fill: "#DADADA"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M513.682 108.913H510.684L509.186 106.322L510.684 103.726H513.682L515.181 106.322L513.682 108.913Z",
    fill: "#DADADA"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 112.159H516.304L514.806 109.563L516.304 106.967H519.302L520.801 109.563L519.302 112.159Z",
    fill: "#DADADA"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M519.302 105.672H516.304L514.806 103.076L516.304 100.48H519.302L520.801 103.076L519.302 105.672Z",
    fill: "#DADADA"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M524.914 115.383H521.938L520.453 112.809L521.938 110.235H524.914L526.4 112.809L524.914 115.383Z",
    fill: "#DADADA"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M524.911 102.396H521.948L520.466 99.835L521.948 97.2695H524.911L526.388 99.835L524.911 102.396Z",
    fill: "#DADADA"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M530.015 104.747H528.086L527.121 103.077L528.086 101.407H530.015L530.98 103.077L530.015 104.747Z",
    fill: "#DADADA"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M530.183 98.5517H527.913L526.78 96.5889L527.913 94.626H530.183L531.32 96.5889L530.183 98.5517Z",
    fill: "#DADADA"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 79.7245H527.551L526.053 77.1288L527.551 74.5332H530.549L532.048 77.1288L530.549 79.7245Z",
    fill: "#DADADA"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 73.2334H527.551L526.053 70.642L527.551 68.0464H530.549L532.048 70.642L530.549 73.2334Z",
    fill: "#DADADA"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 66.7461H527.551L526.053 64.1547L527.551 61.5591H530.549L532.048 64.1547L530.549 66.7461Z",
    fill: "#DADADA"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 53.7724H527.551L526.053 51.1768L527.551 48.5854H530.549L532.048 51.1768L530.549 53.7724Z",
    fill: "#DADADA"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M529.437 45.3618H528.662L528.274 44.6899L528.662 44.0181H529.437L529.825 44.6899L529.437 45.3618Z",
    fill: "#DADADA"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0525 52.8551H67.1101L66.1411 51.1763L67.1101 49.4976H69.0525L70.0215 51.1763L69.0525 52.8551Z",
    fill: "#DADADA"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 60.2588H66.5842L65.0854 57.6674L66.5842 55.0718H69.5817L71.0804 57.6674L69.5817 60.2588Z",
    fill: "#DADADA"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 66.7461H66.5842L65.0854 64.1547L66.5842 61.5591H69.5817L71.0804 64.1547L69.5817 66.7461Z",
    fill: "#DADADA"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 73.2334H66.5842L65.0854 70.642L66.5842 68.0464H69.5817L71.0804 70.642L69.5817 73.2334Z",
    fill: "#DADADA"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 79.7245H66.5842L65.0854 77.1288L66.5842 74.5332H69.5817L71.0804 77.1288L69.5817 79.7245Z",
    fill: "#DADADA"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 86.2108H66.5842L65.0854 83.6152L66.5842 81.0195H69.5817L71.0804 83.6152L69.5817 86.2108Z",
    fill: "#DADADA"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 92.6981H66.5842L65.0854 90.1025L66.5842 87.5068H69.5817L71.0804 90.1025L69.5817 92.6981Z",
    fill: "#DADADA"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 99.1849H66.5842L65.0854 96.5893L66.5842 93.9937H69.5817L71.0804 96.5893L69.5817 99.1849Z",
    fill: "#DADADA"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 105.672H66.5842L65.0854 103.076L66.5842 100.48H69.5817L71.0804 103.076L69.5817 105.672Z",
    fill: "#DADADA"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 112.159H66.5842L65.0854 109.563L66.5842 106.967H69.5817L71.0804 109.563L69.5817 112.159Z",
    fill: "#DADADA"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 118.646H66.5842L65.0854 116.05L66.5842 113.455H69.5817L71.0804 116.05L69.5817 118.646Z",
    fill: "#DADADA"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 125.133H66.5842L65.0854 122.537L66.5842 119.941H69.5817L71.0804 122.537L69.5817 125.133Z",
    fill: "#DADADA"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 131.621H66.5842L65.0854 129.025L66.5842 126.434H69.5817L71.0804 129.025L69.5817 131.621Z",
    fill: "#DADADA"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 138.106H66.5842L65.0854 135.511L66.5842 132.919H69.5817L71.0804 135.511L69.5817 138.106Z",
    fill: "#DADADA"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5817 144.593H66.5842L65.0854 142.002L66.5842 139.406H69.5817L71.0804 142.002L69.5817 144.593Z",
    fill: "#DADADA"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5394 149.281H67.622L67.1655 148.489L67.622 147.693H68.5394L69.0002 148.489L68.5394 149.281Z",
    fill: "#DADADA"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M535.61 309.054H533.732L532.789 307.426L533.732 305.799H535.61L536.553 307.426L535.61 309.054Z",
    fill: "#DADADA"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 303.535H533.172L531.673 300.939L533.172 298.344H536.17L537.668 300.939L536.17 303.535Z",
    fill: "#DADADA"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 297.048H533.172L531.673 294.452L533.172 291.856H536.17L537.668 294.452L536.17 297.048Z",
    fill: "#DADADA"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 290.561H533.172L531.673 287.966L533.172 285.37H536.17L537.668 287.966L536.17 290.561Z",
    fill: "#DADADA"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 284.074H533.172L531.673 281.478L533.172 278.882H536.17L537.668 281.478L536.17 284.074Z",
    fill: "#DADADA"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 277.587H533.172L531.673 274.992L533.172 272.396H536.17L537.668 274.992L536.17 277.587Z",
    fill: "#DADADA"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 271.096H533.172L531.673 268.504L533.172 265.909H536.17L537.668 268.504L536.17 271.096Z",
    fill: "#DADADA"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 264.608H533.172L531.673 262.017L533.172 259.421H536.17L537.668 262.017L536.17 264.608Z",
    fill: "#DADADA"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 258.122H533.172L531.673 255.53L533.172 252.935H536.17L537.668 255.53L536.17 258.122Z",
    fill: "#DADADA"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M535.028 230.198H534.313L533.951 229.578L534.313 228.958H535.028L535.39 229.578L535.028 230.198Z",
    fill: "#DADADA"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 225.687H533.172L531.673 223.091L533.172 220.496H536.17L537.668 223.091L536.17 225.687Z",
    fill: "#DADADA"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M535.997 141.056H533.344L532.014 138.757L533.344 136.458H535.997L537.328 138.757L535.997 141.056Z",
    fill: "#DADADA"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M535.541 133.776H533.801L532.931 132.269L533.801 130.763H535.541L536.411 132.269L535.541 133.776Z",
    fill: "#DADADA"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M535.188 126.678H534.154L533.637 125.783L534.154 124.887H535.188L535.704 125.783L535.188 126.678Z",
    fill: "#DADADA"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M536.015 121.625H533.323L531.979 119.296L533.323 116.963H536.015L537.363 119.296L536.015 121.625Z",
    fill: "#DADADA"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M535.287 107.39H534.055L533.435 106.322L534.055 105.25H535.287L535.907 106.322L535.287 107.39Z",
    fill: "#DADADA"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M536.117 82.8748H533.223L531.776 80.3696L533.223 77.8687H536.117L537.564 80.3696L536.117 82.8748Z",
    fill: "#DADADA"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 76.4784H533.172L531.673 73.8827L533.172 71.2871H536.17L537.668 73.8827L536.17 76.4784Z",
    fill: "#DADADA"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 69.9911H533.172L531.673 67.3955L533.172 64.7998H536.17L537.668 67.3955L536.17 69.9911Z",
    fill: "#DADADA"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 63.5048H533.172L531.673 60.9091L533.172 58.3135H536.17L537.668 60.9091L536.17 63.5048Z",
    fill: "#DADADA"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 57.0179H533.172L531.673 54.4223L533.172 51.8267H536.17L537.668 54.4223L536.17 57.0179Z",
    fill: "#DADADA"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M536.17 50.5306H533.172L531.673 47.935L533.172 45.3394H536.17L537.668 47.935L536.17 50.5306Z",
    fill: "#DADADA"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 57.0179H60.9588L59.4644 54.4223L60.9588 51.8267H63.9606L65.4593 54.4223L63.9606 57.0179Z",
    fill: "#DADADA"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 63.5048H60.9588L59.4644 60.9091L60.9588 58.3135H63.9606L65.4593 60.9091L63.9606 63.5048Z",
    fill: "#DADADA"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 69.9911H60.9588L59.4644 67.3955L60.9588 64.7998H63.9606L65.4593 67.3955L63.9606 69.9911Z",
    fill: "#DADADA"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 76.4784H60.9588L59.4644 73.8827L60.9588 71.2871H63.9606L65.4593 73.8827L63.9606 76.4784Z",
    fill: "#DADADA"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 82.9657H60.9588L59.4644 80.3701L60.9588 77.7744H63.9606L65.4593 80.3701L63.9606 82.9657Z",
    fill: "#DADADA"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9606 89.4525H60.9588L59.4644 86.8569L60.9588 84.2612H63.9606L65.4593 86.8569L63.9606 89.4525Z",
    fill: "#DADADA"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8872 95.819H61.0319L59.6021 93.3439L61.0319 90.873H63.8872L65.3171 93.3439L63.8872 95.819Z",
    fill: "#DADADA"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5513 101.725H61.3678L60.2739 99.8349L61.3678 97.9409H63.5513L64.6452 99.8349L63.5513 101.725Z",
    fill: "#DADADA"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 107.256H61.9191L61.3765 106.322L61.9191 105.384H63.0001L63.5427 106.322L63.0001 107.256Z",
    fill: "#DADADA"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7853 113.369H62.135L61.812 112.809L62.135 112.249H62.7853L63.1083 112.809L62.7853 113.369Z",
    fill: "#DADADA"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9487 120.14H61.971L61.4844 119.296L61.971 118.453H62.9487L63.4353 119.296L62.9487 120.14Z",
    fill: "#DADADA"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 126.717H61.9191L61.3765 125.783L61.9191 124.845H63.0001L63.5427 125.783L63.0001 126.717Z",
    fill: "#DADADA"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5473 134.15H61.3724L60.2871 132.269L61.3724 130.388H63.5473L64.6326 132.269L63.5473 134.15Z",
    fill: "#DADADA"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0001 139.69H61.9191L61.3765 138.756L61.9191 137.822H63.0001L63.5427 138.756L63.0001 139.69Z",
    fill: "#DADADA"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M541.786 313.255H538.797L537.307 310.672L538.797 308.085H541.786L543.28 310.672L541.786 313.255Z",
    fill: "#DADADA"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M541.028 305.454H539.555L538.823 304.184L539.555 302.91H541.028L541.76 304.184L541.028 305.454Z",
    fill: "#DADADA"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 300.29H538.793L537.294 297.698L538.793 295.103H541.79L543.289 297.698L541.79 300.29Z",
    fill: "#DADADA"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 293.802H538.793L537.294 291.207L538.793 288.615H541.79L543.289 291.207L541.79 293.802Z",
    fill: "#DADADA"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 287.315H538.793L537.294 284.719L538.793 282.124H541.79L543.289 284.719L541.79 287.315Z",
    fill: "#DADADA"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 280.827H538.793L537.294 278.231L538.793 275.636H541.79L543.289 278.231L541.79 280.827Z",
    fill: "#DADADA"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 274.341H538.793L537.294 271.746L538.793 269.15H541.79L543.289 271.746L541.79 274.341Z",
    fill: "#DADADA"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 267.854H538.793L537.294 265.259L538.793 262.663H541.79L543.289 265.259L541.79 267.854Z",
    fill: "#DADADA"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 261.368H538.793L537.294 258.772L538.793 256.176H541.79L543.289 258.772L541.79 261.368Z",
    fill: "#DADADA"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M540.886 253.313H539.697L539.103 252.285L539.697 251.256H540.886L541.48 252.285L540.886 253.313Z",
    fill: "#DADADA"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M541.742 235.338H538.84L537.388 232.824L538.84 230.31H541.742L543.194 232.824L541.742 235.338Z",
    fill: "#DADADA"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 228.929H538.793L537.294 226.337L538.793 223.742H541.79L543.289 226.337L541.79 228.929Z",
    fill: "#DADADA"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M540.648 220.471H539.933L539.576 219.851L539.933 219.227H540.648L541.01 219.851L540.648 220.471Z",
    fill: "#DADADA"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M541.24 85.2509H539.345L538.402 83.6151L539.345 81.9751H541.24L542.187 83.6151L541.24 85.2509Z",
    fill: "#DADADA"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 79.7245H538.793L537.294 77.1288L538.793 74.5332H541.79L543.289 77.1288L541.79 79.7245Z",
    fill: "#DADADA"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 73.2334H538.793L537.294 70.642L538.793 68.0464H541.79L543.289 70.642L541.79 73.2334Z",
    fill: "#DADADA"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 66.7461H538.793L537.294 64.1547L538.793 61.5591H541.79L543.289 64.1547L541.79 66.7461Z",
    fill: "#DADADA"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M541.79 60.2588H538.793L537.294 57.6674L538.793 55.0718H541.79L543.289 57.6674L541.79 60.2588Z",
    fill: "#DADADA"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M541.76 53.7203H538.823L537.354 51.1763L538.823 48.6323H541.76L543.233 51.1763L541.76 53.7203Z",
    fill: "#DADADA"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9137 53.0408H55.7647L54.688 51.1769L55.7647 49.3174H57.9137L58.9904 51.1769L57.9137 53.0408Z",
    fill: "#DADADA"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 60.2588H55.3371L53.8384 57.6674L55.3371 55.0718H58.3346L59.8376 57.6674L58.3346 60.2588Z",
    fill: "#DADADA"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 66.7461H55.3371L53.8384 64.1547L55.3371 61.5591H58.3346L59.8376 64.1547L58.3346 66.7461Z",
    fill: "#DADADA"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 73.2334H55.3371L53.8384 70.642L55.3371 68.0464H58.3346L59.8376 70.642L58.3346 73.2334Z",
    fill: "#DADADA"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 79.7245H55.3371L53.8384 77.1288L55.3371 74.5332H58.3346L59.8376 77.1288L58.3346 79.7245Z",
    fill: "#DADADA"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3346 86.2108H55.3371L53.8384 83.6152L55.3371 81.0195H58.3346L59.8376 83.6152L58.3346 86.2108Z",
    fill: "#DADADA"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0121 92.1385H55.6606L54.4849 90.1025L55.6606 88.0664H58.0121L59.1878 90.1025L58.0121 92.1385Z",
    fill: "#DADADA"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M546.261 308.029H545.568L545.219 307.426L545.568 306.828H546.261L546.606 307.426L546.261 308.029Z",
    fill: "#DADADA"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M547.328 303.393H544.495L543.078 300.939L544.495 298.485H547.328L548.745 300.939L547.328 303.393Z",
    fill: "#DADADA"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 297.048H544.413L542.915 294.452L544.413 291.856H547.411L548.91 294.452L547.411 297.048Z",
    fill: "#18A7B9"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 290.561H544.413L542.915 287.966L544.413 285.37H547.411L548.91 287.966L547.411 290.561Z",
    fill: "#DADADA"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 284.074H544.413L542.915 281.478L544.413 278.882H547.411L548.91 281.478L547.411 284.074Z",
    fill: "#DADADA"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 277.587H544.413L542.915 274.992L544.413 272.396H547.411L548.91 274.992L547.411 277.587Z",
    fill: "#DADADA"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 271.096H544.413L542.915 268.504L544.413 265.909H547.411L548.91 268.504L547.411 271.096Z",
    fill: "#DADADA"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 264.608H544.413L542.915 262.017L544.413 259.421H547.411L548.91 262.017L547.411 264.608Z",
    fill: "#DADADA"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 258.122H544.413L542.915 255.53L544.413 252.935H547.411L548.91 255.53L547.411 258.122Z",
    fill: "#DADADA"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M547.256 251.36H544.573L543.233 249.039L544.573 246.719H547.256L548.595 249.039L547.256 251.36Z",
    fill: "#DADADA"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M546.404 243.4H545.426L544.939 242.552L545.426 241.708H546.404L546.89 242.552L546.404 243.4Z",
    fill: "#DADADA"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M547.294 238.459H544.534L543.151 236.066L544.534 233.677H547.294L548.677 236.066L547.294 238.459Z",
    fill: "#DADADA"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 232.175H544.413L542.915 229.579L544.413 226.983H547.411L548.91 229.579L547.411 232.175Z",
    fill: "#DADADA"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M547.406 76.47H544.421L542.927 73.883L544.421 71.3003H547.406L548.9 73.883L547.406 76.47Z",
    fill: "#DADADA"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 69.9911H544.413L542.915 67.3955L544.413 64.7998H547.411L548.91 67.3955L547.411 69.9911Z",
    fill: "#DADADA"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 63.5048H544.413L542.915 60.9091L544.413 58.3135H547.411L548.91 60.9091L547.411 63.5048Z",
    fill: "#DADADA"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M547.411 57.0179H544.413L542.915 54.4223L544.413 51.8267H547.411L548.91 54.4223L547.411 57.0179Z",
    fill: "#DADADA"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5008 48.422H50.9366L50.6523 47.9353L50.9366 47.4443H51.5008L51.7807 47.9353L51.5008 48.422Z",
    fill: "#DADADA"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M52.714 57.0179H49.7165L48.2178 54.4223L49.7165 51.8267H52.714L54.2127 54.4223L52.714 57.0179Z",
    fill: "#DADADA"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M52.714 63.5048H49.7165L48.2178 60.9091L49.7165 58.3135H52.714L54.2127 60.9091L52.714 63.5048Z",
    fill: "#DADADA"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M52.714 69.9911H49.7165L48.2178 67.3955L49.7165 64.7998H52.714L54.2127 67.3955L52.714 69.9911Z",
    fill: "#DADADA"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M52.714 76.4784H49.7165L48.2178 73.8827L49.7165 71.2871H52.714L54.2127 73.8827L52.714 76.4784Z",
    fill: "#DADADA"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M52.714 82.9657H49.7165L48.2178 80.3701L49.7165 77.7744H52.714L54.2127 80.3701L52.714 82.9657Z",
    fill: "#DADADA"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2931 88.721H50.1398L49.0674 86.8571L50.1398 84.9976H52.2931L53.3698 86.8571L52.2931 88.721Z",
    fill: "#DADADA"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M552.432 299.251H550.636L549.736 297.697L550.636 296.139H552.432L553.332 297.697L552.432 299.251Z",
    fill: "#DADADA"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 293.802H550.033L548.535 291.207L550.033 288.615H553.031L554.534 291.207L553.031 293.802Z",
    fill: "#DADADA"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 287.315H550.033L548.535 284.719L550.033 282.124H553.031L554.534 284.719L553.031 287.315Z",
    fill: "#DADADA"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 280.827H550.033L548.535 278.231L550.033 275.636H553.031L554.534 278.231L553.031 280.827Z",
    fill: "#DADADA"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 274.341H550.033L548.535 271.746L550.033 269.15H553.031L554.534 271.746L553.031 274.341Z",
    fill: "#DADADA"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 267.854H550.033L548.535 265.259L550.033 262.663H553.031L554.534 265.259L553.031 267.854Z",
    fill: "#DADADA"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M552.834 261.018H550.237L548.937 258.771L550.237 256.524H552.834L554.135 258.771L552.834 261.018Z",
    fill: "#DADADA"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M552.993 235.346H550.078L548.618 232.824L550.078 230.297H552.993L554.453 232.824L552.993 235.346Z",
    fill: "#DADADA"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M551.817 103.567H551.253L550.969 103.076L551.253 102.589H551.817L552.101 103.076L551.817 103.567Z",
    fill: "#DADADA"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M552.928 98.9993H550.142L548.751 96.5888L550.142 94.1782H552.928L554.32 96.5888L552.928 98.9993Z",
    fill: "#DADADA"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 92.6981H550.033L548.535 90.1025L550.033 87.5068H553.031L554.534 90.1025L553.031 92.6981Z",
    fill: "#DADADA"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M552.989 86.1298H550.082L548.631 83.6159L550.082 81.1021H552.989L554.441 83.6159L552.989 86.1298Z",
    fill: "#DADADA"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M552.258 78.3812H550.815L550.091 77.1286L550.815 75.876H552.258L552.981 77.1286L552.258 78.3812Z",
    fill: "#DADADA"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 73.2334H550.033L548.535 70.642L550.033 68.0464H553.031L554.534 70.642L553.031 73.2334Z",
    fill: "#DADADA"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 66.7461H550.033L548.535 64.1547L550.033 61.5591H553.031L554.534 64.1547L553.031 66.7461Z",
    fill: "#DADADA"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M553.031 60.2588H550.033L548.535 57.6674L550.033 55.0718H553.031L554.534 57.6674L553.031 60.2588Z",
    fill: "#DADADA"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M552.975 53.6726H550.094L548.656 51.1759L550.094 48.6836H552.975L554.414 51.1759L552.975 53.6726Z",
    fill: "#DADADA"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0944 53.7724H44.0969L42.5981 51.1768L44.0969 48.5854H47.0944L48.5931 51.1768L47.0944 53.7724Z",
    fill: "#DADADA"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0944 60.2588H44.0969L42.5981 57.6674L44.0969 55.0718H47.0944L48.5931 57.6674L47.0944 60.2588Z",
    fill: "#DADADA"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0944 66.7461H44.0969L42.5981 64.1547L44.0969 61.5591H47.0944L48.5931 64.1547L47.0944 66.7461Z",
    fill: "#DADADA"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0944 73.2334H44.0969L42.5981 70.642L44.0969 68.0464H47.0944L48.5931 70.642L47.0944 73.2334Z",
    fill: "#DADADA"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0944 79.7245H44.0969L42.5981 77.1288L44.0969 74.5332H47.0944L48.5931 77.1288L47.0944 79.7245Z",
    fill: "#DADADA"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9831 84.2875H45.2079L44.8203 83.6157L45.2079 82.9438H45.9831L46.3707 83.6157L45.9831 84.2875Z",
    fill: "#DADADA"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M558.295 289.941H556.017L554.876 287.965L556.017 285.989H558.295L559.437 287.965L558.295 289.941Z",
    fill: "#DADADA"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M558.657 284.074H555.659L554.161 281.478L555.659 278.882H558.657L560.156 281.478L558.657 284.074Z",
    fill: "#DADADA"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M558.627 277.535H555.685L554.217 274.991L555.685 272.447H558.627L560.095 274.991L558.627 277.535Z",
    fill: "#DADADA"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M558.144 270.213H556.167L555.181 268.504L556.167 266.791H558.144L559.13 268.504L558.144 270.213Z",
    fill: "#DADADA"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M557.727 237.055H556.586L556.018 236.065L556.586 235.08H557.727L558.296 236.065L557.727 237.055Z",
    fill: "#DADADA"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M558.579 95.8067H555.732L554.311 93.3445L555.732 90.8823H558.579L560 93.3445L558.579 95.8067Z",
    fill: "#DADADA"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M558.619 89.3917H555.694L554.23 86.8563L555.694 84.3252H558.619L560.083 86.8563L558.619 89.3917Z",
    fill: "#DADADA"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M558.639 82.9357H555.676L554.194 80.3702L555.676 77.8047H558.639L560.12 80.3702L558.639 82.9357Z",
    fill: "#DADADA"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M558.657 76.4784H555.659L554.161 73.8827L555.659 71.2871H558.657L560.156 73.8827L558.657 76.4784Z",
    fill: "#DADADA"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M558.657 69.9911H555.659L554.161 67.3955L555.659 64.7998H558.657L560.156 67.3955L558.657 69.9911Z",
    fill: "#DADADA"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M558.657 63.5048H555.659L554.161 60.9091L555.659 58.3135H558.657L560.156 60.9091L558.657 63.5048Z",
    fill: "#DADADA"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M558.657 57.0179H555.659L554.161 54.4223L555.659 51.8267H558.657L560.156 54.4223L558.657 57.0179Z",
    fill: "#DADADA"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M557.817 49.0763H556.499L555.84 47.9356L556.499 46.7949H557.817L558.471 47.9356L557.817 49.0763Z",
    fill: "#DADADA"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7623 49.2994H39.1861L38.3979 47.9349L39.1861 46.5703H40.7623L41.5505 47.9349L40.7623 49.2994Z",
    fill: "#DADADA"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4728 57.0179H38.4753L36.9766 54.4223L38.4753 51.8267H41.4728L42.9715 54.4223L41.4728 57.0179Z",
    fill: "#DADADA"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4728 63.5048H38.4753L36.9766 60.9091L38.4753 58.3135H41.4728L42.9715 60.9091L41.4728 63.5048Z",
    fill: "#DADADA"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4728 69.9911H38.4753L36.9766 67.3955L38.4753 64.7998H41.4728L42.9715 67.3955L41.4728 69.9911Z",
    fill: "#DADADA"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4728 76.4784H38.4753L36.9766 73.8827L38.4753 71.2871H41.4728L42.9715 73.8827L41.4728 76.4784Z",
    fill: "#DADADA"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4728 82.9657H38.4753L36.9766 80.3701L38.4753 77.7744H41.4728L42.9715 80.3701L41.4728 82.9657Z",
    fill: "#DADADA"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M563.331 266.214H562.228L561.673 265.258L562.228 264.303H563.331L563.882 265.258L563.331 266.214Z",
    fill: "#DADADA"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M563.166 259.444H562.391L562.003 258.772L562.391 258.1H563.166L563.554 258.772L563.166 259.444Z",
    fill: "#DADADA"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M564.273 79.7113H561.284L559.79 77.1285L561.284 74.5415H564.273L565.763 77.1285L564.273 79.7113Z",
    fill: "#DADADA"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M564.278 73.2334H561.28L559.782 70.642L561.28 68.0464H564.278L565.777 70.642L564.278 73.2334Z",
    fill: "#DADADA"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M564.278 66.7461H561.28L559.782 64.1547L561.28 61.5591H564.278L565.777 64.1547L564.278 66.7461Z",
    fill: "#DADADA"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M564.278 60.2588H561.28L559.782 57.6674L561.28 55.0718H564.278L565.777 57.6674L564.278 60.2588Z",
    fill: "#DADADA"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M564.273 53.7635H561.284L559.79 51.1765L561.284 48.5938H564.273L565.763 51.1765L564.273 53.7635Z",
    fill: "#DADADA"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6981 45.2919H34.0047L33.6602 44.689L34.0047 44.0903H34.6981L35.0469 44.689L34.6981 45.2919Z",
    fill: "#DADADA"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 53.7724H32.8547L31.356 51.1768L32.8547 48.5854H35.8522L37.3509 51.1768L35.8522 53.7724Z",
    fill: "#DADADA"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 60.2588H32.8547L31.356 57.6674L32.8547 55.0718H35.8522L37.3509 57.6674L35.8522 60.2588Z",
    fill: "#DADADA"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 66.7461H32.8547L31.356 64.1547L32.8547 61.5591H35.8522L37.3509 64.1547L35.8522 66.7461Z",
    fill: "#DADADA"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 73.2334H32.8547L31.356 70.642L32.8547 68.0464H35.8522L37.3509 70.642L35.8522 73.2334Z",
    fill: "#DADADA"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 79.7245H32.8547L31.356 77.1288L32.8547 74.5332H35.8522L37.3509 77.1288L35.8522 79.7245Z",
    fill: "#DADADA"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 86.2108H32.8547L31.356 83.6152L32.8547 81.0195H35.8522L37.3509 83.6152L35.8522 86.2108Z",
    fill: "#DADADA"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8522 92.6981H32.8547L31.356 90.1025L32.8547 87.5068H35.8522L37.3509 90.1025L35.8522 92.6981Z",
    fill: "#DADADA"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M568.835 81.1233H567.965L567.53 80.37L567.965 79.6167H568.835L569.27 80.37L568.835 81.1233Z",
    fill: "#DADADA"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M569.899 76.4784H566.901L565.402 73.8827L566.901 71.2871H569.899L571.397 73.8827L569.899 76.4784Z",
    fill: "#DADADA"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M569.899 69.9911H566.901L565.402 67.3955L566.901 64.7998H569.899L571.397 67.3955L569.899 69.9911Z",
    fill: "#DADADA"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M569.899 63.5048H566.901L565.402 60.9091L566.901 58.3135H569.899L571.397 60.9091L569.899 63.5048Z",
    fill: "#DADADA"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M569.899 57.0179H566.901L565.402 54.4223L566.901 51.8267H569.899L571.397 54.4223L569.899 57.0179Z",
    fill: "#DADADA"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0069 50.1435H27.453L26.1782 47.9353L27.453 45.7271H30.0069L31.2817 47.9353L30.0069 50.1435Z",
    fill: "#DADADA"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M30.231 57.0179H27.2292L25.7305 54.4223L27.2292 51.8267H30.231L31.7297 54.4223L30.231 57.0179Z",
    fill: "#DADADA"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M30.231 63.5048H27.2292L25.7305 60.9091L27.2292 58.3135H30.231L31.7297 60.9091L30.231 63.5048Z",
    fill: "#DADADA"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M288.819 167.3H285.822L284.323 164.705L285.822 162.113H288.819L290.318 164.705L288.819 167.3Z",
    fill: "#DADADA"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M316.928 105.672H313.931L312.432 103.076L313.931 100.48H316.928L318.427 103.076L316.928 105.672Z",
    fill: "#DADADA"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M333.795 245.148H330.797L329.298 242.553L330.797 239.961H333.795L335.293 242.553L333.795 245.148Z",
    fill: "#DADADA"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M401.253 128.378H398.256L396.757 125.783L398.256 123.187H401.253L402.752 125.783L401.253 128.378Z",
    fill: "#DADADA"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M198.878 245.148H195.881L194.382 242.553L195.881 239.961H198.878L200.377 242.553L198.878 245.148Z",
    fill: "#DADADA"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M159.528 235.416H156.526L155.027 232.824L156.526 230.229H159.528L161.027 232.824L159.528 235.416Z",
    fill: "#DADADA"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M423.741 50.5306H420.743L419.24 47.935L420.743 45.3394H423.741L425.24 47.935L423.741 50.5306Z",
    fill: "#DADADA"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M198.878 31.0659H195.881L194.382 28.4745L195.881 25.8789H198.878L200.377 28.4745L198.878 31.0659Z",
    fill: "#DADADA"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M479.953 115.405H476.956L475.457 112.81L476.956 110.214H479.953L481.452 112.81L479.953 115.405Z",
    fill: "#DADADA"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M120.168 193.239H117.184L115.689 190.656L117.184 188.069H120.168L121.663 190.656L120.168 193.239Z",
    fill: "#DADADA"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M103.311 125.133H100.314L98.8149 122.538L100.314 119.942H103.311L104.81 122.538L103.311 125.133Z",
    fill: "#DADADA"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M159.528 14.8505H156.526L155.027 12.2548L156.526 9.65918H159.528L161.027 12.2548L159.528 14.8505Z",
    fill: "#DADADA"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0656 92.6986H89.0681L87.5693 90.103L89.0681 87.5073H92.0656L93.5686 90.103L92.0656 92.6986Z",
    fill: "#DADADA"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M530.549 60.2592H527.552L526.053 57.6679L527.552 55.0723H530.549L532.048 57.6679L530.549 60.2592Z",
    fill: "#DADADA"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M30.232 69.9921H27.2302L25.7314 67.3964L27.2302 64.8008H30.232L31.7307 67.3964L30.232 69.9921Z",
    fill: "#DADADA"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M30.231 76.4784H27.2292L25.7305 73.8827L27.2292 71.2871H30.231L31.7297 73.8827L30.231 76.4784Z",
    fill: "#DADADA"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M30.231 82.9657H27.2292L25.7305 80.3701L27.2292 77.7744H30.231L31.7297 80.3701L30.231 82.9657Z",
    fill: "#DADADA"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2088 89.4226H27.2501L25.7686 86.8571L27.2501 84.2959H30.2088L31.6903 86.8571L30.2088 89.4226Z",
    fill: "#DADADA"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1032 95.7154H27.3641L25.9902 93.3436L27.3641 90.9761H30.1032L31.4684 93.3436L30.1032 95.7154Z",
    fill: "#DADADA"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M574.292 324.116H573.749L573.482 323.646L573.749 323.177H574.292L574.563 323.646L574.292 324.116Z",
    fill: "#DADADA"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M575.519 73.2334H572.522L571.023 70.642L572.522 68.0464H575.519L577.018 70.642L575.519 73.2334Z",
    fill: "#DADADA"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M575.519 66.7461H572.522L571.023 64.1547L572.522 61.5591H575.519L577.018 64.1547L575.519 66.7461Z",
    fill: "#DADADA"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M575.519 60.2588H572.522L571.023 57.6674L572.522 55.0718H575.519L577.018 57.6674L575.519 60.2588Z",
    fill: "#DADADA"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M574.369 51.7797H573.676L573.327 51.1768L573.676 50.5781H574.369L574.713 51.1768L574.369 51.7797Z",
    fill: "#DADADA"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 53.7724H21.6086L20.1099 51.1768L21.6086 48.5854H24.6061L26.1048 51.1768L24.6061 53.7724Z",
    fill: "#DADADA"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4249 59.9447H21.7934L20.4756 57.6676L21.7934 55.3862H24.4249L25.7427 57.6676L24.4249 59.9447Z",
    fill: "#DADADA"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 66.7461H21.6086L20.1099 64.1547L21.6086 61.5591H24.6061L26.1048 64.1547L24.6061 66.7461Z",
    fill: "#DADADA"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 73.2334H21.6086L20.1099 70.642L21.6086 68.0464H24.6061L26.1048 70.642L24.6061 73.2334Z",
    fill: "#DADADA"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 79.7245H21.6086L20.1099 77.1288L21.6086 74.5332H24.6061L26.1048 77.1288L24.6061 79.7245Z",
    fill: "#DADADA"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6061 86.2108H21.6086L20.1099 83.6152L21.6086 81.0195H24.6061L26.1048 83.6152L24.6061 86.2108Z",
    fill: "#DADADA"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M24.598 92.677H21.622L20.1362 90.1029L21.622 87.5288H24.598L26.0838 90.1029L24.598 92.677Z",
    fill: "#DADADA"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M581.088 322.905H578.199L576.751 320.4L578.199 317.899H581.088L582.535 320.4L581.088 322.905Z",
    fill: "#DADADA"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M580.136 314.769H579.15L578.655 313.912L579.15 313.06H580.136L580.632 313.912L580.136 314.769Z",
    fill: "#DADADA"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M580.068 74.6139H579.22L578.798 73.8822L579.22 73.1504H580.068L580.49 73.8822L580.068 74.6139Z",
    fill: "#DADADA"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M580.554 68.976H578.732L577.819 67.3963L578.732 65.8208H580.554L581.467 67.3963L580.554 68.976Z",
    fill: "#DADADA"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M581.14 63.5048H578.143L576.644 60.9091L578.143 58.3135H581.14L582.639 60.9091L581.14 63.5048Z",
    fill: "#DADADA"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M580.86 56.5267H578.427L577.208 54.4218L578.427 52.3169H580.86L582.075 54.4218L580.86 56.5267Z",
    fill: "#DADADA"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7538 48.3915H17.224L16.957 47.9349L17.224 47.4741H17.7538L18.0165 47.9349L17.7538 48.3915Z",
    fill: "#DADADA"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1891 55.6316H16.7894L16.0874 54.422L16.7894 53.2124H18.1891L18.8868 54.422L18.1891 55.6316Z",
    fill: "#DADADA"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9639 63.4621H16.0138L14.5366 60.9095L16.0138 58.3569H18.9639L20.4368 60.9095L18.9639 63.4621Z",
    fill: "#DADADA"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 69.4404H16.3064L15.1221 67.3957L16.3064 65.3511H18.6665L19.8509 67.3957L18.6665 69.4404Z",
    fill: "#DADADA"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9855 76.4784H15.988L14.4893 73.8827L15.988 71.2871H18.9855L20.4842 73.8827L18.9855 76.4784Z",
    fill: "#DADADA"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9855 82.9657H15.988L14.4893 80.3701L15.988 77.7744H18.9855L20.4842 80.3701L18.9855 82.9657Z",
    fill: "#DADADA"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9855 89.4525H15.988L14.4893 86.8569L15.988 84.2612H18.9855L20.4842 86.8569L18.9855 89.4525Z",
    fill: "#18A7B9"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9814 95.9315H15.9969L14.5024 93.3444L15.9969 90.7617H18.9814L20.4716 93.3444L18.9814 95.9315Z",
    fill: "#DADADA"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M586.153 318.695H584.375L583.487 317.158L584.375 315.622H586.153L587.04 317.158L586.153 318.695Z",
    fill: "#DADADA"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M586.644 313.06H583.883L582.501 310.671L583.883 308.278H586.644L588.026 310.671L586.644 313.06Z",
    fill: "#DADADA"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M586.304 65.954H584.224L583.182 64.1547L584.224 62.3511H586.304L587.346 64.1547L586.304 65.954Z",
    fill: "#DADADA"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M586.235 59.3467H584.292L583.323 57.6679L584.292 55.9849H586.235L587.204 57.6679L586.235 59.3467Z",
    fill: "#DADADA"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3484 58.4984H11.3837L10.9014 57.6676L11.3837 56.8325H12.3484L12.8308 57.6676L12.3484 58.4984Z",
    fill: "#DADADA"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3644 66.7461H10.3669L8.86816 64.1547L10.3669 61.5591H13.3644L14.8631 64.1547L13.3644 66.7461Z",
    fill: "#DADADA"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1078 71.0601H11.6255L11.3843 70.6424L11.6255 70.2246H12.1078L12.349 70.6424L12.1078 71.0601Z",
    fill: "#DADADA"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3644 79.7245H10.3669L8.86816 77.1288L10.3669 74.5332H13.3644L14.8631 77.1288L13.3644 79.7245Z",
    fill: "#DADADA"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3644 86.2108H10.3669L8.86816 83.6152L10.3669 81.0195H13.3644L14.8631 83.6152L13.3644 86.2108Z",
    fill: "#DADADA"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5426 91.2728H11.1903L10.5142 90.102L11.1903 88.9312H12.5426L13.2188 90.102L12.5426 91.2728Z",
    fill: "#DADADA"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M12.693 98.0231H11.0392L10.208 96.5897L11.0392 95.1562H12.693L13.5242 96.5897L12.693 98.0231Z",
    fill: "#DADADA"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0589 105.143H10.6729L9.47998 103.077L10.6729 101.011H13.0589L14.2518 103.077L13.0589 105.143Z",
    fill: "#DADADA"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M591.185 314.434H590.586L590.285 313.913L590.586 313.396H591.185L591.486 313.913L591.185 314.434Z",
    fill: "#DADADA"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M591.808 309.023H589.961L589.039 307.426L589.961 305.829H591.808L592.73 307.426L591.808 309.023Z",
    fill: "#DADADA"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M591.373 301.783H590.396L589.909 300.939L590.396 300.096H591.373L591.86 300.939L591.373 301.783Z",
    fill: "#DADADA"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M591.714 68.8292H590.056L589.229 67.3958L590.056 65.9624H591.714L592.546 67.3958L591.714 68.8292Z",
    fill: "#DADADA"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M591.757 62.4165H590.017L589.147 60.9099L590.017 59.4033H591.757L592.627 60.9099L591.757 62.4165Z",
    fill: "#DADADA"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18321 62.536H5.30117L4.3623 60.9089L5.30117 59.2817H7.18321L8.12638 60.9089L7.18321 62.536Z",
    fill: "#DADADA"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42028 75.9193H5.0688L3.89307 73.8832L5.0688 71.8472H7.42028L8.59601 73.8832L7.42028 75.9193Z",
    fill: "#DADADA"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74378 82.9657H4.7463L3.24756 80.3701L4.7463 77.7744H7.74378L9.24252 80.3701L7.74378 82.9657Z",
    fill: "#DADADA"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42028 88.893H5.0688L3.89307 86.8569L5.0688 84.8252H7.42028L8.59601 86.8569L7.42028 88.893Z",
    fill: "#DADADA"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57955 100.412H5.9077L5.57178 99.8353L5.9077 99.2539H6.57955L6.91117 99.8353L6.57955 100.412Z",
    fill: "#DADADA"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14918 107.888H5.34036L4.43164 106.321L5.34036 104.754H7.14918L8.0536 106.321L7.14918 107.888Z",
    fill: "#DADADA"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M597.765 306.363H595.25L593.992 304.184L595.25 302.006H597.765L599.022 304.184L597.765 306.363Z",
    fill: "#DADADA"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M597.99 300.259H595.027L593.545 297.698L595.027 295.132H597.99L599.471 297.698L597.99 300.259Z",
    fill: "#DADADA"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M596.801 291.72H596.215L595.918 291.207L596.215 290.699H596.801L597.094 291.207L596.801 291.72Z",
    fill: "#DADADA"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M0.930028 77.6586H0.318474L0.0126953 77.1288L0.318474 76.5991H0.930028L1.23581 77.1288L0.930028 77.6586Z",
    fill: "#DADADA"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M0.934559 103.614H0.310085L0 103.076L0.310085 102.538H0.934559L1.24464 103.076L0.934559 103.614Z",
    fill: "#DADADA"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M0.913015 110.063H0.335913L0.0473633 109.563L0.335913 109.063H0.913015L1.19726 109.563L0.913015 110.063Z",
    fill: "#DADADA"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M602.565 295.205H601.695L601.26 294.452L601.695 293.698H602.565L603 294.452L602.565 295.205Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/MAP.f710ec5454e7f98050451dc33c39735b.svg";
export { ForwardRef as ReactComponent };